webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(66);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueRouter = __webpack_require__(191);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(190);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueKeepScrollPosition = __webpack_require__(173);
	
	var _vueKeepScrollPosition2 = _interopRequireDefault(_vueKeepScrollPosition);
	
	var _vuexRouterSync = __webpack_require__(192);
	
	var _elementUi = __webpack_require__(147);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(161);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(4);
	
	var _velocityAnimate = __webpack_require__(171);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	__webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueKeepScrollPosition2.default);
	
	var VueTouch = __webpack_require__(100);
	_vue2.default.use(VueTouch);
	
	_vue2.default.use(_elementUi2.default);
	
	var App = __webpack_require__(174);
	var Projects = __webpack_require__(180);
	var Page = __webpack_require__(177);
	var Index = __webpack_require__(176);
	var TestTouch = __webpack_require__(181);
	var Clients = __webpack_require__(175);
	
	window.addEventListener("keydown", function (e) {
	    if ([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
	        e.preventDefault();
	    }
	}, false);
	
	var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	    if (savedPosition) {
	        return savedPosition;
	    } else {
	        var position = {};
	
	        if (to.hash) {
	            position.selector = to.hash;
	        }
	
	        if (to.matched.some(function (m) {
	            return m.meta.scrollToTop;
	        })) {
	            position.x = 0;
	            position.y = 0;
	        }
	
	        return position;
	    }
	};
	
	var routes = [{ path: '/testtouchevents', component: TestTouch, name: 'testtouch', meta: { scrollToTop: true } }, { path: '/', component: App, name: 'app', children: [{ path: '/', redirect: { name: 'project', params: { slug: 'startseite' } } }, { path: '/projekte', component: Projects, name: 'projects', meta: { scrollToTop: true } }, { path: '/projekte/:slug', component: Projects, name: 'project', meta: { scrollToTop: true } }, { path: '/projekte/:slug/:index', component: Projects, name: 'project-slide', meta: { scrollToTop: true } }, { path: '/start', component: Projects, name: 'start' }, { path: '/clients', component: Clients, name: 'clients', meta: { scrollToTop: true } }, { path: '/index', component: Index, name: 'index', meta: { scrollToTop: true } }, { path: '/index/client/:clientSlug', component: Index, name: 'index-client', meta: { scrollToTop: true } }, { path: '/index/:category', component: Index, name: 'index-category', meta: { scrollToTop: true } }, { path: '/seite/:pageslug',
	        component: Page,
	        name: 'page',
	        meta: { scrollToTop: true },
	        beforeEnter: function beforeEnter(to, from, next) {
	            console.log('route changed to page' + Date.now());
	            next();
	        }
	    }]
	}];
	
	var router = new _vueRouter2.default({
	    mode: 'history',
	    base: '/',
	    scrollBehavior: scrollBehavior,
	    routes: routes
	});
	
	(0, _vuexRouterSync.sync)(_store2.default, router);
	
	console.log('Loading data');
	
	console.log("Loading config");
	_vue2.default.http.get('/static/config/config.json').then(function (response) {
	    _store2.default.commit('setConfig', response.body.config);
	}, function (response) {
	    console.error("error loading data");
	});
	
	console.log("Loading clients");
	_vue2.default.http.get('/static/clients.json').then(function (response) {
	
	    _store2.default.commit('setClients', response.body.clientCategories);
	}, function (response) {
	    console.error("error loading data");
	});
	
	console.log("Loading categories");
	_vue2.default.http.get('/static/categories.json').then(function (response) {
	    _store2.default.commit('setCategories', response.body.categories);
	}, function (response) {
	    console.error("error loading data");
	});
	
	console.log("Loading projects");
	_vue2.default.http.get('/static/projects-new.json').then(function (response) {
	    _store2.default.commit('setProjects', response.body.projects);
	    var app = new _vue2.default({ router: router }).$mount('#app');
	}, function (response) {
	    console.error("error loading projects");
	});
	
	exports.default = router;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(66);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _getters = __webpack_require__(99);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _actions = __webpack_require__(98);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	    state: {
	        config: {
	            root: "",
	            debug: false,
	            domain: "",
	            defaultLanguage: "",
	            apiurl: ""
	        },
	
	        domElements: {
	            mainApp: "#mainApp",
	            sidebar: "#sidebar",
	            mainContent: "#mainContent"
	        },
	
	        count: 0,
	        ready: false,
	        loaded: false,
	        language: 'de',
	
	        sidebar: {
	            status: 0,
	            expanded: false,
	            hidden: true,
	            widthExpanded: 200,
	            widthCollapsed: 80,
	            widthHidden: 40
	        },
	
	        layout: {
	            height: 100,
	            width: 100,
	            margin: 40,
	            gutter: 20,
	            sidebarWidth: 40,
	            viewportWidth: 0,
	            viewportHeight: 0,
	            galleryHeight: 0,
	            galleryWidth: 0,
	
	            fullscreen: false,
	
	            type: false,
	            ratio: false,
	            orientation: false,
	            breakpointMobile: 800,
	            breakpointTablet: 1024,
	
	            mobileNavigation: false,
	
	            mobileSandwichColumn: 60,
	            mobileGutter: 20,
	            offsetTop: 0,
	            offsetLeft: 0
	        },
	
	        mouse: {
	            last: { x: 0, y: 0 },
	            delataX: 0,
	            deltaY: 0
	        },
	
	        downloadTermsAccepted: false,
	        downloadTermsVisible: false,
	        downloadRequestedImage: false,
	        currentProject: null,
	        projectsScrollLastY: 0,
	        projectsScrollPosition: 0,
	        projectsCurrentIndex: 0,
	        projectsCurrentId: '',
	        projectsCurrentType: '',
	        projectsCurrentInfo: false,
	        projectMove: 0,
	        projectMoveRight: 0,
	        projectMoveLeft: 0,
	        pageMove: 0,
	        projectRerender: false,
	        projectsVisible: true,
	
	        projects: [],
	        categories: [],
	        clients: [],
	        filteredProjects: [],
	        categoryFilter: false,
	        clientFilter: '',
	        selectedProject: false,
	        selectedCategory: false,
	        pages: [],
	        navItems: {
	            about: { de: 'Profil', en: 'About' },
	            contact: { de: 'Kontakt', en: 'Contact' },
	            clients: { de: 'Kunden', en: 'Clients' },
	            makingOf: { de: "Making Of", en: 'Making Of' },
	            agb: { de: "AGB", en: 'TAC' }
	
	        },
	
	        textVariables: {
	            'example': { de: 'Beispiel', en: 'Example' },
	            'allProjects': { de: 'Alle Projekte', en: 'All projects' }
	        }
	
	    },
	
	    getters: getters,
	
	    mutations: {
	        toggleSidebar: function toggleSidebar(state) {
	            state.layout.sidebar.expanded = !state.layout.sidebar.expanded;
	            console.log(state.layout.sidebar.expanded);
	        },
	        setSidebar: function setSidebar(state, n) {
	            state.sidebar.status = n;
	            if (n < 1) {
	                state.layout.sidebarWidth = state.sidebar.widthHidden;
	            }
	            if (n == 1) {
	                state.layout.sidebarWidth = state.sidebar.widthCollapsed;
	            }
	            if (n == 2) {
	                state.layout.sidebarWidth = state.sidebar.widthExpanded;
	            }
	
	            if (state.layout.type == 'large') {
	
	                state.layout.viewportWidth = state.layout.width - state.layout.sidebarWidth - state.layout.margin;
	            }
	        },
	        setConfig: function setConfig(state, config) {
	            state.config = config;
	        },
	        setCategories: function setCategories(state, categories) {
	            state.categories = categories;
	        },
	        setProjects: function setProjects(state, projects) {
	            for (var i = 0; i < projects.length; i++) {
	
	                projects[i].view = {
	                    totalWidth: 100,
	                    overlay: false,
	                    title: false,
	                    info: false
	                };
	
	                for (var p = 0; p < projects[i].images.length; p++) {
	                    projects[i].images[p].view = {
	                        index: p,
	                        totalImages: projects[i].images.length,
	                        scrollPosition: 20 * p,
	                        width: 20,
	                        height: 20,
	                        loaded: false
	                    };
	                }
	            }
	
	            state.projects = projects;
	        },
	        setProjectsScrollPosition: function setProjectsScrollPosition(state, scrollTop) {
	
	            state.projectsScrollPosition = scrollTop;
	
	            var pIndex = scrollTop / state.layout.height;
	            pIndex = Math.floor(Math.abs(pIndex));
	
	            state.projectsCurrentId = state.projects[pIndex].id;
	            state.currentProject = state.projects[pIndex];
	            state.projectsCurrentIndex = pIndex;
	        },
	
	
	        setProjectCurrentIndex: function setProjectCurrentIndex(state, index) {
	
	            console.log("Project set scroll Index");
	        },
	
	        setProjectMove: function setProjectMove(state, direction) {
	
	            state.projectMove = Date.now() * direction;
	
	            if (direction < 0) {
	                state.projectMoveLeft = state.projectMove;
	            } else {
	
	                state.projectMoveRight = state.projectMove;
	            }
	        },
	
	        setPageMove: function setPageMove(state, direction) {
	
	            state.pageMove = Date.now() * direction;
	        },
	
	        setProjectRerender: function setProjectRerender(state) {
	
	            state.projectRerender = Date.now();
	        },
	
	        setProjectsVisible: function setProjectsVisible(state, visible) {
	
	            state.projectsVisible = visible;
	        },
	
	        setFullscreen: function setFullscreen(state, fullscreen) {
	
	            state.layout.fullscreen = fullscreen;
	        },
	
	        setCategoryFilter: function setCategoryFilter(state, category) {
	
	            category = category || false;
	            state.categoryFilter = category;
	        },
	
	        setDownloadTermsVisible: function setDownloadTermsVisible(state, visible) {
	
	            state.downloadTermsVisible = visible;
	        },
	
	        setDownloadTermsAccepted: function setDownloadTermsAccepted(state, accepted) {
	
	            state.downloadTermsAccepted = accepted;
	        },
	
	        toggleMobileNavigation: function toggleMobileNavigation(state) {
	
	            state.layout.mobileNavigation = !state.layout.mobileNavigation;
	        },
	
	        hideMobileNavigation: function hideMobileNavigation(state) {
	
	            state.layout.mobileNavigation = false;
	        },
	
	        showMobileNavigation: function showMobileNavigation(state) {
	
	            state.layout.mobileNavigation = true;
	        },
	
	        setLanguage: function setLanguage(state, language) {
	
	            state.language = language;
	        },
	
	        setClients: function setClients(state, clients) {
	
	            state.clients = clients;
	        }
	
	    },
	
	    actions: actions
	
	});
	
	exports.default = store;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    computed: {
	        language: function language() {
	            return _store2.default.state.language;
	        },
	        categories: function categories() {
	            return _store2.default.state.categories;
	        },
	        nav: function nav() {
	            return _store2.default.state.navItems;
	        },
	        sidebarWidthExpanded: function sidebarWidthExpanded() {
	            return _store2.default.state.sidebar.widthExpanded;
	        },
	        sidebarWidthCollapsed: function sidebarWidthCollapsed() {
	            return _store2.default.state.sidebar.widthCollapsed;
	        },
	        sidebarWidthHidden: function sidebarWidthHidden() {
	            return _store2.default.state.sidebar.widthHidden;
	        },
	        sidebarExpanded: function sidebarExpanded() {
	            return _store2.default.state.sidebar.expanded;
	        },
	        sidebarHidden: function sidebarHidden() {
	            return _store2.default.state.sidebar.hidden;
	        },
	        sidebarStatus: function sidebarStatus() {
	            return _store2.default.state.sidebar.status;
	        },
	        windowHeight: function windowHeight() {
	            return _store2.default.state.layout.height;
	        },
	        windowWidth: function windowWidth() {
	            return _store2.default.state.layout.width;
	        },
	        windowMargin: function windowMargin() {
	            return _store2.default.getters.getWindowMargin;
	        },
	        domElements: function domElements() {
	            return _store2.default.state.domElements;
	        },
	        projectsScrollPosition: function projectsScrollPosition() {
	            return _store2.default.state.projectsScrollPosition;
	        },
	        fullscreen: function fullscreen() {
	            return _store2.default.state.layout.fullscreen;
	        },
	        downloadTermsVisible: function downloadTermsVisible() {
	            return _store2.default.state.downloadTermsVisible;
	        },
	        isVerySmall: function isVerySmall() {
	            if (_store2.default.state.layout.height < 490) {
	                return true;
	            } else {
	                return false;
	            }
	        },
	        layout: function layout() {
	            return _store2.default.state.layout;
	        },
	        mobileMenuTop: function mobileMenuTop() {
	            if (this.layout.orientation == 'portrait') {
	                return this.layout.offsetTop - 2;
	            } else {
	                return this.layout.offsetTop;
	            }
	        },
	        showNavArrows: function showNavArrows() {
	            if (this.$route.name == 'project' || this.$route.name == 'project-slide') {
	                return true;
	            }
	            return false;
	        }
	    },
	
	    watch: {
	        '$route': function $route(val, oldVal) {
	            this.handleRouteChange(val, oldVal);
	        },
	
	        sidebarStatus: function sidebarStatus(val, oldVal) {
	            console.log("Sidebar switched from " + oldVal + ' to ' + val);
	
	            var sidebar = $(this.domElements.sidebar);
	            var mainContent = $(this.domElements.mainContent);
	
	            if (val < 1) {
	                var seq = [{ e: sidebar,
	                    p: { width: this.sidebarWidthHidden, opacity: 0 },
	                    o: { duration: 400, easing: "easeOutQuint" }
	                }, { e: mainContent,
	                    p: { paddingLeft: this.sidebarWidthHidden },
	                    o: { duration: 400, easing: "easeOutQuint", sequenceQueue: false }
	                }];
	
	                $.Velocity.RunSequence(seq);
	                console.log("Hide Sidebar");
	            }
	
	            if (val == 1 && oldVal < 1) {
	                var seq = [{ e: sidebar,
	                    p: { width: this.sidebarWidthCollapsed + 'px', opacity: 1 },
	                    o: { duration: 800, easing: "easeOutQuint" }
	                }, { e: mainContent,
	                    p: { paddingLeft: this.sidebarWidthCollapsed },
	                    o: { duration: 800, easing: "easeOutQuint", sequenceQueue: false }
	                }];
	                $.Velocity.RunSequence(seq);
	                console.log("Collapse sidebar from hidden");
	            }
	
	            if (val == 1 && oldVal == 2) {
	                var seq = [{
	                    e: $('.main-menu ul li'),
	                    p: 'transition.slideLeftOut',
	                    o: { duration: 200, stagger: 30, easing: 'easeOutQuad', sequenceQueue: false }
	                }, { e: sidebar,
	                    p: { width: this.sidebarWidthCollapsed + 'px' },
	                    o: { duration: 800, easing: "easeOutQuint", sequenceQueue: false }
	                }, { e: mainContent,
	                    p: { paddingLeft: this.sidebarWidthCollapsed },
	                    o: { duration: 1000, easing: "easeOutQuint", sequenceQueue: false, delay: 0 }
	                }];
	                $.Velocity.RunSequence(seq);
	                console.log("Collapse sidebar from expanded");
	            }
	
	            if (val == 2 && oldVal == 1) {
	                var seq = [{ e: sidebar,
	                    p: { width: this.sidebarWidthExpanded },
	                    o: { duration: 800, easing: "easeOutQuint" }
	                }, { e: mainContent,
	                    p: { paddingLeft: this.sidebarWidthExpanded },
	                    o: { duration: 800, easing: "easeOutQuint", sequenceQueue: false }
	                }, {
	                    e: $('.main-menu ul li'),
	                    p: 'transition.slideLeftIn',
	                    o: { duration: 400, stagger: 75, delay: 200, easing: 'easeOutQuad', sequenceQueue: false }
	                }];
	                $.Velocity.RunSequence(seq);
	                console.log("Expand Sidebar from collapsed");
	            }
	
	            if (val == 2 && oldVal < 1) {
	                var seq = [{ e: sidebar,
	                    p: { width: this.sidebarWidthExpanded },
	                    o: { duration: 800, easing: "easeOutQuint" }
	                }, { e: mainContent,
	                    p: { paddingLeft: this.sidebarWidthExpanded },
	                    o: { duration: 800, easing: "easeOutQuint", sequenceQueue: false }
	                }];
	                $.Velocity.RunSequence(seq);
	                console.log("Expand Sidebar from hidden");
	            }
	        }
	
	    },
	
	    created: function created() {
	        _store2.default.dispatch('handleWindowResize');
	        _store2.default.commit('setSidebar', 0);
	
	        window.addEventListener('resize', this.handleWindowResize.bind(this));
	
	        if (_store2.default.state.route.name == 'project' || _store2.default.state.route.name == 'project-slide') {
	            this.$nextTick(function () {
	                $('body').addClass('hide-scrollbar');
	            });
	        }
	    },
	
	    methods: {
	
	        handleRouteChange: function handleRouteChange(val, old) {
	
	            console.info("Project route is " + val.name);
	            if (val.name == 'project' || val.name == 'project-slide') {
	                this.$nextTick(function () {
	                    $('body').addClass('hide-scrollbar');
	                });
	            } else {
	
	                this.$nextTick(function () {
	                    $('body').removeClass('hide-scrollbar');
	                });
	            }
	        },
	
	        handleWindowResize: function handleWindowResize(e) {
	            _store2.default.dispatch('handleWindowResize');
	        },
	
	        toggleSidebar: function toggleSidebar() {
	
	            console.log("Sidebarstatus " + this.sidebarStatus);
	            if (this.sidebarStatus == 2 || this.sidebarStatus < 1) {
	                this.setSidebar(1);
	            } else {
	                this.setSidebar(2);
	            }
	        },
	
	        fetchData: function fetchData() {},
	
	        setSidebar: function setSidebar(status) {
	            status = status || 0;
	
	            _store2.default.commit('setSidebar', status);
	        },
	
	        prevPage: function prevPage() {
	            console.log("Side-Nav: Prev Page");
	            _store2.default.commit('setPageMove', -1);
	        },
	
	        nextPage: function nextPage() {
	
	            console.log("Side-Nav: Next Page");
	            _store2.default.commit('setPageMove', 1);
	        },
	
	        acceptDownloadTerms: function acceptDownloadTerms() {
	
	            _store2.default.commit('setDownloadTermsAccepted', true);
	            _store2.default.commit('setDownloadTermsVisible', false);
	            window.location.assign(_store2.default.state.downloadRequestedImage);
	        },
	
	        cancelDownloadTerms: function cancelDownloadTerms() {
	
	            _store2.default.commit('setDownloadTermsVisible', false);
	        },
	
	        toggleFullScreen: function toggleFullScreen() {
	
	            var doc = window.document;
	            var docEl = doc.documentElement;
	
	            var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
	            var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
	
	            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
	                requestFullScreen.call(docEl);
	                _store2.default.commit('setFullscreen', true);
	            } else {
	                _store2.default.commit('setFullscreen', false);
	                cancelFullScreen.call(doc);
	            }
	        },
	
	        toggleMobileNav: function toggleMobileNav() {
	
	            _store2.default.commit('toggleMobileNavigation');
	        },
	
	        setLanguage: function setLanguage(lang) {
	
	            _store2.default.commit('setLanguage', lang);
	        }
	
	    }
	};
	
	var css = __webpack_require__(169);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(28);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _computed;
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            clients: []
	        };
	    },
	
	
	    computed: (_computed = {
	        lang: function lang() {
	            return _store2.default.state.language;
	        },
	        nav: function nav() {
	            return _store2.default.state.navItems;
	        },
	        clientCategories: function clientCategories() {
	            return _store2.default.state.clients;
	        },
	        snippets: function snippets() {
	            return _store2.default.state.textVariables;
	        },
	        sidebarStatus: function sidebarStatus() {
	            return _store2.default.state.sidebar.status;
	        },
	        windowHeight: function windowHeight() {
	            return _store2.default.state.layout.height;
	        },
	        windowWidth: function windowWidth() {
	            return _store2.default.state.layout.width;
	        },
	        domElements: function domElements() {
	            return _store2.default.state.domElements;
	        },
	        projects: function projects() {
	            return _store2.default.state.projects;
	        },
	        projectsCurrentIndex: function projectsCurrentIndex() {
	            return _store2.default.state.projectsCurrentIndex;
	        },
	        projectsCurrentId: function projectsCurrentId() {
	            return _store2.default.state.projectsCurrentId;
	        },
	        windowRatio: function windowRatio() {
	            return _store2.default.getters.getLayoutRatio;
	        },
	        windowMargin: function windowMargin() {
	            return _store2.default.getters.getWindowMargin;
	        }
	    }, (0, _defineProperty3.default)(_computed, 'windowHeight', function windowHeight() {
	        return _store2.default.state.layout.height;
	    }), (0, _defineProperty3.default)(_computed, 'windowWidth', function windowWidth() {
	        return _store2.default.state.layout.width;
	    }), (0, _defineProperty3.default)(_computed, 'layout', function layout() {
	        return _store2.default.state.layout;
	    }), (0, _defineProperty3.default)(_computed, 'isMobile', function isMobile() {
	        if (_store2.default.state.layout.type != 'large') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'isLandscape', function isLandscape() {
	        if (this.isMobile && this.layout.orientation == 'landscape') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'isPortrait', function isPortrait() {
	        if (this.isMobile && this.layout.orientation == 'portrait') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'slug', function slug() {
	        return this.$route.params.pageslug;
	    }), (0, _defineProperty3.default)(_computed, 'pageTitle', function pageTitle() {
	        return this.nav.clients[this.lang];
	    }), _computed),
	
	    created: function created() {
	
	        this.clients = [];
	
	        if (this.sidebarStatus < 2 && this.layout.type == 'large') {
	
	            _store2.default.commit('setSidebar', 1);
	        }
	
	        if (this.layout.type != 'large') {
	            _store2.default.commit('setSidebar', 0);
	        }
	
	        console.info("Render clients");
	        this.renderCategories();
	    },
	
	    methods: {
	
	        renderCategories: function renderCategories() {
	            for (var i = 0; i < this.clientCategories.length; i++) {
	
	                this.clients.push(this.renderCategory(this.clientCategories[i]));
	            }
	        },
	
	        renderCategory: function renderCategory(category) {
	
	            var cat = false;
	            cat = category;
	
	            for (var i = 0; i < cat.clients.length; i++) {
	
	                this.renderClient(cat.clients[i]);
	            }
	
	            return cat;
	        },
	
	        renderClient: function renderClient(client) {
	
	            client.link = false;
	            client.projects = this.getClientProjects(client.slug);
	
	            if (client.projects.length > 0) {
	                client.link = true;
	            }
	        },
	
	        getClientProjects: function getClientProjects(clientSlug) {
	
	            var projects = [];
	
	            for (var i = 0; i < this.projects.length; i++) {
	                if (this.projects[i].clientSlug == clientSlug) {
	                    projects.push(this.projects[i]);
	                }
	            }
	
	            return projects;
	        },
	
	        openLink: function openLink(client) {
	
	            if (client.projects.length == 1) {
	
	                this.$router.push({ name: 'project', params: { slug: client.projects[0].id } });
	            } else {
	
	                this.$router.push({ name: 'index-client', params: { clientSlug: client.slug } });
	            }
	        }
	
	    }
	
	};

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(28);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _computed;
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'index',
	
	    computed: (_computed = {
	        lang: function lang() {
	            return _store2.default.state.language;
	        },
	        textVariables: function textVariables() {
	            return _store2.default.state.textVariables;
	        },
	        sidebarStatus: function sidebarStatus() {
	            return _store2.default.state.sidebar.status;
	        },
	        windowHeight: function windowHeight() {
	            return _store2.default.state.layout.height;
	        },
	        windowWidth: function windowWidth() {
	            return _store2.default.state.layout.width;
	        },
	        domElements: function domElements() {
	            return _store2.default.state.domElements;
	        },
	        projects: function projects() {
	            return _store2.default.state.projects;
	        },
	        projectsCurrentIndex: function projectsCurrentIndex() {
	            return _store2.default.state.projectsCurrentIndex;
	        },
	        projectsCurrentId: function projectsCurrentId() {
	            return _store2.default.state.projectsCurrentId;
	        },
	        windowRatio: function windowRatio() {
	            return _store2.default.getters.getLayoutRatio;
	        },
	        windowMargin: function windowMargin() {
	            return _store2.default.getters.getWindowMargin;
	        }
	    }, (0, _defineProperty3.default)(_computed, 'windowHeight', function windowHeight() {
	        return _store2.default.state.layout.height;
	    }), (0, _defineProperty3.default)(_computed, 'windowWidth', function windowWidth() {
	        return _store2.default.state.layout.width;
	    }), (0, _defineProperty3.default)(_computed, 'categoryFilter', function categoryFilter() {
	        return _store2.default.state.categoryFilter;
	    }), (0, _defineProperty3.default)(_computed, 'layout', function layout() {
	        return _store2.default.state.layout;
	    }), (0, _defineProperty3.default)(_computed, 'isMobile', function isMobile() {
	        if (_store2.default.state.layout.type != 'large') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'isLandscape', function isLandscape() {
	        if (this.isMobile && this.layout.orientation == 'landscape') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'isPortrait', function isPortrait() {
	        if (this.isMobile && this.layout.orientation == 'portrait') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'pageTitle', function pageTitle() {
	        if (this.$route.name != 'index-client' && this.categoryFilter) {
	
	            var cat = false;
	            for (var i = 0; i < _store2.default.state.categories.length; i++) {
	                if (_store2.default.state.categories[i].slug == this.categoryFilter) {
	                    cat = _store2.default.state.categories[i];
	                }
	            }
	
	            return cat.title[this.lang];
	        }
	
	        if (this.$route.name == 'index-client') {
	
	            return this.filteredProjects[0].client;
	        }
	
	        return this.textVariables.allProjects[this.lang];
	    }), (0, _defineProperty3.default)(_computed, 'filteredProjects', function filteredProjects() {
	
	        $('.track-nav').hide();
	        var filtered = [];
	
	        if (this.$route.name == 'index-category' || this.$route.name == 'index') {
	            if (this.categoryFilter) {
	                for (var i = 0; i < this.projects.length; i++) {
	                    if (this.projects[i].category[0] == this.categoryFilter) {
	
	                        filtered.push(this.projects[i]);
	                    }
	                }
	            } else {
	                filtered = this.projects;
	            }
	        }
	
	        if (this.$route.name == 'index-client') {
	
	            for (var i = 0; i < this.projects.length; i++) {
	                if (this.projects[i].clientSlug == this.$route.params.clientSlug) {
	
	                    filtered.push(this.projects[i]);
	                }
	            }
	        }
	
	        return filtered;
	    }), _computed),
	
	    data: function data() {
	        return {};
	    },
	    created: function created() {
	        this.setFilter(_store2.default.state.route.params.category);
	
	        this.$nextTick(function () {
	
	            $('.track-nav').hide();
	            this.unveil();
	
	            $('body').velocity({ opacity: 1 }, { duration: 1200, complete: this.checkTrackNavigation.bind(this) });
	        });
	        if (this.sidebarStatus < 2 && this.layout.type == 'large') {
	
	            _store2.default.commit('setSidebar', 1);
	        }
	
	        if (this.layout.type != 'large') {
	            _store2.default.commit('setSidebar', 0);
	        }
	    },
	
	
	    watch: {
	        sidebarStatus: function sidebarStatus(val, oldVal) {
	
	            $('.track-nav').hide();
	            console.log('Check track width after sidebar change');
	            $('body').velocity({ opacity: 1 }, { duration: 700, complete: this.checkTrackNavigation.bind(this) });
	        },
	
	        windowWidth: function windowWidth(val, oldVal) {
	            console.log('Track parent changed ' + oldVal + 'px to ' + val);
	
	            this.checkTrackNavigation();
	        },
	
	        $route: function $route(val, oldVal) {
	
	            $('.track-nav').hide();
	            if (this.sidebarStatus < 2 && this.layout.type == 'large') {
	
	                _store2.default.commit('setSidebar', 1);
	            }
	
	            if (this.layout.type != 'large') {
	                _store2.default.commit('setSidebar', 0);
	            }
	
	            this.setFilter(_store2.default.state.route.params.category);
	            console.log('unveil ' + Date.now());
	
	            this.$nextTick(function () {
	
	                this.unveil();
	                this.checkTrackNavigation();
	            });
	        }
	
	    },
	
	    methods: {
	        checkTrackNavigation: function checkTrackNavigation() {
	
	            $('.track-nav').hide();
	
	            console.log('Check Track Navigation for all projects ' + Date.now());
	
	            if (this.layout.type != 'large') {
	                return false;
	            }
	
	            for (var i = 0; i < this.filteredProjects.length; i++) {
	
	                var wrapper = $('#index-' + this.filteredProjects[i].id);
	                var track = $('#index-' + this.filteredProjects[i].id + ' .index-project-slide-track');
	                var images = this.filteredProjects[i].images;
	
	                var width = 0;
	
	                for (var w = 0; w < images.length; w++) {
	                    width += 133 * (images[w].view.width / images[w].view.height) + 10;
	                }
	
	                if (width > Number(wrapper.width())) {
	
	                    $('#index-' + this.filteredProjects[i].id + ' .track-nav-right').show();
	                    console.log('check index track for #' + this.filteredProjects[i].id + ' -- ' + wrapper.width() + ' -- ' + width);
	                }
	            };
	        },
	
	        checkLeftTrackNav: function checkLeftTrackNav(projectId) {
	
	            var scrollLeft = $('#index-' + projectId + ' .index-project-slide-track').scrollLeft();
	
	            var scrollLeft = $('#index-' + projectId + ' .index-project-slide-track').scrollLeft();
	            var trackWidth = $('#index-' + projectId + ' .index-project-slide-track').width();
	
	            if (scrollLeft > 0) {
	                $('#index-' + projectId + ' .track-nav-left').show();
	            } else {
	
	                $('#index-' + projectId + ' .track-nav-left').hide();
	            }
	        },
	
	        trackMoveRight: function trackMoveRight(projectId) {
	
	            this.trackMove(projectId, 1);
	        },
	
	        trackMoveLeft: function trackMoveLeft(projectId) {
	
	            this.trackMove(projectId, -1);
	        },
	
	        trackMove: function trackMove(projectId, direction) {
	            var scroll = $('#index-' + projectId + ' .index-project-slide-track').scrollLeft();
	            var trackWidth = $('#index-' + projectId + ' .index-project-slide-track').width();
	            var newScroll = Number(scroll) + direction * this.layout.viewportWidth;
	            var incrementer = 0.01;
	
	            console.log('Move track from ' + scroll + 'total width is' + trackWidth);
	
	            var that = this;
	            function animateTrack() {
	                incrementer += 0.0035;
	                scroll = Number(scroll) + 2 * direction;
	
	                if (direction > 0) {
	                    scroll += 1 / incrementer;
	                    if (scroll <= newScroll && scroll <= trackWidth) {
	                        requestAnimationFrame(animateTrack);
	                        $('#index-' + projectId + ' .index-project-slide-track').scrollLeft(scroll);
	                    }
	                } else {
	
	                    scroll -= 1 / incrementer;
	                    if (scroll >= newScroll) {
	                        requestAnimationFrame(animateTrack);
	                        $('#index-' + projectId + ' .index-project-slide-track').scrollLeft(scroll);
	                    }
	                }
	
	                that.checkLeftTrackNav(projectId);
	            };
	
	            animateTrack();
	        },
	
	        setFilter: function setFilter(filter) {
	            if (filter) {
	
	                _store2.default.commit('setCategoryFilter', filter);
	            } else {
	
	                _store2.default.commit('setCategoryFilter', false);
	            }
	        },
	
	        download: function download(image) {
	
	            _store2.default.dispatch('downloadImage', image);
	        },
	
	        getCategoryBySlug: function getCategoryBySlug(slug) {
	
	            var cat = false;
	            for (var i = 0; i < _store2.default.state.categories.length; i++) {
	                if (_store2.default.state.categories[i].slug == slug) {
	                    cat = _store2.default.state.categories[i];
	                }
	            }
	
	            return cat.title[this.lang];
	        },
	
	        unveil: function unveil() {
	
	            $(".index-project-slide .index-image").unbind().css({ opacity: 0 }).attr('src', '/static/images/placeholder.gif');
	
	            console.log("Unveil all images");
	
	            for (var i = 0; i < this.filteredProjects.length; i++) {
	
	                for (var p = 0; p < this.filteredProjects[i].images.length; p++) {
	
	                    var id = 'index-' + this.filteredProjects[i].id + '--' + p;
	                    var src = '/static/assets2/small/' + this.filteredProjects[i].directory + '/' + this.filteredProjects[i].images[p].file;
	                    console.log(src);
	
	                    $("#" + id).unbind().attr('src', '/static/images/placeholder.gif').on('load', function () {
	
	                        var delay = Math.floor(Math.random() * 15 + 1) * 40;
	                        $(this).velocity({ opacity: 1 }, { easing: "easeInOutQuad", duration: 600, delay: delay });
	                    }).attr('src', src);
	                }
	            }
	        }
	
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(28);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _computed;
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            content: { de: 'Etwas Inhalt', en: "Some content" }
	        };
	    },
	
	
	    computed: (_computed = {
	        lang: function lang() {
	            return _store2.default.state.language;
	        },
	        nav: function nav() {
	            return _store2.default.state.navItems;
	        },
	        sidebarStatus: function sidebarStatus() {
	            return _store2.default.state.sidebar.status;
	        },
	        windowHeight: function windowHeight() {
	            return _store2.default.state.layout.height;
	        },
	        windowWidth: function windowWidth() {
	            return _store2.default.state.layout.width;
	        },
	        domElements: function domElements() {
	            return _store2.default.state.domElements;
	        },
	        projects: function projects() {
	            return _store2.default.state.projects;
	        },
	        projectsCurrentIndex: function projectsCurrentIndex() {
	            return _store2.default.state.projectsCurrentIndex;
	        },
	        projectsCurrentId: function projectsCurrentId() {
	            return _store2.default.state.projectsCurrentId;
	        },
	        windowRatio: function windowRatio() {
	            return _store2.default.getters.getLayoutRatio;
	        },
	        windowMargin: function windowMargin() {
	            return _store2.default.getters.getWindowMargin;
	        }
	    }, (0, _defineProperty3.default)(_computed, 'windowHeight', function windowHeight() {
	        return _store2.default.state.layout.height;
	    }), (0, _defineProperty3.default)(_computed, 'windowWidth', function windowWidth() {
	        return _store2.default.state.layout.width;
	    }), (0, _defineProperty3.default)(_computed, 'layout', function layout() {
	        return _store2.default.state.layout;
	    }), (0, _defineProperty3.default)(_computed, 'isMobile', function isMobile() {
	        if (_store2.default.state.layout.type != 'large') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'isLandscape', function isLandscape() {
	        if (this.isMobile && this.layout.orientation == 'landscape') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'isPortrait', function isPortrait() {
	        if (this.isMobile && this.layout.orientation == 'portrait') {
	            return true;
	        }return false;
	    }), (0, _defineProperty3.default)(_computed, 'slug', function slug() {
	        return this.$route.params.pageslug;
	    }), (0, _defineProperty3.default)(_computed, 'pageTitle', function pageTitle() {
	        if (this.slug == 'about') {
	            return this.nav.about[this.lang];
	        }
	        if (this.slug == 'contact') {
	            return this.nav.contact[this.lang];
	        }
	        if (this.slug == 'clients') {
	            return this.nav.clients[this.lang];
	        }
	        if (this.slug == 'making-of') {
	            return this.nav.makingOf[this.lang];
	        }
	        if (this.slug == 'agb') {
	            return this.nav.agb[this.lang];
	        }
	    }), _computed),
	
	    created: function created() {
	
	        if (this.sidebarStatus < 2 && this.layout.type == 'large') {
	
	            _store2.default.commit('setSidebar', 1);
	        }
	
	        if (this.layout.type != 'large') {
	            _store2.default.commit('setSidebar', 0);
	        }
	
	        this.fetchData();
	    },
	
	    watch: {
	
	        $route: function $route(val, oldVal) {
	
	            this.fetchData();
	        }
	    },
	
	    methods: {
	
	        fetchData: function fetchData() {
	            var _this = this;
	
	            this.$http.get('/static/pages/' + this.$route.params.pageslug + ".json").then(function (response) {
	                console.log(response.body);
	                _this.content = response.body.page.content;
	            }, function (response) {
	                console.error("Coud not load requested content");
	            });
	        }
	
	    }
	
	};

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectImage = __webpack_require__(179);
	
	exports.default = {
	
	    components: { 'project-image': projectImage },
	    props: ['project', 'index'],
	    computed: {
	        lang: function lang() {
	            return _store2.default.state.language;
	        },
	        windowHeight: function windowHeight() {
	            return _store2.default.state.layout.height;
	        },
	        windowWidth: function windowWidth() {
	            return _store2.default.state.layout.width;
	        },
	        windowRatio: function windowRatio() {
	            return _store2.default.getters.getLayoutRatio;
	        },
	        windowMargin: function windowMargin() {
	            return _store2.default.getters.getWindowMargin;
	        },
	        currentId: function currentId() {
	            return _store2.default.state.projectsCurrentId;
	        },
	        layout: function layout() {
	            return _store2.default.state.layout;
	        },
	        projectMove: function projectMove() {
	            return _store2.default.state.projectMove;
	        },
	        totalImages: function totalImages() {
	            return this.project.images.length;
	        },
	        slideTrackMaxTime: function slideTrackMaxTime() {
	            return this.project.images.length * this.windowWidth / 10;
	        },
	        refImages: function refImages() {
	            return this.$refs.images;
	        },
	        projectRerender: function projectRerender() {
	            return _store2.default.state.projectRerender;
	        },
	        lightSiteTitle: function lightSiteTitle() {
	            if (this.startImage.caption == 'light') {
	                return true;
	            }
	            return false;
	        }
	    },
	
	    data: function data() {
	        return {
	            scrollLeft: 0,
	            imageIndex: 0,
	            listen: true,
	            lastMove: false,
	            currentSlide: 0,
	            showTitle: false,
	            showInfoFlag: 0,
	            ready: false,
	            startImage: false,
	            mobileProjectInfo: false
	        };
	    },
	
	
	    watch: {
	
	        projectRerender: function projectRerender(val, oldVal) {
	
	            if (this.project.id == this.currentId) {
	                console.info("Request rerender of current project");
	                var CorrectionConstant = 0;
	
	                this.renderProject();
	
	                if (this.layout.type == 'small' || this.layout.type == 'medium') {
	                    CorrectionConstant = this.layout.mobileGutter * this.currentSlide;
	                }
	
	                var targetPosition = this.project.images[this.currentSlide].view.scrollPosition + CorrectionConstant;
	
	                $("#" + this.project.id + " .project-slide-track").velocity({ marginLeft: -1 * Math.floor(targetPosition) - CorrectionConstant }, { easing: 'easeOutQuad', duration: 1 });
	            }
	        },
	        currentId: function currentId(val, oldVal) {
	
	            oldVal = oldVal || '';
	            if (val == this.project.id && val != oldVal) {
	                this.renderProject();
	
	                if (!_store2.default.state.route.params.index) {
	                    this.$router.push({ name: 'project', params: { slug: this.project.id } });
	                    this.moveToStart();
	                } else {
	                    this.jumpToSlide(_store2.default.state.route.params.index);
	                }
	            }
	        },
	
	        projectMove: function projectMove(val, oldVal) {
	
	            if (this.currentId != this.project.id) {
	                return false;
	            }
	
	            if (val > 0) {
	                this.nextSlide();
	            } else {
	                this.prevSlide();
	            }
	
	            if (_store2.default.state.layout.type == 'large') {
	
	                _store2.default.commit('setSidebar', 1);
	            }
	        }
	
	    },
	
	    created: function created() {
	
	        this.startImage = this.project.images[Math.floor(Math.random() * this.project.images.length)];
	        this.lastMove = Date.now();
	    },
	
	    methods: {
	
	        nextSlide: function nextSlide() {
	
	            if (!this.listen) {
	                return false;
	            }
	
	            var targetIndex = this.currentSlide + 1;
	            if (targetIndex >= this.project.images.length) {
	
	                this.$emit('projectEnd');
	                return false;
	            }
	
	            this.listen = false;
	            this.showInfoFlag = 0;
	
	            var targetPosition = this.project.images[targetIndex].view.scrollPosition;
	            console.log("Move " + this.project.id + " to " + targetPosition);
	
	            this.currentSlide = targetIndex;
	            this.loadImage(this.currentSlide, 1);
	
	            var CorrectionConstant = 0;
	
	            if (this.layout.type == 'small' || this.layout.type == 'medium') {
	                CorrectionConstant = this.layout.mobileGutter * this.currentSlide;
	            }
	
	            $("#" + this.project.id + " .project-slide-track").velocity({ marginLeft: -1 * Math.floor(targetPosition) - CorrectionConstant }, { easing: 'easeOutQuad', duration: 700, complete: this.handleCompleteMove.bind(this) });
	        },
	
	        prevSlide: function prevSlide() {
	
	            if (!this.listen) {
	                return false;
	            }
	
	            var targetIndex = this.currentSlide - 1;
	
	            if (targetIndex < 0) {
	                this.$emit('startReached');
	                return false;
	            }
	
	            this.listen = false;
	            this.showInfoFlag = 0;
	
	            var targetPosition = this.project.images[targetIndex].view.scrollPosition;
	            console.log("Move " + this.project.id + " to " + targetPosition);
	
	            this.currentSlide = targetIndex;
	
	            this.loadImage(this.currentSlide, -1);
	            var CorrectionConstant = 0;
	
	            if (this.layout.type == 'small' || this.layout.type == 'medium') {
	                CorrectionConstant = this.layout.mobileGutter * this.currentSlide;
	            }
	
	            $("#" + this.project.id + " .project-slide-track").velocity({ marginLeft: -1 * Math.floor(targetPosition) - CorrectionConstant }, { easing: 'easeOutQuad', duration: 700, complete: this.handleCompleteMove.bind(this) });
	        },
	
	        moveToStart: function moveToStart() {
	
	            console.log("Move " + this.project.id + " to start");
	            this.currentSlide = 0;
	            $("#" + this.project.id + " .project-slide-track").velocity({ marginLeft: 0 }, { easing: 'easeInOutCubic', duration: this.slideTrackMaxTime, complete: this.handleCompleteMove.bind(this) });
	        },
	
	        jumpToSlide: function jumpToSlide(targetIndex) {
	
	            console.info("JUMP to slide");
	
	            this.listen = false;
	            this.showInfoFlag = 0;
	            this.currentSlide = Number(targetIndex);
	            var CorrectionConstant = 0;
	
	            if (this.layout.type == 'small' || this.layout.type == 'medium') {
	                CorrectionConstant = this.layout.mobileGutter * this.currentSlide;
	            }
	
	            var targetPosition = this.project.images[targetIndex].view.scrollPosition + CorrectionConstant;
	
	            $("#" + this.project.id + " .project-slide-track").velocity({ marginLeft: -1 * Math.floor(targetPosition) - CorrectionConstant }, { easing: 'easeOutQuad', duration: 1, complete: this.handleCompleteMove.bind(this) });
	            this.loadImage(this.currentSlide);
	            this.$router.push({ name: 'project', params: { slug: this.project.id } });
	        },
	
	        handleCompleteMove: function handleCompleteMove() {
	
	            this.lastMove = Date.now();
	            this.listen = true;
	            console.log("Update lastMove " + this.lastMove);
	        },
	
	        renderProject: function renderProject() {
	
	            console.log("Render project #" + this.project.id);
	            this.showInfoFlag = 1;
	
	            if (!_store2.default.state.route.params.index) {
	
	                this.loadImage(0, 1);
	            }
	
	            setTimeout(this.fadeOutInfo, 500);
	        },
	
	        fadeOutInfo: function fadeOutInfo() {
	            this.showInfoFlag = 0;
	        },
	
	        loadImage: function loadImage(index, direction) {
	
	            if (this.project.type == 'homepage') {
	                return false;
	            }
	            index = index || 0;
	            direction = direction || 1;
	
	            if (direction > 0) {
	                for (var i = 0; i < 3; i++) {
	                    this.lazyLoadImage(index + i);
	                }
	            } else {
	
	                for (var i = 0; i > -3; i--) {
	                    this.lazyLoadImage(index + i);
	                }
	            }
	        },
	
	        lazyLoadImage: function lazyLoadImage(index) {
	            index = index || 0;
	
	            if (Number(index) < 0) {
	                return false;
	            }
	
	            if (index < this.project.images.length) {
	
	                this.$refs.images[index].unveil();
	            }
	        },
	
	        showInfo: function showInfo() {
	
	            if (!this.ready) {
	                return false;
	            }
	
	            if (this.showInfoFlag < 2) {
	                this.showInfoFlag = 2;
	            } else {
	                this.showInfoFlag = 0;
	            }
	        },
	
	        showMobileProjectInfo: function showMobileProjectInfo() {
	            this.mobileProjectInfo = true;
	        },
	
	        hideMobileProjectInfo: function hideMobileProjectInfo() {
	            this.mobileProjectInfo = false;
	        },
	
	        onIsReady: function onIsReady() {
	
	            this.ready = true;
	        },
	
	        onAnimation: function onAnimation() {
	            this.ready = false;
	        }
	
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    props: ['image', 'project', 'currentSlide', 'showInfo', 'projectIndex', 'imageIndex', 'imageScrollPosition'],
	
	    computed: {
	        lang: function lang() {
	            return _store2.default.state.language;
	        },
	        windowHeight: function windowHeight() {
	            return _store2.default.state.layout.height;
	        },
	        windowWidth: function windowWidth() {
	            return _store2.default.state.layout.width;
	        },
	        windowRatio: function windowRatio() {
	            return _store2.default.getters.getLayoutRatio;
	        },
	        windowMargin: function windowMargin() {
	            return _store2.default.getters.getWindowMargin;
	        },
	        layout: function layout() {
	            return _store2.default.state.layout;
	        },
	        slidePadding: function slidePadding() {
	            return 0;
	        },
	        imageRatio: function imageRatio() {
	            var ratio = this.image.width / this.image.height;return ratio.toFixed(2);
	        },
	        imageMarginTop: function imageMarginTop() {},
	        src: function src() {
	            return '/static/assets2/large/' + this.project.directory + '/' + this.image.file;
	        },
	        id: function id() {
	            return this.project.id + '-image-' + this.imageIndex;
	        },
	        hideInfoText: function hideInfoText() {
	            if (this.showInfo <= 1) {
	                return true;
	            } else {
	                return false;
	            }
	        },
	        marginTop: function marginTop() {
	
	            return 0;
	        },
	        gutterRight: function gutterRight() {
	            if (this.layout.type == 'small' || this.layout.type == 'medium') {
	                return this.layout.mobileGutter;
	            } else {
	                return this.layout.margin;
	            }
	        }
	    },
	
	    data: function data() {
	        return {
	            imagePath: '/static/images/placeholder.gif'
	        };
	    },
	
	
	    watch: {
	
	        showInfo: function showInfo(val, oldVal) {
	            var textOpacity = 1;
	
	            if (this.currentSlide != this.imageIndex) {
	                textOpacity = 0;
	            }
	
	            if (oldVal == 0 && val == 2) {
	                var seq = [{ e: $('#' + this.id + ' .info-text'),
	                    p: { opacity: 1 },
	                    o: { duration: 1, easing: "easeOutQuint" }
	                }, { e: $('#' + this.id + ' .image-overlay'),
	                    p: { opacity: 0.7 },
	                    o: { duration: 1200, easing: "easeOutQuint" }
	                }, { e: $('#' + this.id + ' .image-overlay-content'),
	                    p: { opacity: textOpacity },
	                    o: { duration: 1500, easing: "easeOutQuint", sequenceQueue: false, delay: 200 }
	                }];
	                $.Velocity.RunSequence(seq);
	            }
	
	            if (oldVal == 0 && val == 1) {
	
	                this.$emit('animation');
	                var seq = [{ e: $('#' + this.id + ' .info-text'),
	                    p: { opacity: 0 },
	                    o: { duration: 1, easing: "easeOutQuint" }
	                }, { e: $('#' + this.id + ' .image-overlay'),
	                    p: { opacity: 0.7 },
	                    o: { duration: 1200, easing: "easeOutQuint" }
	                }, { e: $('#' + this.id + ' .image-overlay-content'),
	                    p: { opacity: textOpacity },
	                    o: { duration: 1500, easing: "easeOutQuint", sequenceQueue: false }
	                }];
	                $.Velocity.RunSequence(seq);
	            }
	
	            if (oldVal == 2 && val == 0) {
	
	                console.log("Fade out info");
	                var seq = [{ e: $('#' + this.id + ' .image-overlay-content'),
	                    p: { opacity: 0 },
	                    o: { duration: 700, easing: "easeInQuint" }
	                }, { e: $('#' + this.id + ' .image-overlay'),
	                    p: { opacity: 0 },
	                    o: { duration: 700, easing: "easeInQuint", sequenceQueue: false }
	                }];
	                $.Velocity.RunSequence(seq);
	            }
	
	            if (oldVal == 1 && val == 0) {
	
	                var seq2 = [{ e: $('#' + this.id + ' .image-overlay-content'),
	                    p: { opacity: 0 },
	                    o: { duration: 1000, easing: "easeInQuint" }
	                }, { e: $('#' + this.id + ' .image-overlay'),
	                    p: { opacity: 0 },
	                    o: { duration: 1000,
	                        easing: "easeInQuint",
	                        sequenceQueue: false,
	                        complete: function () {
	                            this.$emit('ready');
	                        }.bind(this) }
	                }];
	                $.Velocity.RunSequence(seq2);
	            }
	        }
	    },
	
	    created: function created() {},
	
	    methods: {
	
	        unveil: function unveil() {
	
	            console.log("Unvail " + this.image.file);
	            var selector = '#' + this.id + ' > img';
	
	            $(selector).unbind().on('load', function () {
	
	                $(this).velocity({ opacity: 1 }, { duration: 1500 });
	            });
	
	            this.imagePath = this.src;
	        },
	
	        onAnimationCompleted: function onAnimationCompleted() {
	
	            console.log('Animation completed');
	        },
	
	        download: function download() {
	
	            _store2.default.dispatch('downloadImage', this.image);
	        }
	
	    }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = __webpack_require__(178);
	
	exports.default = {
	
	    components: { 'project-component': Project },
	
	    data: function data() {
	        return {
	            title: '',
	            testmsg: 'swipe',
	            listen: true,
	            thresholdX: 20,
	            thresholdY: 20,
	            detectorOffsetY: 75,
	            detectorOffsetX: 75,
	            lastMove: false
	        };
	    },
	
	
	    computed: {
	        projects: function projects() {
	            return _store2.default.state.projects;
	        },
	        projectsCurrentIndex: function projectsCurrentIndex() {
	            return _store2.default.state.projectsCurrentIndex;
	        },
	        projectsCurrentId: function projectsCurrentId() {
	            return _store2.default.state.projectsCurrentId;
	        },
	        sidebarWidth: function sidebarWidth() {
	            return _store2.default.getters.getSidebarWidth;
	        },
	        viewportWidth: function viewportWidth() {
	            return _store2.default.state.layout.viewportWidth;
	        },
	        windowHeight: function windowHeight() {
	            return _store2.default.state.layout.height;
	        },
	        windowWidth: function windowWidth() {
	            return _store2.default.state.layout.width;
	        },
	        windowMargin: function windowMargin() {
	            return _store2.default.getters.getWindowMargin;
	        },
	        layout: function layout() {
	            return _store2.default.state.layout;
	        },
	        windowRatio: function windowRatio() {
	            return _store2.default.getters.getLayoutRatio;
	        },
	        scroll: function scroll() {
	            return _store2.default.state.projectsScrollPosition;
	        },
	        pageMove: function pageMove() {
	            return _store2.default.state.pageMove;
	        },
	        projectsVisible: function projectsVisible() {
	            return _store2.default.state.projectsVisible;
	        },
	        categoryFilter: function categoryFilter() {
	            return _store2.default.state.categoryFilter;
	        },
	        projectFrameHeight: function projectFrameHeight() {
	
	            if (this.windowMargin > 0) {
	                return this.windowHeight - 2 * this.windowMargin;
	            }
	
	            return this.windowHeight - 40;
	        },
	        filteredProjects: function filteredProjects() {
	            return this.projects;
	        }
	    },
	
	    watch: {
	        projectsCurrentIndex: function projectsCurrentIndex(val, oldVal) {
	
	            if (val > 0) {
	                if (_store2.default.state.layout.type == 'large') {
	                    _store2.default.commit('setSidebar', 1);
	                }
	            } else {
	
	                _store2.default.commit('setSidebar', 0);
	            }
	        },
	
	        '$route': function $route(val, oldVal) {
	            this.checkAndScrollById(val.params.slug);
	        },
	
	        pageMove: function pageMove(val, oldVal) {
	            console.log("Move page in projects " + val);
	
	            if (val > 0) {
	                this.nextPage();
	            } else {
	
	                this.prevPage();
	            }
	        },
	
	        windowHeight: function windowHeight(val, oldVal) {
	            console.log("Fix scroll position for new window height");
	            this.jumpToProject(this.projectsCurrentId);
	        }
	
	    },
	
	    created: function created() {
	
	        this.$nextTick(function () {
	            $("#swipe-detector").scrollTop(this.detectorOffsetY);
	            $("#swipe-detector").scrollLeft(this.detectorOffsetX);
	        });
	
	        if (_store2.default.state.route.name == 'project' || _store2.default.state.route.name == 'project-slide') {
	            console.log("Jump tp " + _store2.default.state.route.params.slug);
	            this.jumpToProject(_store2.default.state.route.params.slug);
	        };
	        if (_store2.default.state.route.name == 'projects') {
	            this.title = "Start with project 1";
	        };
	        if (_store2.default.state.route.name == 'start') {
	            this.title = "Start";
	        }
	    },
	
	    methods: {
	
	        preventArrowKeys: function preventArrowKeys(event) {
	
	            console.log("Prevent arrow keys");
	            return false;
	        },
	
	        handleSwipe: function handleSwipe(event) {
	
	            if (!this.listen) {
	                return false;
	            }
	
	            this.testmsg = "Detected " + event.type;
	
	            if (event.type === 'swipeleft') {
	                this.nextSlide();
	            }
	            if (event.type === 'swiperight') {
	                this.prevSlide();
	            }
	            if (event.type === 'swipeup') {
	                this.nextPage();
	            }
	            if (event.type === 'swipedown') {
	                this.prevPage();
	            }
	        },
	
	        handleDetector: function handleDetector(event) {
	            if (!this.listen) {
	                this.startDetector();return false;
	            }
	
	            var deltaY = event.target.scrollTop - this.detectorOffsetY;
	            var deltaX = event.target.scrollLeft - this.detectorOffsetX;
	
	            if (deltaY == deltaX || Math.abs(deltaY) < this.thresholdY && Math.abs(deltaX) < this.thresholdX) {
	                this.startDetector();return false;
	            }
	
	            if (Math.abs(deltaY) > Math.abs(deltaX)) {
	                if (event.target.scrollTop > this.detectorOffsetY) {
	                    this.nextPage();
	                } else {
	                        this.prevPage();
	                    }
	            } else {
	                if (event.target.scrollLeft > this.detectorOffsetX) {
	                    this.nextSlide();
	                    console.log("move right");
	                } else {
	                        this.prevSlide();
	                        console.log("Move left");
	                    }
	            }
	        },
	
	        handleMouseMove: function handleMouseMove(event) {
	            var x = event.clientX;
	            var y = event.clientY;
	            var direction = this.getDirectionFromCoordinates(x, y);
	
	            $('.projects-detector').removeClass('left right up down').addClass(direction);
	        },
	
	        handleDetectorClick: function handleDetectorClick(event) {
	
	            var x = event.clientX;
	            var y = event.clientY;
	            var direction = this.getDirectionFromCoordinates(x, y);
	
	            switch (direction) {
	                case 'up':
	                    this.prevPage();
	                    break;
	                case 'down':
	                    this.nextPage();
	                    break;
	                case 'right':
	                    this.nextSlide();
	                    break;
	                case 'left':
	                    this.prevSlide();
	                    break;
	
	            }
	
	            console.log(direction);
	        },
	
	        getDirectionFromCoordinates: function getDirectionFromCoordinates(x, y) {
	            var direction = false;
	
	            var l = 0.3;
	            var r = 0.3;
	            var u = 0.2;
	            var d = 0.80;
	
	            if (x <= this.windowWidth * l) {
	                direction = 'left';
	            }
	            if (x > this.windowWidth * l) {
	                direction = 'right';
	            }
	            if (y < this.windowHeight * u) {
	                direction = 'up';
	            }
	            if (y > this.windowHeight * d) {
	                direction = 'down';
	            }
	
	            return direction;
	        },
	
	        nextPage: function nextPage() {
	            var scrollPosition = $(".projects-vertical-track").css('marginTop');
	
	            console.log("move next " + parseInt(scrollPosition) + ' ' + (this.filteredProjects.length - 1) * this.windowHeight);
	
	            if (parseInt(scrollPosition) - this.windowHeight < -1 * (this.filteredProjects.length - 1) * this.windowHeight) {
	                console.log('Last page reeached');
	                this.listen = true;
	                this.startDetector();
	                return false;
	            }
	
	            if (this.lastMove - Date.now() > -400) {
	                console.log('To early to move on');
	                this.listen = true;
	                this.startDetector();
	                return false;
	            }
	
	            if (!this.listen) {
	                return false;
	            }
	
	            this.listen = false;
	
	
	            $('.projects-vertical-track').velocity({ marginTop: "+=" + -1 * this.windowHeight + 'px' }, { easing: 'easeOutQuint', duration: 800, complete: this.resetDetector.bind(this) });
	        },
	
	        checkAndScrollById: function checkAndScrollById(id) {
	            console.log("check and scroll by id");
	            this.jumpToProject(id);
	        },
	
	        prevPage: function prevPage() {
	            var scrollPosition = $(".projects-vertical-track").css('marginTop');
	            if (parseInt(scrollPosition) + this.windowHeight > 0) {
	                console.log("First page reached");
	                this.listen = true;
	                this.startDetector();
	                return false;
	            }
	
	            if (this.lastMove - Date.now() > -300) {
	                this.listen = true;this.startDetector();return false;
	            }
	
	            if (!this.listen) {
	                this.startDetector();this.listen = true;return false;
	            }
	
	            this.listen = false;
	
	            $('.projects-vertical-track').velocity({ marginTop: "+=" + 1 * this.windowHeight + 'px' }, { easing: 'easeOutQuint', duration: 800, complete: this.resetDetector.bind(this) });
	        },
	
	        nextSlide: function nextSlide() {
	
	            if (this.projectsCurrentIndex < 1) {
	                console.log("Move down");
	                this.nextPage();
	                return false;
	            }
	
	            _store2.default.commit('setProjectMove', 1);
	            this.resetDetector();
	        },
	
	        prevSlide: function prevSlide() {
	
	            if (this.projectsCurrentIndex < 1) {
	                console.log("Move down");
	                this.nextPage();
	
	                return false;
	            }
	
	            _store2.default.commit('setProjectMove', -1);
	            this.resetDetector();
	        },
	
	        resetDetector: function resetDetector() {
	
	            this.lastMove = Date.now();
	            var scrollPosition = $(".projects-vertical-track").css('marginTop');
	
	            _store2.default.commit('setProjectsScrollPosition', parseInt(scrollPosition));
	
	            $("#swipe-detector").scrollTop(this.detectorOffsetY);
	            $("#swipe-detector").scrollLeft(this.detectorOffsetX);
	            console.log("Reset scroll detector now");
	
	            this.listen = true;
	        },
	
	        startDetector: function startDetector() {
	
	            $("#swipe-detector").scrollTop(this.detectorOffsetY);
	            $("#swipe-detector").scrollLeft(this.detectorOffsetX);
	        },
	
	        jumpToProject: function jumpToProject(id) {
	
	            var project = this.getProjectById(id);
	            var index = this.filteredProjects.indexOf(project);
	            console.log("Render after jumping to Project index " + index + ' of project' + project.id);
	
	            this.$nextTick(function () {
	                _store2.default.commit('setProjectRerender');
	                $("#swipe-detector").scrollTop(this.detectorOffsetY);
	                $("#swipe-detector").scrollLeft(this.detectorOffsetX);
	
	                console.log("scroll to requested project");
	
	                $('.projects-vertical-track').velocity({ marginTop: -1 * this.windowHeight * index + 'px' }, { easing: 'easeOutQuint', duration: 1, complete: this.handleJumpCompleted.bind(this) });
	            });
	        },
	
	        handleJumpCompleted: function handleJumpCompleted() {
	            this.resetDetector();
	            _store2.default.commit('setProjectsVisible', true);
	        },
	
	        getScrollPositionById: function getScrollPositionById(id) {},
	
	        getProjectById: function getProjectById(id) {
	
	            for (var i = 0; i < this.filteredProjects.length; i++) {
	
	                if (this.filteredProjects[i].id == id) {
	                    return this.filteredProjects[i];
	                }
	            }
	        },
	
	        projectEnd: function projectEnd() {
	
	            console.log('project says end');
	            this.lastMove = Date.now() - 400;
	            this.nextPage();
	        },
	
	        test: function test(e) {
	
	            this.testmsg = e.type;
	        }
	
	    }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            msg: "Wisch mir eine, drück mich, kneif mich ..."
	        };
	    },
	
	
	    methods: {
	
	        test: function test(e) {
	
	            this.msg = e.type;
	        }
	    }
	
	};

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var handleWindowResize = exports.handleWindowResize = function handleWindowResize(_ref) {
	    var commit = _ref.commit,
	        state = _ref.state;
	
	
	    renderProportions(commit, state);
	};
	
	var downloadImage = exports.downloadImage = function downloadImage(_ref2, payload) {
	    var commit = _ref2.commit,
	        state = _ref2.state;
	
	    console.info("Download image " + payload.download);
	    var URL = state.config.downloadBaseUrl + payload.view.directory + '/' + payload.download;
	    state.downloadRequestedImage = URL;
	
	    if (!state.downloadTermsAccepted) {
	        state.downloadTermsVisible = true;
	
	        return false;
	    }
	
	    window.location.assign(URL);
	};
	
	function renderProportions(commit, state) {
	
	    console.info("Render proportions " + Date.now());
	
	    state.layout.height = window.innerHeight;
	    state.layout.width = window.innerWidth;
	
	    var ratio = state.layout.width / state.layout.height;
	    state.layout.ratio = Number(ratio.toFixed(2));
	
	    if (state.layout.ratio < 1) {
	        state.layout.orientation = 'portrait';
	    } else {
	        state.layout.orientation = 'landscape';
	    }
	
	    if (state.layout.width > state.layout.breakpointTablet) {
	        state.layout.type = 'large';
	        var margin = state.layout.margin;
	        state.layout.viewportWidth = state.layout.width - state.layout.sidebarWidth - state.layout.margin;
	        state.layout.viewportHeight = state.layout.height;
	        var gutter = state.layout.margin;
	        state.layout.galleryWidth = state.layoutViewportWidth;
	        state.layout.galleryHeight = state.layout.height - 2 * state.layout.margin;
	        state.offsetTop = 0;
	        state.offsetLeft = 0;
	    }
	
	    if (state.layout.width <= state.layout.breakpointTablet && state.layout.width > state.layout.breakpointMobile) {
	        state.layout.type = 'medium';
	        state.sidebar.status = 0;
	        var margin = 0;
	        var gutter = 20;
	    }
	
	    if (state.layout.width <= state.layout.breakpointMobile) {
	        state.layout.type = 'small';
	        state.sidebar.status = 0;
	        var margin = 0;
	        var gutter = 20;
	    }
	
	    if (state.layout.type == 'small' || state.layout.type == 'medium') {
	
	        if (state.layout.orientation == 'landscape') {
	            state.layout.viewportWidth = state.layout.width - state.layout.mobileSandwichColumn;
	            state.layout.viewportHeight = state.layout.height;
	            state.layout.galleryWidth = state.layout.viewportWidth;
	            state.layout.galleryHeight = state.layout.viewportHeight;
	            state.layout.offsetTop = 0;
	            state.layout.offsetLeft = state.layout.mobileSandwichColumn;
	        }
	
	        if (state.layout.orientation == 'portrait') {
	
	            state.layout.viewportWidth = state.layout.width;
	            state.layout.viewportHeight = state.layout.height - state.layout.mobileSandwichColumn;
	            state.layout.galleryWidth = state.layout.viewportWidth;
	            state.layout.galleryHeight = state.layout.viewportHeight - 40;
	            state.layout.offsetTop = state.layout.mobileSandwichColumn;
	            state.layout.offsetLeft = 0;
	        }
	    }
	
	    var width = state.layout.width - margin * 2;
	    var height = state.layout.height - margin * 2;
	
	    for (var p = 0; p < state.projects.length; p++) {
	        var totalWidth = 0;
	
	        for (var i = 0; i < state.projects[p].images.length; i++) {
	
	            var image = state.projects[p].images[i];
	            var imageRatio = image.width / image.height;
	            var imageRatio = imageRatio.toFixed(2);
	
	            if (i > 0) {
	                state.projects[p].images[i].view.scrollPosition = totalWidth.toFixed(2) + gutter;
	            } else {
	
	                state.projects[p].images[i].view.scrollPosition = 0;
	            }
	
	            if (state.layout.ratio > imageRatio) {
	                state.projects[p].images[i].view.height = height;
	                state.projects[p].images[i].view.width = height * imageRatio;
	            } else {
	
	                state.projects[p].images[i].view.height = width / imageRatio;
	                state.projects[p].images[i].view.width = width;
	
	                if (state.projects[p].images[i].view.height > state.layout.viewportHeight - 40) {
	
	                    state.projects[p].images[i].view.height = state.layout.viewportHeight - 40;
	                    state.projects[p].images[i].view.width = (state.layout.viewportHeight - 40) * imageRatio;
	                } else {
	
	                    state.projects[p].images[i].view.height = width / imageRatio;
	                    state.projects[p].images[i].view.width = width;
	                }
	            }
	
	            state.projects[p].images[i].view.directory = state.projects[p].directory;
	            totalWidth = totalWidth + state.projects[p].images[i].view.width + margin;
	        }
	
	        state.projects[p].view.totalWidth = totalWidth;
	    }
	}
	
	var getCategoryBySlug = exports.getCategoryBySlug = function getCategoryBySlug(_ref3, payload) {
	    var commit = _ref3.commit,
	        state = _ref3.state;
	
	
	    var cat = false;
	    for (var i = 0; i < state.categories.length; i++) {
	        if (state.categories[i].slug == payload) {
	            cat = state.categories[i];
	        }
	    }
	
	    return cat;
	};

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	       value: true
	});
	var getCountGetter = exports.getCountGetter = function getCountGetter(state, getters) {
	       return state.count + " Euro";
	};
	
	var getLayoutRatio = exports.getLayoutRatio = function getLayoutRatio(state, getters) {
	       var ratio = state.layout.width / state.layout.height;
	       return Number(ratio.toFixed(2));
	};
	
	var getWindowMargin = exports.getWindowMargin = function getWindowMargin(state, getters) {
	
	       if (state.layout.type == 'small' || state.layout.type == 'medium') {
	              return 0;
	       }
	       return state.layout.margin;
	};
	
	var getSidebarWidth = exports.getSidebarWidth = function getSidebarWidth(state, getters) {
	
	       if (state.layout.type == 'small' || state.layout.type == 'medium') {
	              return 0;
	       }
	
	       if (state.sidebar.status == 2) {
	
	              return state.sidebar.widthExpanded;
	       }
	       if (state.sidebar.status == 1) {
	
	              return state.sidebar.widthCollapsed;
	       }
	       if (state.sidebar.status < 1) {
	
	              return state.sidebar.widthHidden;
	       }
	
	       return state.sidebar.widthHidden;
	};

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(18);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(103);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function () {
	
	  var vueTouch = {};
	  var Hammer =  true ? __webpack_require__(165) : window.Hammer;
	  var gestures = ['tap', 'pan', 'pinch', 'press', 'rotate', 'swipe'];
	  var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
	  var customEvents = {};
	
	  if (!Hammer) {
	    throw new Error('[vue-touch] cannot locate Hammer.js.');
	  }
	
	  vueTouch.config = {};
	
	  vueTouch.install = function (Vue) {
	
	    Vue.directive('touch', {
	
	      bind: function bind(el, binding) {
	        if (!el.__vueTouch__) {
	          el.__vueTouch__ = {
	            mc: new Hammer.Manager(el),
	            eventHandlers: {}
	          };
	        }
	        var cache = el.__vueTouch__;
	        var mc = cache.mc;
	
	        var event = binding.arg;
	        if (!event) {
	          console.warn('[vue-touch] event type argument is required.');
	        }
	        var recognizerType, recognizer;
	
	        if (customEvents[event]) {
	          var custom = customEvents[event];
	          recognizerType = custom.type;
	          recognizer = new Hammer[capitalize(recognizerType)](custom);
	          recognizer.recognizeWith(mc.recognizers);
	          mc.add(recognizer);
	        } else {
	          for (var i = 0; i < gestures.length; i++) {
	            if (event.indexOf(gestures[i]) === 0) {
	              recognizerType = gestures[i];
	              break;
	            }
	          }
	          if (!recognizerType) {
	            console.warn('[vue-touch] invalid event type: ' + event);
	            return;
	          }
	          recognizer = mc.get(recognizerType);
	          if (!recognizer) {
	            recognizer = new Hammer[capitalize(recognizerType)]();
	
	            recognizer.recognizeWith(mc.recognizers);
	            mc.add(recognizer);
	          }
	
	          var globalOptions = vueTouch.config[recognizerType];
	          if (globalOptions) {
	            guardDirections(globalOptions);
	            recognizer.set(globalOptions);
	          }
	        }
	        update(el, binding);
	      },
	
	      update: update,
	
	      unbind: function unbind(el, binding) {
	
	        var cache = el.__vueTouch__;
	        var mc = cache.mc;
	        var handlers = cache.eventHandlers;
	
	        var event = binding.arg;
	        var oldHandler = handlers[event];
	        if (oldHandler) {
	          mc.off(binding.arg, oldHandler);
	          handlers[event] = null;
	        }
	
	        var allHandlersGone = (0, _keys2.default)(mc.handlers).every(function (key) {
	          return mc.handlers[key].length === 0;
	        });
	        if (allHandlersGone) {
	          mc.destroy();
	
	          el.__vueTouch__ = null;
	        }
	      }
	    });
	  };
	
	  function update(el, binding) {
	
	    var fn = binding.value;
	    var cache = el.__vueTouch__;
	    var mc = cache.mc;
	    var handlers = cache.eventHandlers;
	    var event = binding.arg;
	
	    var oldHandler = handlers[event];
	    if (oldHandler && oldHandler !== fn) {
	      mc.off(event, oldHandler);
	      handlers[event] = null;
	    }
	
	    if (oldHandler !== fn) {
	      if (typeof fn === 'function') {
	        mc.on(event, handlers[event] = fn);
	      } else {
	        handlers[event] = null;
	        console.warn('[vue-touch] invalid handler function for v-touch: ' + this.arg + '="' + fn);
	      }
	    }
	  }
	
	  vueTouch.registerCustomEvent = function (event, options) {
	    options.event = event;
	    customEvents[event] = options;
	  };
	
	  function capitalize(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  function guardDirections(options) {
	    var dir = options.direction;
	    if (typeof dir === 'string') {
	      var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
	      if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
	        options.direction = Hammer[hammerDirection];
	      } else {
	        console.warn('[vue-touch] invalid direction: ' + dir);
	      }
	    }
	  }
	
	  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
	    module.exports = vueTouch;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return vueTouch;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (window.Vue) {
	    window.VueTouch = vueTouch;
	    Vue.use(vueTouch);
	  }
	})();

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(141)();
	// imports
	exports.push([module.id, "@import url(//hello.myfonts.net/count/31112d);", ""]);
	
	// module
	exports.push([module.id, "@font-face{font-family:JohnstonITCStd-Light;src:url(\"/static/font/webfonts/31112D_0_0.eot\");src:url(\"/static/font/webfonts/31112D_0_0.eot?#iefix\") format(\"embedded-opentype\"),url(\"/static/font/webfonts/31112D_0_0.woff2\") format(\"woff2\"),url(\"/static/font/webfonts/31112D_0_0.woff\") format(\"woff\"),url(\"/static/font/webfonts/31112D_0_0.ttf\") format(\"truetype\")}@font-face{font-family:JohnstonITCStd-Bold;src:url(\"/static/font/webfonts/31112D_1_0.eot\");src:url(\"/static/font/webfonts/31112D_1_0.eot?#iefix\") format(\"embedded-opentype\"),url(\"/static/font/webfonts/31112D_1_0.woff2\") format(\"woff2\"),url(\"/static/font/webfonts/31112D_1_0.woff\") format(\"woff\"),url(\"/static/font/webfonts/31112D_1_0.ttf\") format(\"truetype\")}@font-face{font-family:JohnstonITCStd-Medium;src:url(\"/static/font/webfonts/322619_0_0.eot\");src:url(\"/static/font/webfonts/322619_0_0.eot?#iefix\") format(\"embedded-opentype\"),url(\"/static/font/webfonts/322619_0_0.woff2\") format(\"woff2\"),url(\"/static/font/webfonts/322619_0_0.woff\") format(\"woff\"),url(\"/static/font/webfonts/322619_0_0.ttf\") format(\"truetype\")}/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:not-allowed}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}.foundation-mq{font-family:\"small=0em&medium=56.25em&large=64.0625em&xlarge=75em&xxlarge=90em\"}html{font-size:100%;box-sizing:border-box}*,:after,:before{box-sizing:inherit}body{padding:0;margin:0;font-family:JohnstonITCStd-Light,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;line-height:1.5;color:#3c3c46;background:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}img{max-width:100%;height:auto;-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}textarea{height:auto;min-height:50px;border-radius:2px}select{width:100%}#map_canvas embed,#map_canvas img,#map_canvas object,.map_canvas embed,.map_canvas img,.map_canvas object,.mqa-display embed,.mqa-display img,.mqa-display object{max-width:none!important}button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:2px;line-height:1}[data-whatinput=mouse] button{outline:0}.is-visible{display:block!important}.is-hidden{display:none!important}.row{max-width:84.375rem;margin-left:auto;margin-right:auto;display:flex;flex-flow:row wrap}.row .row{margin-left:-.9375rem;margin-right:-.9375rem}@media screen and (min-width:56.25em){.row .row{margin-left:-2.5rem;margin-right:-2.5rem}}.row.expanded{max-width:none}.row.collapse>.column,.row.collapse>.columns{padding-left:0;padding-right:0}.row.collapse>.column>.row,.row.collapse>.columns>.row,.row.is-collapse-child{margin-left:0;margin-right:0}.column,.columns{flex:1 1 0px;padding-left:.9375rem;padding-right:.9375rem;min-width:0}@media screen and (min-width:56.25em){.column,.columns{padding-left:2.5rem;padding-right:2.5rem}}.column.row.row,.row.row.columns{float:none;display:block}.row .column.row.row,.row .row.row.columns{padding-left:0;padding-right:0;margin-left:0;margin-right:0}.small-1{flex:0 0 8.33333%;max-width:8.33333%}.small-offset-0{margin-left:0}.small-2{flex:0 0 16.66667%;max-width:16.66667%}.small-offset-1{margin-left:8.33333%}.small-3{flex:0 0 25%;max-width:25%}.small-offset-2{margin-left:16.66667%}.small-4{flex:0 0 33.33333%;max-width:33.33333%}.small-offset-3{margin-left:25%}.small-5{flex:0 0 41.66667%;max-width:41.66667%}.small-offset-4{margin-left:33.33333%}.small-6{flex:0 0 50%;max-width:50%}.small-offset-5{margin-left:41.66667%}.small-7{flex:0 0 58.33333%;max-width:58.33333%}.small-offset-6{margin-left:50%}.small-8{flex:0 0 66.66667%;max-width:66.66667%}.small-offset-7{margin-left:58.33333%}.small-9{flex:0 0 75%;max-width:75%}.small-offset-8{margin-left:66.66667%}.small-10{flex:0 0 83.33333%;max-width:83.33333%}.small-offset-9{margin-left:75%}.small-11{flex:0 0 91.66667%;max-width:91.66667%}.small-offset-10{margin-left:83.33333%}.small-12{flex:0 0 100%;max-width:100%}.small-offset-11{margin-left:91.66667%}.small-up-1{flex-wrap:wrap}.small-up-1>.column,.small-up-1>.columns{flex:0 0 100%;max-width:100%}.small-up-2{flex-wrap:wrap}.small-up-2>.column,.small-up-2>.columns{flex:0 0 50%;max-width:50%}.small-up-3{flex-wrap:wrap}.small-up-3>.column,.small-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.small-up-4{flex-wrap:wrap}.small-up-4>.column,.small-up-4>.columns{flex:0 0 25%;max-width:25%}.small-up-5{flex-wrap:wrap}.small-up-5>.column,.small-up-5>.columns{flex:0 0 20%;max-width:20%}.small-up-6{flex-wrap:wrap}.small-up-6>.column,.small-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.small-up-7{flex-wrap:wrap}.small-up-7>.column,.small-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.small-up-8{flex-wrap:wrap}.small-up-8>.column,.small-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}.small-collapse>.column,.small-collapse>.columns{padding-left:0;padding-right:0}.small-uncollapse>.column,.small-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}@media screen and (min-width:56.25em){.medium-1{flex:0 0 8.33333%;max-width:8.33333%}.medium-offset-0{margin-left:0}.medium-2{flex:0 0 16.66667%;max-width:16.66667%}.medium-offset-1{margin-left:8.33333%}.medium-3{flex:0 0 25%;max-width:25%}.medium-offset-2{margin-left:16.66667%}.medium-4{flex:0 0 33.33333%;max-width:33.33333%}.medium-offset-3{margin-left:25%}.medium-5{flex:0 0 41.66667%;max-width:41.66667%}.medium-offset-4{margin-left:33.33333%}.medium-6{flex:0 0 50%;max-width:50%}.medium-offset-5{margin-left:41.66667%}.medium-7{flex:0 0 58.33333%;max-width:58.33333%}.medium-offset-6{margin-left:50%}.medium-8{flex:0 0 66.66667%;max-width:66.66667%}.medium-offset-7{margin-left:58.33333%}.medium-9{flex:0 0 75%;max-width:75%}.medium-offset-8{margin-left:66.66667%}.medium-10{flex:0 0 83.33333%;max-width:83.33333%}.medium-offset-9{margin-left:75%}.medium-11{flex:0 0 91.66667%;max-width:91.66667%}.medium-offset-10{margin-left:83.33333%}.medium-12{flex:0 0 100%;max-width:100%}.medium-offset-11{margin-left:91.66667%}.medium-order-1{order:1}.medium-order-2{order:2}.medium-order-3{order:3}.medium-order-4{order:4}.medium-order-5{order:5}.medium-order-6{order:6}.medium-up-1{flex-wrap:wrap}.medium-up-1>.column,.medium-up-1>.columns{flex:0 0 100%;max-width:100%}.medium-up-2{flex-wrap:wrap}.medium-up-2>.column,.medium-up-2>.columns{flex:0 0 50%;max-width:50%}.medium-up-3{flex-wrap:wrap}.medium-up-3>.column,.medium-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.medium-up-4{flex-wrap:wrap}.medium-up-4>.column,.medium-up-4>.columns{flex:0 0 25%;max-width:25%}.medium-up-5{flex-wrap:wrap}.medium-up-5>.column,.medium-up-5>.columns{flex:0 0 20%;max-width:20%}.medium-up-6{flex-wrap:wrap}.medium-up-6>.column,.medium-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.medium-up-7{flex-wrap:wrap}.medium-up-7>.column,.medium-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.medium-up-8{flex-wrap:wrap}.medium-up-8>.column,.medium-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width:56.25em) and (min-width:56.25em){.medium-expand{flex:1 1 0px}}.row.medium-unstack>.column,.row.medium-unstack>.columns{flex:0 0 100%}@media screen and (min-width:56.25em){.row.medium-unstack>.column,.row.medium-unstack>.columns{flex:1 1 0px}}@media screen and (min-width:56.25em){.medium-collapse>.column,.medium-collapse>.columns{padding-left:0;padding-right:0}.medium-uncollapse>.column,.medium-uncollapse>.columns{padding-left:2.5rem;padding-right:2.5rem}}@media screen and (min-width:64.0625em){.large-1{flex:0 0 8.33333%;max-width:8.33333%}.large-offset-0{margin-left:0}.large-2{flex:0 0 16.66667%;max-width:16.66667%}.large-offset-1{margin-left:8.33333%}.large-3{flex:0 0 25%;max-width:25%}.large-offset-2{margin-left:16.66667%}.large-4{flex:0 0 33.33333%;max-width:33.33333%}.large-offset-3{margin-left:25%}.large-5{flex:0 0 41.66667%;max-width:41.66667%}.large-offset-4{margin-left:33.33333%}.large-6{flex:0 0 50%;max-width:50%}.large-offset-5{margin-left:41.66667%}.large-7{flex:0 0 58.33333%;max-width:58.33333%}.large-offset-6{margin-left:50%}.large-8{flex:0 0 66.66667%;max-width:66.66667%}.large-offset-7{margin-left:58.33333%}.large-9{flex:0 0 75%;max-width:75%}.large-offset-8{margin-left:66.66667%}.large-10{flex:0 0 83.33333%;max-width:83.33333%}.large-offset-9{margin-left:75%}.large-11{flex:0 0 91.66667%;max-width:91.66667%}.large-offset-10{margin-left:83.33333%}.large-12{flex:0 0 100%;max-width:100%}.large-offset-11{margin-left:91.66667%}.large-order-1{order:1}.large-order-2{order:2}.large-order-3{order:3}.large-order-4{order:4}.large-order-5{order:5}.large-order-6{order:6}.large-up-1{flex-wrap:wrap}.large-up-1>.column,.large-up-1>.columns{flex:0 0 100%;max-width:100%}.large-up-2{flex-wrap:wrap}.large-up-2>.column,.large-up-2>.columns{flex:0 0 50%;max-width:50%}.large-up-3{flex-wrap:wrap}.large-up-3>.column,.large-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.large-up-4{flex-wrap:wrap}.large-up-4>.column,.large-up-4>.columns{flex:0 0 25%;max-width:25%}.large-up-5{flex-wrap:wrap}.large-up-5>.column,.large-up-5>.columns{flex:0 0 20%;max-width:20%}.large-up-6{flex-wrap:wrap}.large-up-6>.column,.large-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.large-up-7{flex-wrap:wrap}.large-up-7>.column,.large-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.large-up-8{flex-wrap:wrap}.large-up-8>.column,.large-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width:64.0625em) and (min-width:64.0625em){.large-expand{flex:1 1 0px}}.row.large-unstack>.column,.row.large-unstack>.columns{flex:0 0 100%}@media screen and (min-width:64.0625em){.row.large-unstack>.column,.row.large-unstack>.columns{flex:1 1 0px}}@media screen and (min-width:64.0625em){.large-collapse>.column,.large-collapse>.columns{padding-left:0;padding-right:0}.large-uncollapse>.column,.large-uncollapse>.columns{padding-left:2.5rem;padding-right:2.5rem}}@media screen and (min-width:75em){.xlarge-1{flex:0 0 8.33333%;max-width:8.33333%}.xlarge-offset-0{margin-left:0}.xlarge-2{flex:0 0 16.66667%;max-width:16.66667%}.xlarge-offset-1{margin-left:8.33333%}.xlarge-3{flex:0 0 25%;max-width:25%}.xlarge-offset-2{margin-left:16.66667%}.xlarge-4{flex:0 0 33.33333%;max-width:33.33333%}.xlarge-offset-3{margin-left:25%}.xlarge-5{flex:0 0 41.66667%;max-width:41.66667%}.xlarge-offset-4{margin-left:33.33333%}.xlarge-6{flex:0 0 50%;max-width:50%}.xlarge-offset-5{margin-left:41.66667%}.xlarge-7{flex:0 0 58.33333%;max-width:58.33333%}.xlarge-offset-6{margin-left:50%}.xlarge-8{flex:0 0 66.66667%;max-width:66.66667%}.xlarge-offset-7{margin-left:58.33333%}.xlarge-9{flex:0 0 75%;max-width:75%}.xlarge-offset-8{margin-left:66.66667%}.xlarge-10{flex:0 0 83.33333%;max-width:83.33333%}.xlarge-offset-9{margin-left:75%}.xlarge-11{flex:0 0 91.66667%;max-width:91.66667%}.xlarge-offset-10{margin-left:83.33333%}.xlarge-12{flex:0 0 100%;max-width:100%}.xlarge-offset-11{margin-left:91.66667%}.xlarge-order-1{order:1}.xlarge-order-2{order:2}.xlarge-order-3{order:3}.xlarge-order-4{order:4}.xlarge-order-5{order:5}.xlarge-order-6{order:6}.xlarge-up-1{flex-wrap:wrap}.xlarge-up-1>.column,.xlarge-up-1>.columns{flex:0 0 100%;max-width:100%}.xlarge-up-2{flex-wrap:wrap}.xlarge-up-2>.column,.xlarge-up-2>.columns{flex:0 0 50%;max-width:50%}.xlarge-up-3{flex-wrap:wrap}.xlarge-up-3>.column,.xlarge-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.xlarge-up-4{flex-wrap:wrap}.xlarge-up-4>.column,.xlarge-up-4>.columns{flex:0 0 25%;max-width:25%}.xlarge-up-5{flex-wrap:wrap}.xlarge-up-5>.column,.xlarge-up-5>.columns{flex:0 0 20%;max-width:20%}.xlarge-up-6{flex-wrap:wrap}.xlarge-up-6>.column,.xlarge-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.xlarge-up-7{flex-wrap:wrap}.xlarge-up-7>.column,.xlarge-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.xlarge-up-8{flex-wrap:wrap}.xlarge-up-8>.column,.xlarge-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width:75em) and (min-width:75em){.xlarge-expand{flex:1 1 0px}}.row.xlarge-unstack>.column,.row.xlarge-unstack>.columns{flex:0 0 100%}@media screen and (min-width:75em){.row.xlarge-unstack>.column,.row.xlarge-unstack>.columns{flex:1 1 0px}}@media screen and (min-width:75em){.xlarge-collapse>.column,.xlarge-collapse>.columns{padding-left:0;padding-right:0}.xlarge-uncollapse>.column,.xlarge-uncollapse>.columns{padding-left:2.5rem;padding-right:2.5rem}}@media screen and (min-width:90em){.xxlarge-1{flex:0 0 8.33333%;max-width:8.33333%}.xxlarge-offset-0{margin-left:0}.xxlarge-2{flex:0 0 16.66667%;max-width:16.66667%}.xxlarge-offset-1{margin-left:8.33333%}.xxlarge-3{flex:0 0 25%;max-width:25%}.xxlarge-offset-2{margin-left:16.66667%}.xxlarge-4{flex:0 0 33.33333%;max-width:33.33333%}.xxlarge-offset-3{margin-left:25%}.xxlarge-5{flex:0 0 41.66667%;max-width:41.66667%}.xxlarge-offset-4{margin-left:33.33333%}.xxlarge-6{flex:0 0 50%;max-width:50%}.xxlarge-offset-5{margin-left:41.66667%}.xxlarge-7{flex:0 0 58.33333%;max-width:58.33333%}.xxlarge-offset-6{margin-left:50%}.xxlarge-8{flex:0 0 66.66667%;max-width:66.66667%}.xxlarge-offset-7{margin-left:58.33333%}.xxlarge-9{flex:0 0 75%;max-width:75%}.xxlarge-offset-8{margin-left:66.66667%}.xxlarge-10{flex:0 0 83.33333%;max-width:83.33333%}.xxlarge-offset-9{margin-left:75%}.xxlarge-11{flex:0 0 91.66667%;max-width:91.66667%}.xxlarge-offset-10{margin-left:83.33333%}.xxlarge-12{flex:0 0 100%;max-width:100%}.xxlarge-offset-11{margin-left:91.66667%}.xxlarge-order-1{order:1}.xxlarge-order-2{order:2}.xxlarge-order-3{order:3}.xxlarge-order-4{order:4}.xxlarge-order-5{order:5}.xxlarge-order-6{order:6}.xxlarge-up-1{flex-wrap:wrap}.xxlarge-up-1>.column,.xxlarge-up-1>.columns{flex:0 0 100%;max-width:100%}.xxlarge-up-2{flex-wrap:wrap}.xxlarge-up-2>.column,.xxlarge-up-2>.columns{flex:0 0 50%;max-width:50%}.xxlarge-up-3{flex-wrap:wrap}.xxlarge-up-3>.column,.xxlarge-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.xxlarge-up-4{flex-wrap:wrap}.xxlarge-up-4>.column,.xxlarge-up-4>.columns{flex:0 0 25%;max-width:25%}.xxlarge-up-5{flex-wrap:wrap}.xxlarge-up-5>.column,.xxlarge-up-5>.columns{flex:0 0 20%;max-width:20%}.xxlarge-up-6{flex-wrap:wrap}.xxlarge-up-6>.column,.xxlarge-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.xxlarge-up-7{flex-wrap:wrap}.xxlarge-up-7>.column,.xxlarge-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.xxlarge-up-8{flex-wrap:wrap}.xxlarge-up-8>.column,.xxlarge-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width:90em) and (min-width:90em){.xxlarge-expand{flex:1 1 0px}}.row.xxlarge-unstack>.column,.row.xxlarge-unstack>.columns{flex:0 0 100%}@media screen and (min-width:90em){.row.xxlarge-unstack>.column,.row.xxlarge-unstack>.columns{flex:1 1 0px}}@media screen and (min-width:90em){.xxlarge-collapse>.column,.xxlarge-collapse>.columns{padding-left:0;padding-right:0}.xxlarge-uncollapse>.column,.xxlarge-uncollapse>.columns{padding-left:2.5rem;padding-right:2.5rem}}.shrink{flex:0 0 auto;max-width:100%}.align-top.columns,.column.align-top{align-self:flex-start}.align-bottom.columns,.column.align-bottom{align-self:flex-end}.align-middle.columns,.column.align-middle{align-self:center}.align-stretch.columns,.column.align-stretch{align-self:stretch}blockquote,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,pre,td,th,ul{margin:0;padding:0}p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}em,i{font-style:italic}b,em,i,strong{line-height:inherit}b,strong{font-weight:700}small{font-size:80%;line-height:inherit}h1,h2,h3,h4,h5,h6{font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;color:inherit;text-rendering:optimizeLegibility;margin-top:0;margin-bottom:.5rem;line-height:1.4}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{color:#d3dce6;line-height:0}h1{font-size:1.5rem}h2{font-size:1.25rem}h3{font-size:1.1875rem}h4{font-size:1.125rem}h5{font-size:1.0625rem}h6{font-size:1rem}@media screen and (min-width:56.25em){h1{font-size:3rem}h2{font-size:2.5rem}h3{font-size:1.9375rem}h4{font-size:1.5625rem}h5{font-size:1.25rem}h6{font-size:1rem}}a{color:#3c3c46;text-decoration:none;line-height:inherit;cursor:pointer}a:focus,a:hover{color:#34343c}a img{border:0}hr{max-width:84.375rem;height:0;border-right:0;border-top:0;border-bottom:1px solid #d3dce6;border-left:0;margin:1.25rem auto;clear:both}dl,ol,ul{line-height:1.6;margin-bottom:1rem;list-style-position:outside}li{font-size:inherit}ul{list-style-type:disc}ol,ul{margin-left:1.25rem}ol ol,ol ul,ul ol,ul ul{margin-left:1.25rem;margin-bottom:0}dl{margin-bottom:1rem}dl dt{margin-bottom:.3rem;font-weight:700}blockquote{margin:0 0 1rem;padding:.5625rem 1.25rem 0 1.1875rem;border-left:1px solid #d3dce6}blockquote,blockquote p{line-height:1.6;color:#8492a6}cite{display:block;font-size:.8125rem;color:#8492a6}cite:before{content:\"\\2014    \"}abbr{color:#3c3c46;cursor:help;border-bottom:1px dotted #3c3c46}code{font-weight:400;border:1px solid #d3dce6;padding:.125rem .3125rem .0625rem}code,kbd{font-family:Consolas,Liberation Mono,Courier,monospace;color:#3c3c46;background-color:#fdfdfd}kbd{padding:.125rem .25rem 0;margin:0;border-radius:2px}.subheader{margin-top:.2rem;margin-bottom:.5rem;font-weight:400;line-height:1.4;color:#8492a6}.lead{font-size:125%;line-height:1.6}.stat{font-size:2.5rem;line-height:1}p+.stat{margin-top:-1rem}.no-bullet{margin-left:0;list-style:none}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}@media screen and (min-width:56.25em){.medium-text-left{text-align:left}.medium-text-right{text-align:right}.medium-text-center{text-align:center}.medium-text-justify{text-align:justify}}@media screen and (min-width:64.0625em){.large-text-left{text-align:left}.large-text-right{text-align:right}.large-text-center{text-align:center}.large-text-justify{text-align:justify}}@media screen and (min-width:75em){.xlarge-text-left{text-align:left}.xlarge-text-right{text-align:right}.xlarge-text-center{text-align:center}.xlarge-text-justify{text-align:justify}}@media screen and (min-width:90em){.xxlarge-text-left{text-align:left}.xxlarge-text-right{text-align:right}.xxlarge-text-center{text-align:center}.xxlarge-text-justify{text-align:justify}}.show-for-print{display:none!important}@media print{*{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}.show-for-print{display:block!important}.hide-for-print{display:none!important}table.show-for-print{display:table!important}thead.show-for-print{display:table-header-group!important}tbody.show-for-print{display:table-row-group!important}tr.show-for-print{display:table-row!important}td.show-for-print,th.show-for-print{display:table-cell!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}.ir a:after,a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}abbr[title]:after{content:\" (\" attr(title) \")\"}blockquote,pre{border:1px solid #8492a6;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}@page{margin:.5cm}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}[type=color],[type=date],[type=datetime-local],[type=datetime],[type=email],[type=month],[type=number],[type=password],[type=search],[type=tel],[type=text],[type=time],[type=url],[type=week],textarea{display:block;box-sizing:border-box;width:100%;height:2.4375rem;padding:.5rem;border:1px solid #d3dce6;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#3c3c46;background-color:#fff;box-shadow:inset 0 0 0 rgba(60,60,70,.1);border-radius:2px;transition:box-shadow .5s,border-color .25s ease-in-out;-webkit-appearance:none;-moz-appearance:none}[type=color]:focus,[type=date]:focus,[type=datetime-local]:focus,[type=datetime]:focus,[type=email]:focus,[type=month]:focus,[type=number]:focus,[type=password]:focus,[type=search]:focus,[type=tel]:focus,[type=text]:focus,[type=time]:focus,[type=url]:focus,[type=week]:focus,textarea:focus{border:1px solid #8492a6;background-color:#fff;outline:none;box-shadow:0 0 0 #d3dce6;transition:box-shadow .5s,border-color .25s ease-in-out}textarea{max-width:100%}textarea[rows]{height:auto}input::placeholder,textarea::placeholder{color:#fdfdfd}input:disabled,input[readonly],textarea:disabled,textarea[readonly]{background-color:#fdfdfd;cursor:not-allowed}[type=button],[type=submit]{border-radius:2px;-webkit-appearance:none;-moz-appearance:none}input[type=search]{box-sizing:border-box}[type=checkbox],[type=file],[type=radio]{margin:0 0 1rem}[type=checkbox]+label,[type=radio]+label{display:inline-block;margin-left:.5rem;margin-right:1rem;margin-bottom:0;vertical-align:baseline}[type=checkbox]+label[for],[type=radio]+label[for]{cursor:pointer}label>[type=checkbox],label>[type=radio]{margin-right:.5rem}[type=file]{width:100%}label{display:block;margin:0;font-size:.8125rem;font-weight:400;line-height:2;color:#8492a6}label.middle{margin:0 0 1rem;padding:.5625rem 0}.help-text{margin-top:-.5rem;font-size:.8125rem;font-style:italic;color:#3c3c46}.input-group{display:flex;width:100%;margin-bottom:1rem;align-items:stretch}.input-group>:first-child{border-radius:2px 0 0 2px}.input-group>:last-child>*{border-radius:0 2px 2px 0}.input-group-button,.input-group-field,.input-group-label{margin:0;white-space:nowrap}.input-group-label{text-align:center;padding:0 1rem;background:#fdfdfd;color:#3c3c46;border:1px solid #fdfdfd;white-space:nowrap;flex:0 0 auto;display:flex;align-items:center}.input-group-label:first-child{border-right:0}.input-group-label:last-child{border-left:0}.input-group-field{border-radius:0;flex:1 1 0px;height:auto}.input-group-button{padding-top:0;padding-bottom:0;text-align:center;flex:0 0 auto}.input-group-button a,.input-group-button button,.input-group-button input{margin:0}fieldset{border:0;padding:0;margin:0}legend{margin-bottom:.5rem;max-width:100%}.fieldset{border:1px solid #d3dce6;padding:1.25rem;margin:1.125rem 0}.fieldset legend{background:#fff;padding:0 .1875rem;margin:0;margin-left:-.1875rem}select{height:2.4375rem;padding:.5rem;border:1px solid #d3dce6;margin:0 0 1rem;font-size:1rem;font-family:inherit;line-height:normal;color:#3c3c46;background-color:#fff;border-radius:2px;-webkit-appearance:none;-moz-appearance:none;background-image:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28132, 146, 166%29'></polygon></svg>\");background-size:9px 6px;background-position:right -1rem center;background-origin:content-box;background-repeat:no-repeat;padding-right:1.5rem}@media screen and (min-width:0\\0){select{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNrEkckNgDAMBBfRkEt0ObRBBdsGXUDgmQfK4XhH2m8czQAAy27R3tsw4Qfe2x8uOO6oYLb6GlOor3GF+swURAOmUJ+RwtEJs9WvTGEYxBXqI1MQAZhCfUQKRzDMVj+TwrAIV6jvSUEkYAr1LSkcyTBb/V+KYfX7xAeusq3sLDtGH3kEGACPWIflNZfhRQAAAABJRU5ErkJggg==\")}}select:disabled{background-color:#fdfdfd;cursor:not-allowed}select::-ms-expand{display:none}select[multiple]{height:auto;background-image:none}.is-invalid-input:not(:focus){background-color:rgba(236,88,64,.1);border-color:#ec5840}.form-error,.is-invalid-label{color:#ec5840}.form-error{display:none;margin-top:-.5rem;margin-bottom:1rem;font-size:.75rem;font-weight:700}.form-error.is-visible{display:block}.button{display:inline-block;text-align:center;line-height:1;cursor:pointer;-webkit-appearance:none;transition:background-color .25s ease-out,color .25s ease-out;vertical-align:middle;border:1px solid transparent;border-radius:2px;padding:.85em 1em;margin:0 0 1rem;font-size:.9rem;background-color:#dc0000;color:#fff}[data-whatinput=mouse] .button{outline:0}.button:focus,.button:hover{background-color:#b00;color:#fff}.button.tiny{font-size:.6rem}.button.small{font-size:.75rem}.button.large{font-size:1.25rem}.button.expanded{display:block;width:100%;margin-left:0;margin-right:0}.button.primary{background-color:#dc0000;color:#fff}.button.primary:focus,.button.primary:hover{background-color:#b00000;color:#fff}.button.secondary{background-color:#777;color:#fff}.button.secondary:focus,.button.secondary:hover{background-color:#5f5f5f;color:#fff}.button.caution{background-color:#ff6908;color:#fff}.button.caution:focus,.button.caution:hover{background-color:#d25300;color:#fff}.button.success{background-color:#3adb76;color:#fff}.button.success:focus,.button.success:hover{background-color:#22bb5b;color:#fff}.button.warning{background-color:#ff4949;color:#3c3c46}.button.warning:focus,.button.warning:hover{background-color:#ff0707;color:#3c3c46}.button.alert{background-color:#ec5840;color:#fff}.button.alert:focus,.button.alert:hover{background-color:#da3116;color:#fff}.button.hollow{border:1px solid #dc0000;color:#dc0000}.button.hollow,.button.hollow:focus,.button.hollow:hover{background-color:transparent}.button.hollow:focus,.button.hollow:hover{border-color:#6e0000;color:#6e0000}.button.hollow.primary{border:1px solid #dc0000;color:#dc0000}.button.hollow.primary:focus,.button.hollow.primary:hover{border-color:#6e0000;color:#6e0000}.button.hollow.secondary{border:1px solid #777;color:#777}.button.hollow.secondary:focus,.button.hollow.secondary:hover{border-color:#3c3c3c;color:#3c3c3c}.button.hollow.caution{border:1px solid #ff6908;color:#ff6908}.button.hollow.caution:focus,.button.hollow.caution:hover{border-color:#843400;color:#843400}.button.hollow.success{border:1px solid #3adb76;color:#3adb76}.button.hollow.success:focus,.button.hollow.success:hover{border-color:#157539;color:#157539}.button.hollow.warning{border:1px solid #ff4949;color:#ff4949}.button.hollow.warning:focus,.button.hollow.warning:hover{border-color:#a40000;color:#a40000}.button.hollow.alert{border:1px solid #ec5840;color:#ec5840}.button.hollow.alert:focus,.button.hollow.alert:hover{border-color:#881f0e;color:#881f0e}.button.disabled,.button[disabled]{opacity:.25;cursor:not-allowed}.button.disabled:focus,.button.disabled:hover,.button[disabled]:focus,.button[disabled]:hover{background-color:#dc0000;color:#fff}.button.disabled.primary,.button[disabled].primary{opacity:.25;cursor:not-allowed}.button.disabled.primary:focus,.button.disabled.primary:hover,.button[disabled].primary:focus,.button[disabled].primary:hover{background-color:#dc0000;color:#fff}.button.disabled.secondary,.button[disabled].secondary{opacity:.25;cursor:not-allowed}.button.disabled.secondary:focus,.button.disabled.secondary:hover,.button[disabled].secondary:focus,.button[disabled].secondary:hover{background-color:#777;color:#fff}.button.disabled.caution,.button[disabled].caution{opacity:.25;cursor:not-allowed}.button.disabled.caution:focus,.button.disabled.caution:hover,.button[disabled].caution:focus,.button[disabled].caution:hover{background-color:#ff6908;color:#fff}.button.disabled.success,.button[disabled].success{opacity:.25;cursor:not-allowed}.button.disabled.success:focus,.button.disabled.success:hover,.button[disabled].success:focus,.button[disabled].success:hover{background-color:#3adb76;color:#fff}.button.disabled.warning,.button[disabled].warning{opacity:.25;cursor:not-allowed}.button.disabled.warning:focus,.button.disabled.warning:hover,.button[disabled].warning:focus,.button[disabled].warning:hover{background-color:#ff4949;color:#fff}.button.disabled.alert,.button[disabled].alert{opacity:.25;cursor:not-allowed}.button.disabled.alert:focus,.button.disabled.alert:hover,.button[disabled].alert:focus,.button[disabled].alert:hover{background-color:#ec5840;color:#fff}.button.dropdown:after{content:\"\";display:block;width:0;height:0;border:.4em inset;border-color:#fff transparent transparent;border-top-style:solid;border-bottom-width:0;position:relative;top:.4em;float:right;margin-left:1em;display:inline-block}.button.arrow-only:after{margin-left:0;float:none;top:-.1em}.accordion{list-style-type:none;background:#fff;margin-left:0}.accordion-item:first-child>:first-child{border-radius:2px 2px 0 0}.accordion-item:last-child>:last-child{border-radius:0 0 2px 2px}.accordion-title{display:block;padding:1.25rem 1rem;line-height:1;font-size:.75rem;color:#dc0000;position:relative;border:1px solid #fdfdfd;border-bottom:0}:last-child:not(.is-active)>.accordion-title{border-radius:0 0 2px 2px;border-bottom:1px solid #fdfdfd}.accordion-title:focus,.accordion-title:hover{background-color:#fdfdfd}.accordion-title:before{content:\"+\";position:absolute;right:1rem;top:50%;margin-top:-.5rem}.is-active>.accordion-title:before{content:\"\\2013\"}.accordion-content{padding:1rem;display:none;border:1px solid #fdfdfd;border-bottom:0;background-color:#fff;color:#3c3c46}:last-child>.accordion-content:last-child{border-bottom:1px solid #fdfdfd}.is-accordion-submenu-parent>a{position:relative}.is-accordion-submenu-parent>a:after{content:\"\";display:block;width:0;height:0;border:6px inset;border-color:#dc0000 transparent transparent;border-top-style:solid;border-bottom-width:0;position:absolute;top:50%;margin-top:-4px;right:1rem}.is-accordion-submenu-parent[aria-expanded=true]>a:after{transform-origin:50% 50%;transform:scaleY(-1)}.badge{display:inline-block;padding:.3em;min-width:2.1em;font-size:.6rem;text-align:center;border-radius:50%;background:#dc0000;color:#fff}.badge.secondary{background:#777;color:#fff}.badge.caution{background:#ff6908;color:#fff}.badge.success{background:#3adb76;color:#fff}.badge.warning{background:#ff4949;color:#3c3c46}.badge.alert{background:#ec5840;color:#fff}.breadcrumbs{list-style:none;margin:0 0 1rem}.breadcrumbs:after,.breadcrumbs:before{content:\" \";display:table;flex-basis:0;order:1}.breadcrumbs:after{clear:both}.breadcrumbs li{float:left;color:#3c3c46;font-size:.6875rem;cursor:default;text-transform:uppercase}.breadcrumbs li:not(:last-child):after{color:#d3dce6;content:\"/\";margin:0 .75rem;position:relative;top:1px;opacity:1}.breadcrumbs a{color:#dc0000}.breadcrumbs a:hover{text-decoration:underline}.breadcrumbs .disabled{color:#d3dce6;cursor:not-allowed}.button-group{margin-bottom:1rem;display:flex;flex-wrap:nowrap;align-items:stretch}.button-group:after,.button-group:before{content:\" \";display:table;flex-basis:0;order:1}.button-group:after{clear:both}.button-group .button{margin:0;margin-right:1px;margin-bottom:1px;font-size:.9rem;flex:0 0 auto}.button-group .button:last-child{margin-right:0}.button-group.tiny .button{font-size:.6rem}.button-group.small .button{font-size:.75rem}.button-group.large .button{font-size:1.25rem}.button-group.expanded .button{flex:1 1 0px}.button-group.primary .button{background-color:#dc0000;color:#fff}.button-group.primary .button:focus,.button-group.primary .button:hover{background-color:#b00000;color:#fff}.button-group.secondary .button{background-color:#777;color:#fff}.button-group.secondary .button:focus,.button-group.secondary .button:hover{background-color:#5f5f5f;color:#fff}.button-group.caution .button{background-color:#ff6908;color:#fff}.button-group.caution .button:focus,.button-group.caution .button:hover{background-color:#d25300;color:#fff}.button-group.success .button{background-color:#3adb76;color:#fff}.button-group.success .button:focus,.button-group.success .button:hover{background-color:#22bb5b;color:#fff}.button-group.warning .button{background-color:#ff4949;color:#3c3c46}.button-group.warning .button:focus,.button-group.warning .button:hover{background-color:#ff0707;color:#3c3c46}.button-group.alert .button{background-color:#ec5840;color:#fff}.button-group.alert .button:focus,.button-group.alert .button:hover{background-color:#da3116;color:#fff}.button-group.stacked,.button-group.stacked-for-medium,.button-group.stacked-for-small{flex-wrap:wrap}.button-group.stacked-for-medium .button,.button-group.stacked-for-small .button,.button-group.stacked .button{flex:0 0 100%}.button-group.stacked-for-medium .button:last-child,.button-group.stacked-for-small .button:last-child,.button-group.stacked .button:last-child{margin-bottom:0}@media screen and (min-width:56.25em){.button-group.stacked-for-small .button{flex:1 1 0px;margin-bottom:0}}@media screen and (min-width:64.0625em){.button-group.stacked-for-medium .button{flex:1 1 0px;margin-bottom:0}}@media screen and (max-width:56.1875em){.button-group.stacked-for-small.expanded{display:block}.button-group.stacked-for-small.expanded .button{display:block;margin-right:0}}.callout{margin:0 0 1rem;padding:1rem;border:1px solid #fdfdfd;border-radius:2px;position:relative;color:#3c3c46;background-color:#fff}.callout>:first-child{margin-top:0}.callout>:last-child{margin-bottom:0}.callout.primary{background-color:#ffd4d4}.callout.secondary{background-color:#ebebeb}.callout.caution{background-color:#ffe9da}.callout.success{background-color:#e1faea}.callout.warning{background-color:#ffe4e4}.callout.alert{background-color:#fce6e2}.callout.small{padding:.5rem}.callout.large{padding:3rem}.close-button{position:absolute;color:#8492a6;right:1rem;top:.5rem;font-size:2em;line-height:1;cursor:pointer}[data-whatinput=mouse] .close-button{outline:0}.close-button:focus,.close-button:hover{color:#3c3c46}.menu{margin:0;list-style-type:none;width:100%;display:flex;align-items:center;flex-wrap:nowrap}[data-whatinput=mouse] .menu>li{outline:0}.menu>li>a{display:block;padding:.7rem 1rem;line-height:1}.menu a,.menu button,.menu input{margin-bottom:0}.menu>li>a{display:flex;flex-flow:row nowrap}.menu>li>a i,.menu>li>a img,.menu>li>a svg{margin-right:.25rem}.menu>li{flex:0 0 auto}.menu.vertical{flex-wrap:wrap}.menu.vertical>li{flex:0 0 100%;max-width:100%}.menu.vertical>li>a{align-items:flex-start;justify-content:flex-start}@media screen and (min-width:56.25em){.menu.medium-horizontal{flex-wrap:nowrap}.menu.medium-horizontal>li{flex:0 0 auto}.menu.medium-vertical{flex-wrap:wrap}.menu.medium-vertical>li{flex:0 0 100%;max-width:100%}.menu.medium-vertical>li>a{align-items:flex-start;justify-content:flex-start}}@media screen and (min-width:64.0625em){.menu.large-horizontal{flex-wrap:nowrap}.menu.large-horizontal>li{flex:0 0 auto}.menu.large-vertical{flex-wrap:wrap}.menu.large-vertical>li{flex:0 0 100%;max-width:100%}.menu.large-vertical>li>a{align-items:flex-start;justify-content:flex-start}}@media screen and (min-width:75em){.menu.xlarge-horizontal{flex-wrap:nowrap}.menu.xlarge-horizontal>li{flex:0 0 auto}.menu.xlarge-vertical{flex-wrap:wrap}.menu.xlarge-vertical>li{flex:0 0 100%;max-width:100%}.menu.xlarge-vertical>li>a{align-items:flex-start;justify-content:flex-start}}@media screen and (min-width:90em){.menu.xxlarge-horizontal{flex-wrap:nowrap}.menu.xxlarge-horizontal>li{flex:0 0 auto}.menu.xxlarge-vertical{flex-wrap:wrap}.menu.xxlarge-vertical>li{flex:0 0 100%;max-width:100%}.menu.xxlarge-vertical>li>a{align-items:flex-start;justify-content:flex-start}}.menu.simple li{line-height:1;display:inline-block;margin-right:1rem}.menu.simple a{padding:0}.menu.align-right{justify-content:flex-end}.menu.expanded>li{flex:1 1 0px}.menu.expanded>li:first-child:last-child{width:100%}.menu.icon-top>li>a{flex-flow:column nowrap}.menu.icon-top>li>a i,.menu.icon-top>li>a img,.menu.icon-top>li>a svg{align-self:stretch;text-align:center;margin-bottom:.25rem}.menu.nested{margin-left:1rem}.menu .active>a{color:#fff;background:#dc0000}.menu-text{font-weight:700;color:inherit;line-height:1;padding-top:0;padding-bottom:0;padding:.7rem 1rem}.menu-centered{text-align:center}.menu-centered>.menu{display:inline-block}.no-js [data-responsive-menu] ul{display:none}.menu-icon{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon:after{content:\"\";position:absolute;display:block;width:100%;height:2px;background:#fff;top:0;left:0;box-shadow:0 7px 0 #fff,0 14px 0 #fff}.menu-icon:hover:after{background:#d3dce6;box-shadow:0 7px 0 #d3dce6,0 14px 0 #d3dce6}.menu-icon.dark{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon.dark:after{content:\"\";position:absolute;display:block;width:100%;height:2px;background:#3c3c46;top:0;left:0;box-shadow:0 7px 0 #3c3c46,0 14px 0 #3c3c46}.menu-icon.dark:hover:after{background:#8492a6;box-shadow:0 7px 0 #8492a6,0 14px 0 #8492a6}.is-drilldown{position:relative;overflow:hidden}.is-drilldown li{display:block!important}.is-drilldown-submenu{position:absolute;top:0;left:100%;z-index:-1;width:100%;background:#fff;transition:transform .15s linear}.is-drilldown-submenu.is-active{z-index:1;display:block;transform:translateX(-100%)}.is-drilldown-submenu.is-closing{transform:translateX(100%)}.is-drilldown-submenu-parent>a{position:relative}.is-drilldown-submenu-parent>a:after{content:\"\";display:block;width:0;height:0;border:6px inset;border-color:transparent transparent transparent #dc0000;border-left-style:solid;border-right-width:0;position:absolute;top:50%;margin-top:-6px;right:1rem}.js-drilldown-back>a:before{content:\"\";display:block;width:0;height:0;border:6px inset;border-color:transparent #dc0000 transparent transparent;border-right-style:solid;border-left-width:0;display:inline-block;vertical-align:middle;margin-right:.75rem}.dropdown-pane{background-color:#fff;border:1px solid #d3dce6;border-radius:2px;display:block;font-size:1rem;padding:1rem;position:absolute;visibility:hidden;width:300px;z-index:10}.dropdown-pane.is-open{visibility:visible}.dropdown-pane.tiny{width:100px}.dropdown-pane.small{width:200px}.dropdown-pane.large{width:400px}.dropdown.menu>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu>li.is-dropdown-submenu-parent>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:#3c3c46 transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}[data-whatinput=mouse] .dropdown.menu a{outline:0}.no-js .dropdown.menu ul{display:none}.dropdown.menu.vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.vertical>li.opens-left>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent #3c3c46 transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.vertical>li.opens-right>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #3c3c46;border-left-style:solid;border-right-width:0}@media screen and (min-width:56.25em){.dropdown.menu.medium-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.medium-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:#3c3c46 transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.medium-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.medium-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.medium-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.medium-vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.medium-vertical>li.opens-left>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent #3c3c46 transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.medium-vertical>li.opens-right>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #3c3c46;border-left-style:solid;border-right-width:0}}@media screen and (min-width:64.0625em){.dropdown.menu.large-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.large-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:#3c3c46 transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.large-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.large-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.large-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.large-vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.large-vertical>li.opens-left>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent #3c3c46 transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.large-vertical>li.opens-right>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #3c3c46;border-left-style:solid;border-right-width:0}}@media screen and (min-width:75em){.dropdown.menu.xlarge-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.xlarge-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.xlarge-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.xlarge-horizontal>li.is-dropdown-submenu-parent>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:#3c3c46 transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.xlarge-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.xlarge-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.xlarge-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.xlarge-vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.xlarge-vertical>li.opens-left>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent #3c3c46 transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.xlarge-vertical>li.opens-right>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #3c3c46;border-left-style:solid;border-right-width:0}}@media screen and (min-width:90em){.dropdown.menu.xxlarge-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.xxlarge-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.xxlarge-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.xxlarge-horizontal>li.is-dropdown-submenu-parent>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:#3c3c46 transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.xxlarge-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.xxlarge-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.xxlarge-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.xxlarge-vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.xxlarge-vertical>li.opens-left>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent #3c3c46 transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.xxlarge-vertical>li.opens-right>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #3c3c46;border-left-style:solid;border-right-width:0}}.dropdown.menu.align-right .is-dropdown-submenu.first-sub{top:100%;left:auto;right:0}.is-dropdown-menu.vertical{width:100px}.is-dropdown-menu.vertical.align-right{float:right}.is-dropdown-submenu-parent{position:relative}.is-dropdown-submenu-parent a:after{position:absolute;top:50%;right:5px;margin-top:-2px}.is-dropdown-submenu-parent.opens-inner>.is-dropdown-submenu{top:100%;left:auto}.is-dropdown-submenu-parent.opens-left>.is-dropdown-submenu{left:auto;right:100%}.is-dropdown-submenu-parent.opens-right>.is-dropdown-submenu{right:auto;left:100%}.is-dropdown-submenu{display:none;position:absolute;top:0;left:100%;min-width:200px;z-index:1;background:#fff;border:1px solid #d3dce6}.is-dropdown-submenu .is-dropdown-submenu-parent>a:after{right:14px;margin-top:-3px}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-left>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent #3c3c46 transparent transparent;border-right-style:solid;border-left-width:0}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-right>a:after{content:\"\";display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #3c3c46;border-left-style:solid;border-right-width:0}.is-dropdown-submenu .is-dropdown-submenu{margin-top:-1px}.is-dropdown-submenu>li{width:100%}.is-dropdown-submenu.js-dropdown-active{display:block}.flex-video{position:relative;height:0;padding-bottom:75%;margin-bottom:1rem;overflow:hidden}.flex-video embed,.flex-video iframe,.flex-video object,.flex-video video{position:absolute;top:0;left:0;width:100%;height:100%}.flex-video.widescreen{padding-bottom:56.25%}.flex-video.vimeo{padding-top:0}.label{display:inline-block;padding:.33333rem .5rem;font-size:.8rem;line-height:1;white-space:nowrap;cursor:default;border-radius:2px;background:#dc0000;color:#fff}.label.secondary{background:#777;color:#fff}.label.caution{background:#ff6908;color:#fff}.label.success{background:#3adb76;color:#fff}.label.warning{background:#ff4949;color:#3c3c46}.label.alert{background:#ec5840;color:#fff}.media-object{margin-bottom:1rem;display:flex;flex-wrap:nowrap}.media-object img{max-width:none}@media screen and (max-width:56.1875em){.media-object.stack-for-small{flex-wrap:wrap}}@media screen and (max-width:56.1875em){.media-object.stack-for-small .media-object-section{padding:0;padding-bottom:1rem;flex-basis:100%;max-width:100%}.media-object.stack-for-small .media-object-section img{width:100%}}.media-object-section{flex:0 1 auto}.media-object-section:first-child{padding-right:1rem}.media-object-section:last-child:not(:nth-child(2)){padding-left:1rem}.media-object-section>:last-child{margin-bottom:0}.media-object-section.main-section{flex:1 1 0px}body,html{height:100%}.off-canvas-wrapper{width:100%;overflow-x:hidden;position:relative;backface-visibility:hidden;-webkit-overflow-scrolling:auto}.off-canvas-wrapper-inner{position:relative;width:100%;min-height:100%;transition:transform .5s ease}.off-canvas-wrapper-inner:after,.off-canvas-wrapper-inner:before{content:\" \";display:table;flex-basis:0;order:1}.off-canvas-wrapper-inner:after{clear:both}.off-canvas-content{min-height:100%;background:#fff;transition:transform .5s ease;backface-visibility:hidden;z-index:1;padding-bottom:.1px;box-shadow:0 0 10px rgba(60,60,70,.5)}.js-off-canvas-exit{display:none;position:absolute;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.25);cursor:pointer;transition:background .5s ease}.off-canvas{position:absolute;background:#fdfdfd;z-index:-1;max-height:100%;overflow-y:auto;transform:translateX(0)}[data-whatinput=mouse] .off-canvas{outline:0}.off-canvas.position-left{left:-250px;top:0;width:250px}.is-open-left{transform:translateX(250px)}.off-canvas.position-right{right:-250px;top:0;width:250px}.is-open-right{transform:translateX(-250px)}@media screen and (min-width:56.25em){.position-left.reveal-for-medium{left:0;z-index:auto;position:fixed}.position-left.reveal-for-medium~.off-canvas-content{margin-left:250px}.position-right.reveal-for-medium{right:0;z-index:auto;position:fixed}.position-right.reveal-for-medium~.off-canvas-content{margin-right:250px}}@media screen and (min-width:64.0625em){.position-left.reveal-for-large{left:0;z-index:auto;position:fixed}.position-left.reveal-for-large~.off-canvas-content{margin-left:250px}.position-right.reveal-for-large{right:0;z-index:auto;position:fixed}.position-right.reveal-for-large~.off-canvas-content{margin-right:250px}}@media screen and (min-width:75em){.position-left.reveal-for-xlarge{left:0;z-index:auto;position:fixed}.position-left.reveal-for-xlarge~.off-canvas-content{margin-left:250px}.position-right.reveal-for-xlarge{right:0;z-index:auto;position:fixed}.position-right.reveal-for-xlarge~.off-canvas-content{margin-right:250px}}@media screen and (min-width:90em){.position-left.reveal-for-xxlarge{left:0;z-index:auto;position:fixed}.position-left.reveal-for-xxlarge~.off-canvas-content{margin-left:250px}.position-right.reveal-for-xxlarge{right:0;z-index:auto;position:fixed}.position-right.reveal-for-xxlarge~.off-canvas-content{margin-right:250px}}.orbit,.orbit-container{position:relative}.orbit-container{margin:0;overflow:hidden;list-style:none}.orbit-slide{width:100%;max-height:100%}.orbit-slide.no-motionui.is-active{top:0;left:0}.orbit-figure{margin:0}.orbit-image{margin:0;width:100%;max-width:100%}.orbit-caption{position:absolute;bottom:0;width:100%;padding:1rem;margin-bottom:0;color:#fff;background-color:rgba(60,60,70,.5)}.orbit-next,.orbit-previous{position:absolute;top:50%;transform:translateY(-50%);z-index:10;padding:1rem;color:#fff}[data-whatinput=mouse] .orbit-next,[data-whatinput=mouse] .orbit-previous{outline:0}.orbit-next:active,.orbit-next:focus,.orbit-next:hover,.orbit-previous:active,.orbit-previous:focus,.orbit-previous:hover{background-color:rgba(60,60,70,.5)}.orbit-previous{left:0}.orbit-next{left:auto;right:0}.orbit-bullets{position:relative;margin-top:.8rem;margin-bottom:.8rem;text-align:center}[data-whatinput=mouse] .orbit-bullets{outline:0}.orbit-bullets button{width:1.2rem;height:1.2rem;margin:.1rem;background-color:#d3dce6;border-radius:50%}.orbit-bullets button.is-active,.orbit-bullets button:hover{background-color:#8492a6}.pagination{margin-left:0;margin-bottom:1rem}.pagination:after,.pagination:before{content:\" \";display:table;flex-basis:0;order:1}.pagination:after{clear:both}.pagination li{font-size:.875rem;margin-right:.0625rem;border-radius:2px;display:none}.pagination li:first-child,.pagination li:last-child{display:inline-block}@media screen and (min-width:56.25em){.pagination li{display:inline-block}}.pagination a,.pagination button{color:#3c3c46;display:block;padding:.1875rem .625rem;border-radius:2px}.pagination a:hover,.pagination button:hover{background:#fdfdfd}.pagination .current{padding:.1875rem .625rem;background:#dc0000;color:#fff;cursor:default}.pagination .disabled{padding:.1875rem .625rem;color:#d3dce6;cursor:not-allowed}.pagination .disabled:hover{background:transparent}.pagination .ellipsis:after{content:\"\\2026\";padding:.1875rem .625rem;color:#3c3c46}.pagination-previous.disabled:before,.pagination-previous a:before{content:\"\\AB\";display:inline-block;margin-right:.5rem}.pagination-next.disabled:after,.pagination-next a:after{content:\"\\BB\";display:inline-block;margin-left:.5rem}.progress{background-color:#d3dce6;height:1rem;margin-bottom:1rem;border-radius:2px}.progress.primary .progress-meter{background-color:#dc0000}.progress.secondary .progress-meter{background-color:#777}.progress.caution .progress-meter{background-color:#ff6908}.progress.success .progress-meter{background-color:#3adb76}.progress.warning .progress-meter{background-color:#ff4949}.progress.alert .progress-meter{background-color:#ec5840}.progress-meter{position:relative;display:block;width:0;height:100%;background-color:#dc0000;border-radius:2px}.progress-meter-text{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute;margin:0;font-size:.75rem;font-weight:700;color:#fff;white-space:nowrap;border-radius:2px}.slider{position:relative;height:.5rem;margin-top:1.25rem;margin-bottom:2.25rem;background-color:#fdfdfd;cursor:pointer;user-select:none;touch-action:none}.slider-fill{position:absolute;top:0;left:0;display:inline-block;max-width:100%;height:.5rem;background-color:#d3dce6;transition:all .2s ease-in-out}.slider-fill.is-dragging{transition:all 0s linear}.slider-handle{top:50%;transform:translateY(-50%);position:absolute;left:0;z-index:1;display:inline-block;width:1.4rem;height:1.4rem;background-color:#dc0000;transition:all .2s ease-in-out;touch-action:manipulation;border-radius:2px}[data-whatinput=mouse] .slider-handle{outline:0}.slider-handle:hover{background-color:#b00}.slider-handle.is-dragging{transition:all 0s linear}.slider.disabled,.slider[disabled]{opacity:.25;cursor:not-allowed}.slider.vertical{display:inline-block;width:.5rem;height:12.5rem;margin:0 1.25rem;transform:scaleY(-1)}.slider.vertical .slider-fill{top:0;width:.5rem;max-height:100%}.slider.vertical .slider-handle{position:absolute;top:0;left:50%;width:1.4rem;height:1.4rem;transform:translateX(-50%)}.sticky-container{position:relative}.sticky{position:absolute;z-index:0;transform:translateZ(0)}.sticky.is-stuck{position:fixed;z-index:5}.sticky.is-stuck.is-at-top{top:0}.sticky.is-stuck.is-at-bottom{bottom:0}.sticky.is-anchored{position:absolute;left:auto;right:auto}.sticky.is-anchored.is-at-bottom{bottom:0}body.is-reveal-open{overflow:hidden}html.is-reveal-open,html.is-reveal-open body{min-height:100%;overflow:hidden;user-select:none}.reveal-overlay{display:none;position:fixed;top:0;bottom:0;left:0;right:0;z-index:1005;background-color:rgba(60,60,70,.45);overflow-y:scroll}.reveal{display:none;z-index:1006;padding:1rem;border:1px solid #d3dce6;background-color:#fff;border-radius:2px;position:relative;top:100px;margin-left:auto;margin-right:auto;overflow-y:auto}[data-whatinput=mouse] .reveal{outline:0}@media screen and (min-width:56.25em){.reveal{min-height:0}}.reveal .column,.reveal .columns{min-width:0}.reveal>:last-child{margin-bottom:0}@media screen and (min-width:56.25em){.reveal{width:600px;max-width:84.375rem}}@media screen and (min-width:56.25em){.reveal .reveal{left:auto;right:auto;margin:0 auto}}.reveal.collapse{padding:0}@media screen and (min-width:56.25em){.reveal.tiny{width:30%;max-width:84.375rem}}@media screen and (min-width:56.25em){.reveal.small{width:50%;max-width:84.375rem}}@media screen and (min-width:56.25em){.reveal.large{width:90%;max-width:84.375rem}}.reveal.full{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}@media screen and (max-width:56.1875em){.reveal{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}}.reveal.without-overlay{position:fixed}.switch{height:2rem;margin-bottom:1rem;outline:0;position:relative;user-select:none;color:#fff;font-weight:700;font-size:.875rem}.switch-input{opacity:0;position:absolute;margin-bottom:0}.switch-paddle{background:#d3dce6;cursor:pointer;display:block;position:relative;width:4rem;height:2rem;transition:all .25s ease-out;border-radius:2px;color:inherit;font-weight:inherit}input+.switch-paddle{margin:0}.switch-paddle:after{background:#fff;content:\"\";display:block;position:absolute;height:1.5rem;left:.25rem;top:.25rem;width:1.5rem;transition:all .25s ease-out;transform:translateZ(0);border-radius:2px}input:checked~.switch-paddle{background:#dc0000}input:checked~.switch-paddle:after{left:2.25rem}[data-whatinput=mouse] input:focus~.switch-paddle{outline:0}.switch-active,.switch-inactive{position:absolute;top:50%;transform:translateY(-50%)}.switch-active{left:8%;display:none}input:checked+label>.switch-active{display:block}.switch-inactive{right:15%}input:checked+label>.switch-inactive{display:none}.switch.tiny{height:1.5rem}.switch.tiny .switch-paddle{width:3rem;height:1.5rem;font-size:.625rem}.switch.tiny .switch-paddle:after{width:1rem;height:1rem}.switch.tiny input:checked~.switch-paddle:after{left:1.75rem}.switch.small{height:1.75rem}.switch.small .switch-paddle{width:3.5rem;height:1.75rem;font-size:.75rem}.switch.small .switch-paddle:after{width:1.25rem;height:1.25rem}.switch.small input:checked~.switch-paddle:after{left:2rem}.switch.large{height:2.5rem}.switch.large .switch-paddle{width:5rem;height:2.5rem;font-size:1rem}.switch.large .switch-paddle:after{width:2rem;height:2rem}.switch.large input:checked~.switch-paddle:after{left:2.75rem}table{width:100%;margin-bottom:1rem;border-radius:2px}tbody,tfoot,thead{border:1px solid #f2f2f2;background-color:#fff}caption{font-weight:700;padding:.5rem .625rem .625rem}thead{background:#f9f9f9}tfoot,thead{color:#3c3c46}tfoot{background:#f2f2f2}tfoot tr,thead tr{background:transparent}tfoot td,tfoot th,thead td,thead th{padding:.5rem .625rem .625rem;font-weight:700;text-align:left}tbody tr:nth-child(2n){background-color:#f2f2f2}tbody td,tbody th{padding:.5rem .625rem .625rem}@media screen and (max-width:64em){table.stack tfoot,table.stack thead{display:none}table.stack td,table.stack th,table.stack tr{display:block}table.stack td{border-top:0}}table.scroll{display:block;width:100%;overflow-x:auto}table.hover thead tr:hover{background-color:#f4f4f4}table.hover tfoot tr:hover{background-color:#ededed}table.hover tbody tr:hover{background-color:#fafafa}table.hover tbody tr:nth-of-type(2n):hover{background-color:#ededed}.table-scroll{overflow-x:auto}.table-scroll table{width:auto}.tabs{margin:0;list-style-type:none;background:#fff;border:1px solid #fdfdfd}.tabs:after,.tabs:before{content:\" \";display:table;flex-basis:0;order:1}.tabs:after{clear:both}.tabs.vertical>li{width:auto;float:none;display:block}.tabs.simple>li>a{padding:0}.tabs.simple>li>a:hover{background:transparent}.tabs.primary{background:#dc0000}.tabs.primary>li>a{color:#fff}.tabs.primary>li>a:focus,.tabs.primary>li>a:hover{background:#d10000}.tabs-title{float:left}.tabs-title>a{display:block;padding:1.25rem 1.5rem;line-height:1;font-size:.75rem}.tabs-title>a:hover{background:#fff}.tabs-title>a:focus,.tabs-title>a[aria-selected=true]{background:#fdfdfd}.tabs-content{background:#fff;transition:all .5s ease;border:1px solid #fdfdfd;border-top:0}.tabs-content.vertical{border:1px solid #fdfdfd;border-left:0}.tabs-panel{display:none;padding:1rem}.tabs-panel.is-active{display:block}.thumbnail{border:4px solid #fff;box-shadow:0 0 0 1px rgba(60,60,70,.2);display:inline-block;line-height:0;max-width:100%;transition:box-shadow .2s ease-out;border-radius:2px;margin-bottom:1rem}.thumbnail:focus,.thumbnail:hover{box-shadow:0 0 6px 1px rgba(220,0,0,.5)}.title-bar{background:#3c3c46;color:#fff;padding:.5rem;display:flex;align-items:center;justify-content:space-between}.title-bar .menu-icon{margin-left:.25rem;margin-right:.25rem}.title-bar-left,.title-bar-right{flex:1 1 0px}.title-bar-right{text-align:right}.title-bar-title{vertical-align:middle}.has-tip,.title-bar-title{font-weight:700;display:inline-block}.has-tip{border-bottom:1px dotted #8492a6;position:relative;cursor:help}.tooltip{background-color:#3c3c46;color:#fff;font-size:80%;padding:.75rem;position:absolute;z-index:10;top:calc(100% + .6495rem);max-width:10rem!important;border-radius:2px}.tooltip:before{border:.75rem inset;border-color:transparent transparent #3c3c46;border-bottom-style:solid;border-top-width:0;bottom:100%;position:absolute;left:50%;transform:translateX(-50%)}.tooltip.top:before,.tooltip:before{content:\"\";display:block;width:0;height:0}.tooltip.top:before{border:.75rem inset;border-color:#3c3c46 transparent transparent;border-top-style:solid;border-bottom-width:0;top:100%;bottom:auto}.tooltip.left:before{border:.75rem inset;border-color:transparent transparent transparent #3c3c46;border-left-style:solid;border-right-width:0;left:100%}.tooltip.left:before,.tooltip.right:before{content:\"\";display:block;width:0;height:0;bottom:auto;top:50%;transform:translateY(-50%)}.tooltip.right:before{border:.75rem inset;border-color:transparent #3c3c46 transparent transparent;border-right-style:solid;border-left-width:0;left:auto;right:100%}.top-bar{display:flex;align-items:center;justify-content:space-between;flex-wrap:nowrap;padding:.5rem;flex-wrap:wrap}.top-bar,.top-bar ul{background-color:#fdfdfd}.top-bar input{max-width:200px;margin-right:1rem}.top-bar .input-group-field{width:100%;margin-right:0}.top-bar input.button{width:auto}.top-bar .top-bar-left,.top-bar .top-bar-right{flex:0 0 100%;max-width:100%}@media screen and (min-width:56.25em){.top-bar{flex-wrap:nowrap}.top-bar .top-bar-left{flex:1 1 auto}.top-bar .top-bar-right{flex:0 1 auto}}@media screen and (max-width:64em){.top-bar.stacked-for-medium{flex-wrap:wrap}.top-bar.stacked-for-medium .top-bar-left,.top-bar.stacked-for-medium .top-bar-right{flex:0 0 100%;max-width:100%}}@media screen and (max-width:74.9375em){.top-bar.stacked-for-large{flex-wrap:wrap}.top-bar.stacked-for-large .top-bar-left,.top-bar.stacked-for-large .top-bar-right{flex:0 0 100%;max-width:100%}}@media screen and (max-width:89.9375em){.top-bar.stacked-for-xlarge{flex-wrap:wrap}.top-bar.stacked-for-xlarge .top-bar-left,.top-bar.stacked-for-xlarge .top-bar-right{flex:0 0 100%;max-width:100%}}.top-bar.stacked-for-xxlarge{flex-wrap:wrap}.top-bar.stacked-for-xxlarge .top-bar-left,.top-bar.stacked-for-xxlarge .top-bar-right{flex:0 0 100%;max-width:100%}.top-bar-title{flex:0 0 auto;margin-right:1rem}.top-bar-left,.top-bar-right{flex:0 0 auto}.hide{display:none!important}.invisible{visibility:hidden}@media screen and (max-width:56.1875em){.hide-for-small-only{display:none!important}}@media screen and (max-width:0em),screen and (min-width:56.25em){.show-for-small-only{display:none!important}}@media screen and (min-width:56.25em){.hide-for-medium{display:none!important}}@media screen and (max-width:56.1875em){.show-for-medium{display:none!important}}@media screen and (min-width:56.25em) and (max-width:64em){.hide-for-medium-only{display:none!important}}@media screen and (max-width:56.1875em),screen and (min-width:64.0625em){.show-for-medium-only{display:none!important}}@media screen and (min-width:64.0625em){.hide-for-large{display:none!important}}@media screen and (max-width:64em){.show-for-large{display:none!important}}@media screen and (min-width:64.0625em) and (max-width:74.9375em){.hide-for-large-only{display:none!important}}@media screen and (max-width:64em),screen and (min-width:75em){.show-for-large-only{display:none!important}}@media screen and (min-width:75em){.hide-for-xlarge{display:none!important}}@media screen and (max-width:74.9375em){.show-for-xlarge{display:none!important}}@media screen and (min-width:75em) and (max-width:89.9375em){.hide-for-xlarge-only{display:none!important}}@media screen and (max-width:74.9375em),screen and (min-width:90em){.show-for-xlarge-only{display:none!important}}@media screen and (min-width:90em){.hide-for-xxlarge{display:none!important}}@media screen and (max-width:89.9375em){.show-for-xxlarge{display:none!important}}@media screen and (min-width:90em){.hide-for-xxlarge-only{display:none!important}}@media screen and (max-width:89.9375em){.show-for-xxlarge-only{display:none!important}}.show-for-sr,.show-on-focus{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)}.show-on-focus:active,.show-on-focus:focus{position:static!important;height:auto;width:auto;overflow:visible;clip:auto}.hide-for-portrait,.show-for-landscape{display:block!important}@media screen and (orientation:landscape){.hide-for-portrait,.show-for-landscape{display:block!important}}@media screen and (orientation:portrait){.hide-for-portrait,.show-for-landscape{display:none!important}}.hide-for-landscape,.show-for-portrait{display:none!important}@media screen and (orientation:landscape){.hide-for-landscape,.show-for-portrait{display:none!important}}@media screen and (orientation:portrait){.hide-for-landscape,.show-for-portrait{display:block!important}}.float-left{float:left!important}.float-right{float:right!important}.float-center{display:block;margin-left:auto;margin-right:auto}.clearfix:after,.clearfix:before{content:\" \";display:table;flex-basis:0;order:1}.clearfix:after{clear:both}.align-right{justify-content:flex-end}.align-center{justify-content:center}.align-justify{justify-content:space-between}.align-spaced{justify-content:space-around}.align-top{align-items:flex-start}.align-self-top{align-self:flex-start}.align-bottom{align-items:flex-end}.align-self-bottom{align-self:flex-end}.align-middle{align-items:center}.align-self-middle{align-self:center}.align-stretch{align-items:stretch}.align-self-stretch{align-self:stretch}.small-order-1{order:1}.small-order-2{order:2}.small-order-3{order:3}.small-order-4{order:4}.small-order-5{order:5}.small-order-6{order:6}@media screen and (min-width:56.25em){.medium-order-1{order:1}.medium-order-2{order:2}.medium-order-3{order:3}.medium-order-4{order:4}.medium-order-5{order:5}.medium-order-6{order:6}}@media screen and (min-width:64.0625em){.large-order-1{order:1}.large-order-2{order:2}.large-order-3{order:3}.large-order-4{order:4}.large-order-5{order:5}.large-order-6{order:6}}@media screen and (min-width:75em){.xlarge-order-1{order:1}.xlarge-order-2{order:2}.xlarge-order-3{order:3}.xlarge-order-4{order:4}.xlarge-order-5{order:5}.xlarge-order-6{order:6}}@media screen and (min-width:90em){.xxlarge-order-1{order:1}.xxlarge-order-2{order:2}.xxlarge-order-3{order:3}.xxlarge-order-4{order:4}.xxlarge-order-5{order:5}.xxlarge-order-6{order:6}}em{font-family:JohnstonITCStd-Light,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif}em,strong{font-weight:400;font-style:normal}strong{font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif}.page-title{margin-top:0;line-height:1em;padding-top:0;font-family:JohnstonITCStd-Bold,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em}.page-title em{text-transform:capitalize}@media screen and (max-width:56.1875em){.page-title{line-height:1.3em;font-size:22px}.page-title em{display:block}}.site-title{font-family:JohnstonITCStd-Bold,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em}.site-title em{text-transform:none}@media screen and (max-width:56.1875em){.site-title em{display:block}}@media screen and (min-width:56.25em) and (max-width:64em){.site-title em{display:block}}a.bold{font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal}#sidebar .main-menu ul{list-style:none;margin-left:25px;margin-top:58px}#sidebar .main-menu ul li{display:none;text-transform:uppercase;letter-spacing:.04em;font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;font-size:14px;margin-bottom:.4em}#sidebar .main-menu ul li.margin-top-medium{margin-top:3em}#sidebar .main-menu ul a{color:#3c3c46;line-height:2em}.sidebar-icon{width:30px}.full-screen-trigger{margin:0;width:30px;margin-left:-5px}.sidebar-cursor{display:block}.sidebar-cursor.cursor-up{margin-bottom:1em}.margin-bottom-small{margin-bottom:.3em}.margin-bottom-medium{margin-bottom:1em}.margin-bottom-large{margin-bottom:3em}.margin-top-small{margin-top:.3em}.margin-top-medium{margin-top:1em}.margin-top-large{margin-top:3em}.margin-top-container{margin-top:40px}.mobile-sandwich{width:30px;margin-left:10px;margin-top:20px}.mobile-navigation{position:fixed;z-index:100007;background:#fff}#mobile-navigation-horizontal{left:0;top:0}#mobile-navigation-vertical{left:0;top:0;padding-left:10px;background:#fff;height:60px}#mobile-navigation-menu{position:fixed;z-index:100005;background:#fff;text-transform:uppercase;letter-spacing:.04em;font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;overflow:scroll}#mobile-navigation-menu ul{list-style:none}@media screen and (max-width:56.1875em){#mobile-navigation-menu ul{font-size:16px;line-height:2.2em}}@media screen and (min-width:56.25em) and (max-width:64em){#mobile-navigation-menu ul{font-size:18px;line-height:2.2em}}#mobile-navigation-menu .mobile-navigation-content.verySmall ul,#mobile-navigation-menu .mobile-navigation-content.verySmall ul a{font-size:15px;line-height:2em}#mobile-navigation-menu .mobile-navigation-content.portrait ul{width:150px;margin:auto}@media screen and (min-width:56.25em) and (max-width:64em){#mobile-navigation-menu .mobile-navigation-content.landscape{margin-top:6em}#mobile-navigation-menu .mobile-navigation-content.landscape li.margin-top-large{margin-top:0}}#sidebar,.icon.mobile.close{width:40px}#sidebar{position:fixed;top:0;left:0;height:100%;overflow:hidden;opacity:0}#sidebar .side-nav{position:absolute;left:25px;bottom:40px}#sidebar .menu-toggle{display:block;margin-left:25px;margin-top:40px}#sidebar .sidebar-cursor{display:block;width:100px;padding-left:20px;margin-left:-20px}#debug{position:fixed;left:10px;top:40px;font-size:12px;z-index:100001;width:8px;display:none}@media screen and (min-width:64.0625em){#mainContent{padding-left:40px}}.component-projects{overflow:hidden;margin-right:0}@media screen and (min-width:64.0625em){.projects-wrapper{margin-right:40px}}.default-content-container{margin-top:38px}#downloadTermsWrapper{transition:all .5s ease;overflow:scroll;position:fixed;z-index:10000000;top:0;left:0;background:#000;opacity:.8}#downloadTermsWrapper h2{text-transform:uppercase;letter-spacing:.04em;font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;margin-bottom:1em;color:#fff}#downloadTermsWrapper p{font-size:20px;color:#fff}#downloadTermsWrapper .button-area{margin-bottom:100px}#downloadTermsWrapper .button-area a{display:inline-block;color:#fff;padding:0 2em}.small-screen{padding-top:10px;padding-left:1em}.small-screen.portrait-sandwich{position:fixed;z-index:100005;height:50px;background:#fff;top:0;left:0}.project-container{white-space:nowrap;position:relative}.project-container .project-slide-track{white-space:nowrap}.project-container .slide{display:inline-block;position:relative;overflow:visible}@media screen and (max-width:56.1875em){.project-container .slide{vertical-align:top}}@media screen and (min-width:56.25em) and (max-width:64em){.project-container .slide{vertical-align:top}}.project-container .slide .download-trigger-container{position:absolute;z-index:10;bottom:-33px;display:block;right:-8px}.project-container .slide .download-trigger-container img{width:30px}.project-info-line{position:absolute;bottom:0;width:500px}.project-info-line .project-info{font-size:14px;padding-top:8px;background:#fff;overflow:hidden;white-space:normal;z-index:1000;line-height:40px;padding-right:1em;padding-bottom:10px;margin-right:-4px}.project-info-line .project-info.info-trigger,.project-info-line .project-info.title{font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em}.project-info-mobile{position:absolute;bottom:60px;left:10px}.project-info-mobile .info-trigger,.project-info-mobile .title{font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em}.projects-wrapper{overflow:hidden}.project-frame{position:absolute;top:0;overflow:hidden;background:transparent}.projects-detector{position:absolute;top:0;opacity:0;z-index:100001;overflow:scroll}.projects-detector.left{cursor:url(/static/test/cursor-scroll-left-white.png) 77 77,auto}.projects-detector.right{cursor:url(/static/test/cursor-scroll-right-white.png) 77 20,auto}.projects-detector.up{cursor:url(/static/test/cursor-scroll-up-white.png) 77 20,auto}.projects-detector.down{cursor:url(/static/test/cursor-scroll-down-white.png) 77 80,auto}.projects-swipe-area{position:absolute;opacity:.01;background:#0f0;z-index:100001;overflow:hidden}.homepage-content{background-attachment:fixed;background-size:cover;background-position:bottom;position:relative;text-align:center}.homepage-content.light{color:#fff}.homepage-content .contact-info{position:absolute;top:-30px;left:0;font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em;font-size:14px;padding-top:2px}.homepage-content .contact-info span{padding-right:1em}.homepage-content .homepage-arrow{position:absolute;bottom:30px;width:77px;height:40px;background:url(/static/test/cursor-scroll-down-white.png) no-repeat 50%}@media screen and (max-width:56.1875em){.homepage-content .homepage-arrow{bottom:100px;background-size:50px}}@media screen and (max-width:56.1875em) and (orientation:landscape){.homepage-content .homepage-arrow{bottom:20px;background-size:40px}}.image-overlay{background:#000;opacity:.7;position:absolute;z-index:1000;top:0;left:0}.image-overlay-content{z-index:1001;position:absolute;top:0;left:0;text-align:center;overflow-y:auto;color:#fff;white-space:normal;opacity:0;display:table}.image-overlay-content .overlay-content-cell{overflow:hidden;display:table-cell;vertical-align:middle;text-align:center}.image-overlay-content .info-title{overflow:hidden;max-width:80%;margin:auto;font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em;font-size:3em}@media screen and (max-width:56.1875em){.image-overlay-content .info-title{font-size:1.2em}}.image-overlay-content .info-text{max-width:80%;margin:auto;font-size:20px;margin-top:2em;line-height:1.3em;overflow:hidden}@media screen and (max-width:56.1875em){.image-overlay-content .info-text{font-size:14px}}.hidden{display:none}.project-vertical-track::-webkit-scrollbar{width:0!important}.project-vertical-track{-ms-overflow-style:none}.project-info-mobile-landscape{display:block;position:fixed;left:10px;bottom:10px;z-index:1000000;text-transform:uppercase;letter-spacing:.04em}.mobile-project-info-overlay{position:fixed;top:0;left:0;background:#fff;z-index:1000001;text-align:center;overflow:auto}.mobile-project-info-overlay .close{position:absolute;display:block;top:15px;left:10px}.mobile-project-info-overlay .content{white-space:normal;display:table;height:70%;text-align:center;margin:auto}@media screen and (orientation:landscape){.mobile-project-info-overlay .content{padding-right:60px}}.mobile-project-info-overlay .content .content-cell{display:table-cell;vertical-align:middle;text-align:center;padding:2em}@media screen and (min-width:56.25em) and (max-width:64em){.mobile-project-info-overlay .content .content-cell{padding:10em}}.mobile-project-info-overlay .content .title{font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em}.mobile-project-info-overlay .content p{font-size:18px;margin:auto}::-webkit-scrollbar{display:none}*{-ms-overflow-style:none}.index-project{margin-bottom:30px}body{overflow-x:hidden}body.hide-scrollbar{overflow-y:hidden}.index-project-track-wrapper{overflow:hidden;height:165px;position:relative}.index-project-track-wrapper .track-nav{position:absolute;width:30px;height:100px;background:#fff;opacity:.7;height:100%}.index-project-track-wrapper .track-nav img{margin-top:50px}.index-project-track-wrapper .track-nav:hover{opacity:.9}.index-project-track-wrapper .track-nav.track-nav-left{left:0}.index-project-track-wrapper .track-nav.track-nav-right{right:0}.index-project-slide-track{white-space:nowrap;overflow-y:hidden;height:190px;-webkit-overflow-scrolling:touch}.index-project-slide{white-space:normal;display:inline-block;margin-right:10px;text-align:right}.index-project-slide img{height:133px}.index-project-slide .download{height:20px}.index-project-slide .download img{display:inline;height:25px;width:25px}.index-project-info{margin-bottom:.3em;font-size:15px}.index-project-info span{display:inline-block;margin-right:.6em}.index-project-info .index-project-title{font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em}.page-content{margin-top:32px;font-size:20px;margin-bottom:200px}.page-content .row{margin-left:0}.page-content .text-column{padding-left:0}.page-content h2,.page-content h3,.page-content h4{text-transform:uppercase;letter-spacing:.04em}.page-content h3{font-size:26px;margin-bottom:1em}@media screen and (max-width:56.1875em){.page-content h3{font-size:18px}}.page-content.making-of .margin-top-large{margin-top:6em}.page-content.making-of .margin-top-medium{margin-top:2em}@media screen and (max-width:56.1875em){.page-content{font-size:18px}}@media screen and (max-width:56.1875em){.page-content .column.small-12,.page-content .small-12.columns{padding-left:0}}ol.agb>li{list-style:upper-roman;font-family:JohnstonITCStd-Medium,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;text-transform:uppercase;letter-spacing:.04em;font-size:26px}@media screen and (max-width:56.1875em){ol.agb>li{font-size:20px}}@media screen and (min-width:56.25em) and (max-width:64em){ol.agb>li{font-size:20px}}ol.agb>li ol{margin-top:.3em;margin-left:0;padding-left:0;margin-bottom:2em}ol.agb>li ol li{margin-left:-5px;padding-left:10px;margin-bottom:.8em;font-family:JohnstonITCStd-Light,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;letter-spacing:0;text-transform:none;font-size:18px;line-height:1.4em}ol.agb>li ol li ul{margin-top:1em;margin-left:3em}.mobile.landscape{margin-top:20px}.mobile.portrait{margin-top:20px;margin-left:20px}", ""]);
	
	// exports


/***/ }),

/***/ 161:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(140);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(168)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(164)
	
	/* script */
	__vue_exports__ = __webpack_require__(90)
	
	/* template */
	var __vue_template__ = __webpack_require__(188)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ba05136"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(91)
	
	/* template */
	var __vue_template__ = __webpack_require__(182)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(92)
	
	/* template */
	var __vue_template__ = __webpack_require__(187)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(162)
	
	/* script */
	__vue_exports__ = __webpack_require__(93)
	
	/* template */
	var __vue_template__ = __webpack_require__(184)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(94)
	
	/* template */
	var __vue_template__ = __webpack_require__(183)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(95)
	
	/* template */
	var __vue_template__ = __webpack_require__(185)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(163)
	
	/* script */
	__vue_exports__ = __webpack_require__(96)
	
	/* template */
	var __vue_template__ = __webpack_require__(186)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(97)
	
	/* template */
	var __vue_template__ = __webpack_require__(189)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-index default-content-container",
	    class: {
	      landscape: _vm.isLandscape, 'portrait': _vm.isPortrait, mobile: _vm.isMobile
	    }
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Henning Maier-Jantzen "), _c('em', [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-8 text-column"
	  }, _vm._l((_vm.clients), function(category, index) {
	    return _c('div', {
	      staticClass: "margin-bottom-large"
	    }, [_c('h3', [_vm._v(_vm._s(category.name[_vm.lang]))]), _vm._v(" "), _c('p', _vm._l((category.clients), function(c, cindex) {
	      return _c('span', [((!c.link || c.nolink) && !c.url) ? _c('span', [_vm._v(_vm._s(c.name))]) : _vm._e(), _vm._v(" "), (c.link && !c.nolink) ? _c('a', {
	        class: {
	          bold: c.link
	        },
	        on: {
	          "click": function($event) {
	            _vm.openLink(c)
	          }
	        }
	      }, [_vm._v(_vm._s(c.name))]) : _vm._e(), _vm._v(" "), (c.url && !c.link) ? _c('a', {
	        staticClass: "bold",
	        attrs: {
	          "href": c.url,
	          "target": "_blank"
	        }
	      }, [_vm._v(_vm._s(c.name))]) : _vm._e(), _vm._v(" "), (cindex < category.clients.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
	    }), 0)])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.project.type != 'homepage') ? _c('div', {
	    staticClass: "project-container",
	    style: ({
	      height: _vm.windowHeight + 'px'
	    }),
	    attrs: {
	      "id": _vm.project.id
	    }
	  }, [_c('div', {
	    staticClass: "project-slide-track"
	  }, _vm._l((_vm.project.images), function(image, imageIndex) {
	    return _c('project-image', {
	      ref: "images",
	      refInFor: true,
	      attrs: {
	        "image": image,
	        "projectIndex": _vm.index,
	        "project": _vm.project,
	        "imageIndex": imageIndex,
	        "currentSlide": _vm.currentSlide,
	        "showInfo": _vm.showInfoFlag
	      },
	      on: {
	        "ready": _vm.onIsReady,
	        "animation": _vm.onAnimation
	      }
	    })
	  }), 1), _vm._v(" "), (_vm.mobileProjectInfo) ? _c('div', {
	    staticClass: "mobile-project-info-overlay",
	    style: ({
	      width: _vm.layout.width + 'px',
	      height: _vm.layout.height + 'px'
	    })
	  }, [_c('a', {
	    staticClass: "icon close mobile",
	    on: {
	      "click": _vm.hideMobileProjectInfo
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/icons/HMJ-Close_mobil.svg",
	      "alt": "close icon"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "content",
	    style: ({
	      marginLeft: _vm.layout.offsetLeft + 'px',
	      marginTop: _vm.layout.offsetTop + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "content-cell"
	  }, [_c('h4', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.project.title[_vm.lang]))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.project.text[_vm.lang].description) + "\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.layout.type == 'large') ? _c('div', {
	    staticClass: "project-info-line",
	    on: {
	      "click": _vm.showInfo
	    }
	  }, [_c('span', {
	    staticClass: "project-info title"
	  }, [_vm._v(_vm._s(_vm.project.title[_vm.lang]))]), _vm._v(" "), _c('span', {
	    staticClass: "project-info page"
	  }, [_vm._v(_vm._s(_vm.currentSlide + 1) + "/" + _vm._s(_vm.totalImages))]), _vm._v(" "), (_vm.ready) ? _c('a', {
	    staticClass: "project-info info-trigger"
	  }, [_vm._v("Info")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.layout.type != 'large' && _vm.layout.orientation == 'portrait') ? _c('div', {
	    staticClass: "project-info-mobile"
	  }, [(_vm.layout.type == 'medium' && _vm.layout.orientation == 'portrait') ? _c('span', {
	    staticClass: "project-info title"
	  }, [_vm._v(_vm._s(_vm.project.title[_vm.lang]))]) : _vm._e(), _vm._v(" "), (_vm.layout.type == 'medium' && _vm.layout.orientation == 'portrait') ? _c('span', {
	    staticClass: "project-info page"
	  }, [_vm._v(_vm._s(_vm.currentSlide + 1) + "/" + _vm._s(_vm.totalImages))]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'portrait') ? _c('a', {
	    staticClass: "project-info info-trigger portrait",
	    on: {
	      "click": _vm.showMobileProjectInfo
	    }
	  }, [_vm._v("Info")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'landscape' && _vm.layout.type != 'large' && _vm.currentId == _vm.project.id) ? _c('a', {
	    staticClass: "project-info-mobile-landscape ",
	    on: {
	      "click": _vm.showMobileProjectInfo
	    }
	  }, [(_vm.layout.mobileNavigation !== true) ? _c('span', [_vm._v("Info")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.project.type == 'homepage') ? _c('div', {
	    staticClass: " homepage",
	    staticStyle: {
	      "overflow": "hidden"
	    },
	    style: ({
	      height: _vm.windowHeight + 'px',
	      width: _vm.windowWidth + 'px'
	    }),
	    attrs: {
	      "id": _vm.project.id
	    }
	  }, [_c('div', {
	    staticClass: "homepage-content",
	    class: {
	      light: _vm.lightSiteTitle
	    },
	    staticStyle: {
	      "background-image": "url(/static/images/startseite/Highline-Kapuzenturm-2-09-Neu.jpg)",
	      "background-repeat": "no-repeat"
	    },
	    style: ({
	      height: _vm.windowHeight - _vm.windowMargin * 2 + 'px',
	      width: _vm.windowWidth - _vm.windowMargin * 2 + 'px',
	      marginTop: _vm.windowMargin + 'px',
	      backgroundImage: 'url(/static/images/startseite/' + _vm.startImage.file + ')',
	      backgroundPosition: _vm.startImage.position
	    })
	  }, [_vm._m(0), _vm._v(" "), _c('h1', {
	    staticClass: "site-title",
	    style: ({
	      paddingTop: _vm.windowHeight * 0.3 + 'px'
	    })
	  }, [_vm._v("Henning Maier-Jantzen "), _c('em', [_vm._v("Photography")])]), _vm._v(" "), _c('div', {
	    staticClass: "homepage-arrow",
	    style: ({
	      width: _vm.windowWidth - _vm.windowMargin * 2 + 'px'
	    })
	  })])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-info hide-for-small-only hide-for-medium-only"
	  }, [_c('span', [_c('a', {
	    attrs: {
	      "href": "mailto:contact@maier-jantzen.de"
	    }
	  }, [_vm._v("contact@maier-jantzen.de")])]), _vm._v(" "), _c('span', [_c('a', {
	    attrs: {
	      "href": "/seite/contact"
	    }
	  }, [_vm._v("+49 171 19 63 601")])])])
	}]}

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-index default-content-container",
	    class: {
	      landscape: _vm.isLandscape, 'portrait': _vm.isPortrait, mobile: _vm.isMobile
	    }
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Henning Maier-Jantzen "), _c('em', [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), (_vm.slug == 'about') ? _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content[_vm.lang])
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.slug == 'contact') ? _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content[_vm.lang])
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.slug == 'making-of') ? _c('div', {
	    staticClass: "page-content making-of"
	  }, [_vm._l((_vm.content.projects), function(project, index) {
	    return [_c('div', {
	      key: 'project_' + index,
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "columns large-12 small-12 medium-12 text-column",
	      class: {
	        'margin-top-large': index > 0
	      }
	    }, [_c('h3', [_vm._v(_vm._s(project.title[_vm.lang]))])]), _vm._v(" "), _c('div', {
	      staticClass: "columns large-12 small-12 medium-12 text-column"
	    }, [(!project.video && project.image) ? _c('img', {
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "src": project.image
	      }
	    }) : _c('div', [_c('video', {
	      staticStyle: {
	        "background-size": "100% 100%",
	        "width": "100%"
	      },
	      attrs: {
	        "controls": "",
	        "poster": project.image
	      }
	    }, [_c('source', {
	      attrs: {
	        "src": project.video,
	        "type": "video/mp4"
	      }
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tYour browser does not support the video tag.\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
	      staticClass: "columns large-8 small-12 medium-12 text-column margin-top-medium"
	    }, [_vm._v("\n            " + _vm._s(project.description[_vm.lang]) + "\n          ")]), _vm._v(" "), (project.links) ? _c('div', {
	      staticClass: "columns large-8 small-12 medium-12 text-column margin-top-medium"
	    }, _vm._l((project.links), function(link) {
	      return _c('p', [_c('a', {
	        attrs: {
	          "href": link.url,
	          "target": "_blank"
	        }
	      }, [_vm._v(_vm._s(link.text[_vm.lang]))])])
	    }), 0) : _vm._e()])]
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.slug == 'agb') ? _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-12 small-12 text-column"
	  }, [(_vm.lang == 'de') ? _c('h3', [_vm._v("ALLGEMEINE LIEFER- UND GESCHÄFTSBEDINGUNGEN")]) : _vm._e(), _vm._v(" "), (_vm.lang == 'en') ? _c('h3', [_vm._v("GENERAL TERMS AND CONDITIONS OF DELIVERY AND BUSINESS")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "columns large-8 small-12 medium-12 text-column"
	  }, [(_vm.lang == 'de') ? _c('ol', {
	    staticClass: "agb"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.lang == 'en') ? _c('ol', {
	    staticClass: "agb"
	  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.slug == 'privacy-disclaimer') ? _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-12 small-12 text-column"
	  }, [(_vm.lang == 'de') ? _c('h3', [_vm._v("Datenschutzerklärung")]) : _vm._e(), _vm._v(" "), (_vm.lang == 'en') ? _c('h3', [_vm._v("Privacy Disclaimer")]) : _vm._e()]), _vm._v(" "), (_vm.lang == 'de') ? _c('div', {
	    staticClass: "columns large-8 small-12 medium-12 text-column privacy-disclaimer"
	  }, [_c('p', [_vm._v("\n          Wir freuen uns sehr über Ihr Interesse an unserem Unternehmen.\n          Datenschutz hat einen besonders hohen Stellenwert für die\n          Geschäftsleitung der Fotografie Henning Maier-Jantzen. Eine Nutzung\n          der Internetseiten der Fotografie Henning Maier-Jantzen ist\n          grundsätzlich ohne jede Angabe personenbezogener Daten möglich.\n          Sofern eine betroffene Person besondere Services unseres Unternehmens\n          über unsere Internetseite in Anspruch nehmen möchte, könnte jedoch\n          eine Verarbeitung personenbezogener Daten erforderlich werden. Ist\n          die Verarbeitung personenbezogener Daten erforderlich und besteht für\n          eine solche Verarbeitung keine gesetzliche Grundlage, holen wir\n          generell eine Einwilligung der betroffenen Person ein.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Die Verarbeitung personenbezogener Daten, beispielsweise des Namens,\n          der Anschrift, E-Mail-Adresse oder Telefonnummer einer betroffenen\n          Person, erfolgt stets im Einklang mit der Datenschutz-Grundverordnung\n          und in Übereinstimmung mit den für die Fotografie Henning\n          Maier-Jantzen geltenden landesspezifischen Datenschutzbestimmungen.\n          Mittels dieser Datenschutzerklärung möchte unser Unternehmen die\n          Öffentlichkeit über Art, Umfang und Zweck der von uns erhobenen,\n          genutzten und verarbeiteten personenbezogenen Daten informieren.\n          Ferner werden betroffene Personen mittels dieser Datenschutzerklärung\n          über die ihnen zustehenden Rechte aufgeklärt.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Die Fotografie Henning Maier-Jantzen hat als für die Verarbeitung\n          Verantwortlicher zahlreiche technische und organisatorische Maßnahmen\n          umgesetzt, um einen möglichst lückenlosen Schutz der über diese\n          Internetseite verarbeiteten personenbezogenen Daten sicherzustellen.\n          Dennoch können Internetbasierte Datenübertragungen grundsätzlich\n          Sicherheitslücken aufweisen, sodass ein absoluter Schutz nicht\n          gewährleistet werden kann. Aus diesem Grund steht es jeder\n          betroffenen Person frei, personenbezogene Daten auch auf alternativen\n          Wegen, beispielsweise telefonisch, an uns zu übermitteln.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("1. Begriffsbestimmungen")]), _vm._v(" "), _c('p', [_vm._v("\n          Die Datenschutzerklärung der Fotografie Henning Maier-Jantzen beruht\n          auf den Begrifflichkeiten, die durch den Europäischen Richtlinien-\n          und Verordnungsgeber beim Erlass der Datenschutz-Grundverordnung\n          (DS-GVO)  verwendet wurden. Unsere Datenschutzerklärung soll sowohl\n          für die Öffentlichkeit als auch für unsere Kunden und\n          Geschäftspartner einfach lesbar und verständlich sein. Um dies zu\n          gewährleisten, möchten wir vorab die verwendeten Begrifflichkeiten\n          erläutern.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Wir verwenden in dieser Datenschutzerklärung unter anderem die folgenden Begriffe:\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" a)    personenbezogene Daten ")]), _vm._v(" "), _c('p', [_vm._v("\n          Personenbezogene Daten sind alle Informationen, die sich auf eine\n          identifizierte oder identifizierbare natürliche Person (im Folgenden\n          „betroffene Person“) beziehen. Als identifizierbar wird eine natürliche Person\n          angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer\n          Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer\n          Online-Kennung oder zu einem oder mehreren besonderen Merkmalen, die Ausdruck\n          der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen,\n          kulturellen oder sozialen Identität dieser natürlichen Person sind,\n          identifiziert werden kann.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" b)    betroffene Person ")]), _vm._v(" "), _c('p', [_vm._v("\n          Betroffene Person ist jede identifizierte oder identifizierbare natürliche\n          Person, deren personenbezogene Daten von dem für die Verarbeitung\n          Verantwortlichen verarbeitet werden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            c)    Verarbeitung\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Verarbeitung ist jeder mit oder ohne Hilfe automatisierter Verfahren\n          ausgeführte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit\n          personenbezogenen Daten wie das Erheben, das Erfassen, die Organisation, das\n          Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das\n          Abfragen, die Verwendung, die Offenlegung durch Übermittlung, Verbreitung oder\n          eine andere Form der Bereitstellung, den Abgleich oder die Verknüpfung, die\n          Einschränkung, das Löschen oder die Vernichtung.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            d)    Einschränkung der Verarbeitung\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Einschränkung der Verarbeitung ist die Markierung gespeicherter\n          personenbezogener Daten mit dem Ziel, ihre künftige Verarbeitung\n          einzuschränken.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" e)    Profiling ")]), _vm._v(" "), _c('p', [_vm._v("\n          Profiling ist jede Art der automatisierten Verarbeitung personenbezogener\n          Daten, die darin besteht, dass diese personenbezogenen Daten verwendet werden,\n          um bestimmte persönliche Aspekte, die sich auf eine natürliche Person beziehen,\n          zu bewerten, insbesondere, um Aspekte bezüglich Arbeitsleistung,\n          wirtschaftlicher Lage, Gesundheit, persönlicher Vorlieben, Interessen,\n          Zuverlässigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser natürlichen\n          Person zu analysieren oder vorherzusagen.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" f)     Pseudonymisierung ")]), _vm._v(" "), _c('p', [_vm._v("\n          Pseudonymisierung ist die Verarbeitung personenbezogener Daten in einer Weise,\n          auf welche die personenbezogenen Daten ohne Hinzuziehung zusätzlicher\n          Informationen nicht mehr einer spezifischen betroffenen Person zugeordnet\n          werden können, sofern diese zusätzlichen Informationen gesondert aufbewahrt\n          werden und technischen und organisatorischen Maßnahmen unterliegen, die\n          gewährleisten, dass die personenbezogenen Daten nicht einer identifizierten\n          oder identifizierbaren natürlichen Person zugewiesen werden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" g)    Verantwortlicher oder für die Verarbeitung Verantwortlicher ")]), _vm._v(" "), _c('p', [_vm._v("\n          Verantwortlicher oder für die Verarbeitung Verantwortlicher ist die natürliche\n          oder juristische Person, Behörde, Einrichtung oder andere Stelle, die allein\n          oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von\n          personenbezogenen Daten entscheidet. Sind die Zwecke und Mittel dieser\n          Verarbeitung durch das Unionsrecht oder das Recht der Mitgliedstaaten\n          vorgegeben, so kann der Verantwortliche beziehungsweise können die bestimmten\n          Kriterien seiner Benennung nach dem Unionsrecht oder dem Recht der\n          Mitgliedstaaten vorgesehen werden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" h)    Auftragsverarbeiter ")]), _vm._v(" "), _c('p', [_vm._v("\n          Auftragsverarbeiter ist eine natürliche oder juristische Person, Behörde,\n          Einrichtung oder andere Stelle, die personenbezogene Daten im Auftrag des\n          Verantwortlichen verarbeitet.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" i)      Empfänger ")]), _vm._v(" "), _c('p', [_vm._v("\n          Empfänger ist eine natürliche oder juristische Person, Behörde, Einrichtung\n          oder andere Stelle, der personenbezogene Daten offengelegt werden, unabhängig\n          davon, ob es sich bei ihr um einen Dritten handelt oder nicht. Behörden, die im\n          Rahmen eines bestimmten Untersuchungsauftrags nach dem Unionsrecht oder dem\n          Recht der Mitgliedstaaten möglicherweise personenbezogene Daten erhalten,\n          gelten jedoch nicht als Empfänger.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" j)      Dritter ")]), _vm._v(" "), _c('p', [_vm._v("\n          Dritter ist eine natürliche oder juristische Person, Behörde, Einrichtung oder\n          andere Stelle außer der betroffenen Person, dem Verantwortlichen, dem\n          Auftragsverarbeiter und den Personen, die unter der unmittelbaren Verantwortung\n          des Verantwortlichen oder des Auftragsverarbeiters befugt sind, die\n          personenbezogenen Daten zu verarbeiten.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" k)    Einwilligung ")]), _vm._v(" "), _c('p', [_vm._v("\n          Einwilligung ist jede von der betroffenen Person freiwillig für den bestimmten\n          Fall in informierter Weise und unmissverständlich abgegebene Willensbekundung\n          in Form einer Erklärung oder einer sonstigen eindeutigen bestätigenden\n          Handlung, mit der die betroffene Person zu verstehen gibt, dass sie mit der\n          Verarbeitung der sie betreffenden personenbezogenen Daten einverstanden ist.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" l)    Cookie Management der Website")]), _vm._v(" "), _c('p', [_vm._v("\n          Gemäß der europäischen Cookie-Richtlinie ist für das Setzen\n          permanenter Cookies, die anderen Zwecken als der Sicherstellung der\n          korrekten Kommunikation mit dem Webserver dienen, Ihre Zustimmung\n          notwendig, mit Ausnahme für technische unbedingt notwendige Cookies\n          (§ 25 TTDSG).\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            2. Name und Anschrift des für die Verarbeitung Verantwortlichen\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Verantwortlicher im Sinne der Datenschutz-Grundverordnung, sonstiger in den\n          Mitgliedstaaten der Europäischen Union geltenden Datenschutzgesetze und anderer\n          Bestimmungen mit datenschutzrechtlichem Charakter ist die:\n          ")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            3. Erfassung von allgemeinen Daten und Informationen\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Die Internetseite der Fotografie Henning Maier-Jantzen erfasst mit jedem Aufruf\n          der Internetseite durch eine betroffene Person oder ein automatisiertes System\n          eine Reihe von allgemeinen Daten und Informationen. Diese allgemeinen Daten und\n          Informationen werden in den Logfiles des Servers gespeichert. Erfasst werden\n          können die (1) verwendeten Browsertypen und Versionen, (2) das vom zugreifenden\n          System verwendete Betriebssystem, (3) die Internetseite, von welcher ein\n          zugreifendes System auf unsere Internetseite gelangt (sogenannte Referrer), (4)\n          die Unterwebseiten, welche über ein zugreifendes System auf unserer\n          Internetseite angesteuert werden, (5) das Datum und die Uhrzeit eines Zugriffs\n          auf die Internetseite, (6) eine Internet-Protokoll-Adresse (IP-Adresse), (7)\n          der Internet-Service-Provider des zugreifenden Systems und (8) sonstige\n          ähnliche Daten und Informationen, die der Gefahrenabwehr im Falle von Angriffen\n          auf unsere informationstechnologischen Systeme dienen.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Bei der Nutzung dieser allgemeinen Daten und Informationen zieht die Fotografie\n          Henning Maier-Jantzen keine Rückschlüsse auf die betroffene Person. Diese\n          Informationen werden vielmehr benötigt, um (1) die Inhalte unserer\n          Internetseite korrekt auszuliefern, (2) die Inhalte unserer Internetseite sowie\n          die Werbung für diese zu optimieren, (3) die dauerhafte Funktionsfähigkeit\n          unserer informationstechnologischen Systeme und der Technik unserer\n          Internetseite zu gewährleisten sowie (4) um Strafverfolgungsbehörden im Falle\n          eines Cyberangriffes die zur Strafverfolgung notwendigen Informationen\n          bereitzustellen. Diese anonym erhobenen Daten und Informationen werden durch\n          die Fotografie Henning Maier-Jantzen daher einerseits statistisch und ferner\n          mit dem Ziel ausgewertet, den Datenschutz und die Datensicherheit in unserem\n          Unternehmen zu erhöhen, um letztlich ein optimales Schutzniveau für die von uns\n          verarbeiteten personenbezogenen Daten sicherzustellen. Die anonymen Daten der\n          Server-Logfiles werden getrennt von allen durch eine betroffene Person\n          angegebenen personenbezogenen Daten gespeichert.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            4. Routinemäßige Löschung und Sperrung von personenbezogenen Daten\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Der für die Verarbeitung Verantwortliche verarbeitet und speichert\n          personenbezogene Daten der betroffenen Person nur für den Zeitraum, der zur\n          Erreichung des Speicherungszwecks erforderlich ist oder sofern dies durch den\n          Europäischen Richtlinien- und Verordnungsgeber oder einen anderen Gesetzgeber\n          in Gesetzen oder Vorschriften, welchen der für die Verarbeitung Verantwortliche\n          unterliegt, vorgesehen wurde.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Entfällt der Speicherungszweck oder läuft eine vom Europäischen Richtlinien-\n          und Verordnungsgeber oder einem anderen zuständigen Gesetzgeber vorgeschriebene\n          Speicherfrist ab, werden die personenbezogenen Daten routinemäßig und\n          entsprechend den gesetzlichen Vorschriften gesperrt oder gelöscht.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            5. Rechte der betroffenen Person\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" a)    Recht auf Bestätigung ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede betroffene Person hat das vom Europäischen Richtlinien- und\n          Verordnungsgeber eingeräumte Recht, von dem für die Verarbeitung\n          Verantwortlichen eine Bestätigung darüber zu verlangen, ob sie betreffende\n          personenbezogene Daten verarbeitet werden. Möchte eine betroffene Person dieses\n          Bestätigungsrecht in Anspruch nehmen, kann sie sich hierzu jederzeit an unseren\n          Datenschutzbeauftragten oder einen anderen Mitarbeiter des für die Verarbeitung\n          Verantwortlichen wenden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" b)    Recht auf Auskunft ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, jederzeit von\n          dem für die Verarbeitung Verantwortlichen unentgeltliche Auskunft über die zu\n          seiner Person gespeicherten personenbezogenen Daten und eine Kopie dieser\n          Auskunft zu erhalten. Ferner hat der Europäische Richtlinien- und\n          Verordnungsgeber der betroffenen Person Auskunft über folgende Informationen\n          zugestanden:\n          ")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', [_vm._v("\n          Ferner steht der betroffenen Person ein Auskunftsrecht darüber zu, ob\n          personenbezogene Daten an ein Drittland oder an eine internationale\n          Organisation übermittelt wurden. Sofern dies der Fall ist, so steht der\n          betroffenen Person im Übrigen das Recht zu, Auskunft über die geeigneten\n          Garantien im Zusammenhang mit der Übermittlung zu erhalten.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Möchte eine betroffene Person dieses Auskunftsrecht in Anspruch nehmen, kann\n          sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen\n          Mitarbeiter des für die Verarbeitung Verantwortlichen wenden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" c)    Recht auf Berichtigung ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, die\n          unverzügliche Berichtigung sie betreffender unrichtiger personenbezogener Daten\n          zu verlangen. Ferner steht der betroffenen Person das Recht zu, unter\n          Berücksichtigung der Zwecke der Verarbeitung, die Vervollständigung\n          unvollständiger personenbezogener Daten — auch mittels einer ergänzenden\n          Erklärung — zu verlangen.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Möchte eine betroffene Person dieses Berichtigungsrecht in Anspruch nehmen,\n          kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen\n          anderen Mitarbeiter des für die Verarbeitung Verantwortlichen wenden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" d)    Recht auf Löschung (Recht auf Vergessen werden) ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, von dem\n          Verantwortlichen zu verlangen, dass die sie betreffenden personenbezogenen\n          Daten unverzüglich gelöscht werden, sofern einer der folgenden Gründe zutrifft\n          und soweit die Verarbeitung nicht erforderlich ist:\n          ")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', [_vm._v("\n          Sofern einer der oben genannten Gründe zutrifft und eine betroffene Person die\n          Löschung von personenbezogenen Daten, die bei der Fotografie Henning\n          Maier-Jantzen gespeichert sind, veranlassen möchte, kann sie sich hierzu\n          jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des\n          für die Verarbeitung Verantwortlichen wenden. Der Datenschutzbeauftragte der\n          Fotografie Henning Maier-Jantzen oder ein anderer Mitarbeiter wird veranlassen,\n          dass dem Löschverlangen unverzüglich nachgekommen wird.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Wurden die personenbezogenen Daten von der Fotografie Henning Maier-Jantzen\n          öffentlich gemacht und ist unser Unternehmen als Verantwortlicher gemäß Art. 17\n          Abs. 1 DS-GVO zur Löschung der personenbezogenen Daten verpflichtet, so trifft\n          die Fotografie Henning Maier-Jantzen unter Berücksichtigung der verfügbaren\n          Technologie und der Implementierungskosten angemessene Maßnahmen, auch\n          technischer Art, um andere für die Datenverarbeitung Verantwortliche, welche\n          die veröffentlichten personenbezogenen Daten verarbeiten, darüber in Kenntnis\n          zu setzen, dass die betroffene Person von diesen anderen für die\n          Datenverarbeitung Verantwortlichen die Löschung sämtlicher Links zu diesen\n          personenbezogenen Daten oder von Kopien oder Replikationen dieser\n          personenbezogenen Daten verlangt hat, soweit die Verarbeitung nicht\n          erforderlich ist. Der Datenschutzbeauftragte der Fotografie Henning\n          Maier-Jantzen oder ein anderer Mitarbeiter wird im Einzelfall das Notwendige\n          veranlassen.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" e)    Recht auf Einschränkung der Verarbeitung ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, von dem\n          Verantwortlichen die Einschränkung der Verarbeitung zu verlangen, wenn eine der\n          folgenden Voraussetzungen gegeben ist:\n          ")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('p', [_vm._v("\n          Sofern eine der oben genannten Voraussetzungen gegeben ist und eine betroffene\n          Person die Einschränkung von personenbezogenen Daten, die bei der Fotografie\n          Henning Maier-Jantzen gespeichert sind, verlangen möchte, kann sie sich hierzu\n          jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des\n          für die Verarbeitung Verantwortlichen wenden. Der Datenschutzbeauftragte der\n          Fotografie Henning Maier-Jantzen oder ein anderer Mitarbeiter wird die\n          Einschränkung der Verarbeitung veranlassen.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" f)   Cookie Management über MyFonts Counter ")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('strong', [_vm._v(" g)     Recht auf Datenübertragbarkeit ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, die sie\n          betreffenden personenbezogenen Daten, welche durch die betroffene Person einem\n          Verantwortlichen bereitgestellt wurden, in einem strukturierten, gängigen und\n          maschinenlesbaren Format zu erhalten. Sie hat außerdem das Recht, diese Daten\n          einem anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem\n          die personenbezogenen Daten bereitgestellt wurden, zu übermitteln, sofern die\n          Verarbeitung auf der Einwilligung gemäß Art. 6 Abs. 1 Buchstabe a DS-GVO oder\n          Art. 9 Abs. 2 Buchstabe a DS-GVO oder auf einem Vertrag gemäß Art. 6 Abs. 1\n          Buchstabe b DS-GVO beruht und die Verarbeitung mithilfe automatisierter\n          Verfahren erfolgt, sofern die Verarbeitung nicht für die Wahrnehmung einer\n          Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung\n          öffentlicher Gewalt erfolgt, welche dem Verantwortlichen übertragen wurde.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Ferner hat die betroffene Person bei der Ausübung ihres Rechts auf\n          Datenübertragbarkeit gemäß Art. 20 Abs. 1 DS-GVO das Recht, zu erwirken, dass\n          die personenbezogenen Daten direkt von einem Verantwortlichen an einen anderen\n          Verantwortlichen übermittelt werden, soweit dies technisch machbar ist und\n          sofern hiervon nicht die Rechte und Freiheiten anderer Personen beeinträchtigt\n          werden.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Zur Geltendmachung des Rechts auf Datenübertragbarkeit kann sich die betroffene\n          Person jederzeit an den von der Fotografie Henning Maier-Jantzen bestellten\n          Datenschutzbeauftragten oder einen anderen Mitarbeiter wenden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" h)    Recht auf Widerspruch ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, aus Gründen, die\n          sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung\n          sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1\n          Buchstaben e oder f DS-GVO erfolgt, Widerspruch einzulegen. Dies gilt auch für\n          ein auf diese Bestimmungen gestütztes Profiling.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Die Fotografie Henning Maier-Jantzen verarbeitet die personenbezogenen Daten im\n          Falle des Widerspruchs nicht mehr, es sei denn, wir können zwingende\n          schutzwürdige Gründe für die Verarbeitung nachweisen, die den Interessen,\n          Rechten und Freiheiten der betroffenen Person überwiegen, oder die Verarbeitung\n          dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Verarbeitet die Fotografie Henning Maier-Jantzen personenbezogene Daten, um\n          Direktwerbung zu betreiben, so hat die betroffene Person das Recht, jederzeit\n          Widerspruch gegen die Verarbeitung der personenbezogenen Daten zum Zwecke\n          derartiger Werbung einzulegen. Dies gilt auch für das Profiling, soweit es mit\n          solcher Direktwerbung in Verbindung steht. Widerspricht die betroffene Person\n          gegenüber der Fotografie Henning Maier-Jantzen der Verarbeitung für Zwecke der\n          Direktwerbung, so wird die Fotografie Henning Maier-Jantzen die\n          personenbezogenen Daten nicht mehr für diese Zwecke verarbeiten.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Zudem hat die betroffene Person das Recht, aus Gründen, die sich aus ihrer\n          besonderen Situation ergeben, gegen die sie betreffende Verarbeitung\n          personenbezogener Daten, die bei der Fotografie Henning Maier-Jantzen zu\n          wissenschaftlichen oder historischen Forschungszwecken oder zu statistischen\n          Zwecken gemäß Art. 89 Abs. 1 DS-GVO erfolgen, Widerspruch einzulegen, es sei\n          denn, eine solche Verarbeitung ist zur Erfüllung einer im öffentlichen\n          Interesse liegenden Aufgabe erforderlich.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Zur Ausübung des Rechts auf Widerspruch kann sich die betroffene Person direkt\n          an den Datenschutzbeauftragten der Fotografie Henning Maier-Jantzen oder einen\n          anderen Mitarbeiter wenden. Der betroffenen Person steht es ferner frei, im\n          Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft,\n          ungeachtet der Richtlinie 2002/58/EG, ihr Widerspruchsrecht mittels\n          automatisierter Verfahren auszuüben, bei denen technische Spezifikationen\n          verwendet werden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" i)    Automatisierte Entscheidungen im Einzelfall einschließlich Profiling ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, nicht einer\n          ausschließlich auf einer automatisierten Verarbeitung — einschließlich\n          Profiling — beruhenden Entscheidung unterworfen zu werden, die ihr gegenüber\n          rechtliche Wirkung entfaltet oder sie in ähnlicher Weise erheblich\n          beeinträchtigt, sofern die Entscheidung (1) nicht für den Abschluss oder die\n          Erfüllung eines Vertrags zwischen der betroffenen Person und dem\n          Verantwortlichen erforderlich ist, oder (2) aufgrund von Rechtsvorschriften der\n          Union oder der Mitgliedstaaten, denen der Verantwortliche unterliegt, zulässig\n          ist und diese Rechtsvorschriften angemessene Maßnahmen zur Wahrung der Rechte\n          und Freiheiten sowie der berechtigten Interessen der betroffenen Person\n          enthalten oder (3) mit ausdrücklicher Einwilligung der betroffenen Person\n          erfolgt.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Ist die Entscheidung (1) für den Abschluss oder die Erfüllung eines Vertrags\n          zwischen der betroffenen Person und dem Verantwortlichen erforderlich oder (2)\n          erfolgt sie mit ausdrücklicher Einwilligung der betroffenen Person, trifft die\n          Fotografie Henning Maier-Jantzen angemessene Maßnahmen, um die Rechte und\n          Freiheiten sowie die berechtigten Interessen der betroffenen Person zu wahren,\n          wozu mindestens das Recht auf Erwirkung des Eingreifens einer Person seitens\n          des Verantwortlichen, auf Darlegung des eigenen Standpunkts und auf Anfechtung\n          der Entscheidung gehört.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Möchte die betroffene Person Rechte mit Bezug auf automatisierte Entscheidungen\n          geltend machen, kann sie sich hierzu jederzeit an unseren\n          Datenschutzbeauftragten oder einen anderen Mitarbeiter des für die Verarbeitung\n          Verantwortlichen wenden.\n          ")]), _vm._v(" "), _c('strong', [_vm._v(" j)      Recht auf Widerruf einer datenschutzrechtlichen Einwilligung ")]), _vm._v(" "), _c('p', [_vm._v("\n          Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom\n          Europäischen Richtlinien- und Verordnungsgeber gewährte Recht, eine\n          Einwilligung zur Verarbeitung personenbezogener Daten jederzeit zu widerrufen.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Möchte die betroffene Person ihr Recht auf Widerruf einer Einwilligung geltend\n          machen, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder\n          einen anderen Mitarbeiter des für die Verarbeitung Verantwortlichen wenden.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            6. Rechtsgrundlage der Verarbeitung\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Art. 6 I lit. a DS-GVO dient unserem Unternehmen als Rechtsgrundlage für\n          Verarbeitungsvorgänge, bei denen wir eine Einwilligung für einen bestimmten\n          Verarbeitungszweck einholen. Ist die Verarbeitung personenbezogener Daten zur\n          Erfüllung eines Vertrags, dessen Vertragspartei die betroffene Person ist,\n          erforderlich, wie dies beispielsweise bei Verarbeitungsvorgängen der Fall ist,\n          die für eine Lieferung von Waren oder die Erbringung einer sonstigen Leistung\n          oder Gegenleistung notwendig sind, so beruht die Verarbeitung auf Art. 6 I lit.\n          b DS-GVO. Gleiches gilt für solche Verarbeitungsvorgänge die zur Durchführung\n          vorvertraglicher Maßnahmen erforderlich sind, etwa in Fällen von Anfragen zur\n          unseren Produkten oder Leistungen. Unterliegt unser Unternehmen einer\n          rechtlichen Verpflichtung durch welche eine Verarbeitung von personenbezogenen\n          Daten erforderlich wird, wie beispielsweise zur Erfüllung steuerlicher\n          Pflichten, so basiert die Verarbeitung auf Art. 6 I lit. c DS-GVO. In seltenen\n          Fällen könnte die Verarbeitung von personenbezogenen Daten erforderlich werden,\n          um lebenswichtige Interessen der betroffenen Person oder einer anderen\n          natürlichen Person zu schützen. Dies wäre beispielsweise der Fall, wenn ein\n          Besucher in unserem Betrieb verletzt werden würde und daraufhin sein Name, sein\n          Alter, seine Krankenkassendaten oder sonstige lebenswichtige Informationen an\n          einen Arzt, ein Krankenhaus oder sonstige Dritte weitergegeben werden müssten.\n          Dann würde die Verarbeitung auf Art. 6 I lit. d DS-GVO beruhen. Letztlich\n          könnten Verarbeitungsvorgänge auf Art. 6 I lit. f DS-GVO beruhen. Auf dieser\n          Rechtsgrundlage basieren Verarbeitungsvorgänge, die von keiner der vorgenannten\n          Rechtsgrundlagen erfasst werden, wenn die Verarbeitung zur Wahrung eines\n          berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich\n          ist, sofern die Interessen, Grundrechte und Grundfreiheiten des Betroffenen\n          nicht überwiegen. Solche Verarbeitungsvorgänge sind uns insbesondere deshalb\n          gestattet, weil sie durch den Europäischen Gesetzgeber besonders erwähnt\n          wurden. Er vertrat insoweit die Auffassung, dass ein berechtigtes Interesse\n          anzunehmen sein könnte, wenn die betroffene Person ein Kunde des\n          Verantwortlichen ist (Erwägungsgrund 47 Satz 2 DS-GVO).\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            7. Berechtigte Interessen an der Verarbeitung, die von dem Verantwortlichen oder einem Dritten verfolgt werden\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Basiert die Verarbeitung personenbezogener Daten auf Artikel 6 I lit. f DS-GVO\n          ist unser berechtigtes Interesse die Durchführung unserer Geschäftstätigkeit\n          zugunsten des Wohlergehens all unserer Mitarbeiter und unserer Anteilseigner.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            8. Dauer, für die die personenbezogenen Daten gespeichert werden\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Das Kriterium für die Dauer der Speicherung von personenbezogenen Daten ist die\n          jeweilige gesetzliche Aufbewahrungsfrist. Nach Ablauf der Frist werden die\n          entsprechenden Daten routinemäßig gelöscht, sofern sie nicht mehr zur\n          Vertragserfüllung oder Vertragsanbahnung erforderlich sind.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            9. Gesetzliche oder vertragliche Vorschriften zur Bereitstellung der personenbezogenen Daten; Erforderlichkeit für den Vertragsabschluss; Verpflichtung der betroffenen Person, die personenbezogenen Daten bereitzustellen; mögliche Folgen der Nichtbereitstellung\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Wir klären Sie darüber auf, dass die Bereitstellung personenbezogener Daten zum\n          Teil gesetzlich vorgeschrieben ist (z.B. Steuervorschriften) oder sich auch aus\n          vertraglichen Regelungen (z.B. Angaben zum Vertragspartner) ergeben kann.\n          Mitunter kann es zu einem Vertragsschluss erforderlich sein, dass eine\n          betroffene Person uns personenbezogene Daten zur Verfügung stellt, die in der\n          Folge durch uns verarbeitet werden müssen. Die betroffene Person ist\n          beispielsweise verpflichtet uns personenbezogene Daten bereitzustellen, wenn\n          unser Unternehmen mit ihr einen Vertrag abschließt. Eine Nichtbereitstellung\n          der personenbezogenen Daten hätte zur Folge, dass der Vertrag mit dem\n          Betroffenen nicht geschlossen werden könnte. Vor einer Bereitstellung\n          personenbezogener Daten durch den Betroffenen muss sich der Betroffene an\n          unseren Datenschutzbeauftragten wenden. Unser Datenschutzbeauftragter klärt den\n          Betroffenen einzelfallbezogen darüber auf, ob die Bereitstellung der\n          personenbezogenen Daten gesetzlich oder vertraglich vorgeschrieben oder für den\n          Vertragsabschluss erforderlich ist, ob eine Verpflichtung besteht, die\n          personenbezogenen Daten bereitzustellen, und welche Folgen die\n          Nichtbereitstellung der personenbezogenen Daten hätte.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            10. Bestehen einer automatisierten Entscheidungsfindung\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Als verantwortungsbewusstes Unternehmen verzichten wir auf eine automatische\n          Entscheidungsfindung oder ein Profiling.\n          ")]), _vm._v(" "), _vm._m(24)]) : _vm._e(), _vm._v(" "), (_vm.lang == 'en') ? _c('div', {
	    staticClass: "columns large-8 small-12 medium-12 text-column privacy-disclaimer"
	  }, [_c('p', [_vm._v("\n          We are very delighted that you have shown interest in our enterprise.\n          Data protection is of a particularly high priority for the management\n          of the Fotografie Henning Maier-Jantzen. The use of the Internet\n          pages of the Fotografie Henning Maier-Jantzen is possible without any\n          indication of personal data; however, if a data subject wants to use\n          special enterprise services via our website, processing of personal\n          data could become necessary. If the processing of personal data is\n          necessary and there is no statutory basis for such processing, we\n          generally obtain consent from the data subject.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          The processing of personal data, such as the name, address, e-mail\n          address, or telephone number of a data subject shall always be in\n          line with the General Data Protection Regulation (GDPR), and in\n          accordance with the country-specific data protection regulations\n          applicable to the Fotografie Henning Maier-Jantzen. By means of this\n          data protection declaration, our enterprise would like to inform the\n          general public of the nature, scope, and purpose of the personal data\n          we collect, use and process. Furthermore, data subjects are informed,\n          by means of this data protection declaration, of the rights to which\n          they are entitled.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          As the controller, the Fotografie Henning Maier-Jantzen has\n          implemented numerous technical and organizational measures to ensure\n          the most complete protection of personal data processed through this\n          website. However, Internet-based data transmissions may in principle\n          have security gaps, so absolute protection may not be guaranteed. For\n          this reason, every data subject is free to transfer personal data to\n          us via alternative means, e.g. by telephone.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            1. Definitions\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          The data protection declaration of the Fotografie Henning\n          Maier-Jantzen is based on the terms used by the European legislator\n          for the adoption of the General Data Protection Regulation (GDPR).\n          Our data protection declaration should be legible and understandable\n          for the general public, as well as our customers and business\n          partners. To ensure this, we would like to first explain the\n          terminology used.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          In this data protection declaration, we use, inter alia, the\n          following terms:\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            a)    Personal data\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Personal data means any information relating to an identified or\n          identifiable natural person (“data subject”). An identifiable natural\n          person is one who can be identified, directly or indirectly, in\n          particular by reference to an identifier such as a name, an\n          identification number, location data, an online identifier or to one\n          or more factors specific to the physical, physiological, genetic,\n          mental, economic, cultural or social identity of that natural person.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            b) Data subject\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Data subject is any identified or identifiable natural person, whose\n          personal data is processed by the controller responsible for the\n          processing.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            c)    Processing\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Processing is any operation or set of operations which is performed\n          on personal data or on sets of personal data, whether or not by\n          automated means, such as collection, recording, organisation,\n          structuring, storage, adaptation or alteration, retrieval,\n          consultation, use, disclosure by transmission, dissemination or\n          otherwise making available, alignment or combination, restriction,\n          erasure or destruction.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            d)    Restriction of processing\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Restriction of processing is the marking of stored personal data with\n          the aim of limiting their processing in the future.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            e)    Profiling\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Profiling means any form of automated processing of personal data\n          consisting of the use of personal data to evaluate certain personal\n          aspects relating to a natural person, in particular to analyse or\n          predict aspects concerning that natural person's performance at work,\n          economic situation, health, personal preferences, interests,\n          reliability, behaviour, location or movements.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            f)     Pseudonymisation\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Pseudonymisation is the processing of personal data in such a manner\n          that the personal data can no longer be attributed to a specific data\n          subject without the use of additional information, provided that such\n          additional information is kept separately and is subject to technical\n          and organisational measures to ensure that the personal data are not\n          attributed to an identified or identifiable natural person.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            g)    Controller or controller responsible for the processing\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Controller or controller responsible for the processing is the\n          natural or legal person, public authority, agency or other body\n          which, alone or jointly with others, determines the purposes and\n          means of the processing of personal data; where the purposes and\n          means of such processing are determined by Union or Member State law,\n          the controller or the specific criteria for its nomination may be\n          provided for by Union or Member State law.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            h)    Processor\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Processor is a natural or legal person, public authority, agency or\n          other body which processes personal data on behalf of the controller.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            i)      Recipient\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Recipient is a natural or legal person, public authority, agency or\n          another body, to which the personal data are disclosed, whether a\n          third party or not. However, public authorities which may receive\n          personal data in the framework of a particular inquiry in accordance\n          with Union or Member State law shall not be regarded as recipients;\n          the processing of those data by those public authorities shall be in\n          compliance with the applicable data protection rules according to the\n          purposes of the processing.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            j)      Third party\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Third party is a natural or legal person, public authority, agency or\n          body other than the data subject, controller, processor and persons\n          who, under the direct authority of the controller or processor, are\n          authorised to process personal data.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("\n            k)    Consent\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Consent of the data subject is any freely given, specific, informed\n          and unambiguous indication of the data subject's wishes by which he\n          or she, by a statement or by a clear affirmative action, signifies\n          agreement to the processing of personal data relating to him or her.\n          ")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n            2. Name and Address of the controller\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n          Controller for the purposes of the General Data Protection Regulation\n          (GDPR), other data protection laws applicable in Member states of the\n          European Union and other provisions related to data protection is:\n          ")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n  3. Collection of general data and information\n")]), _vm._v(" "), _c('p', [_vm._v("\nThe website of the Fotografie Henning Maier-Jantzen collects a series of\ngeneral data and information when a data subject or automated system calls up\nthe website. This general data and information are stored in the server log\nfiles. Collected may be (1) the browser types and versions used, (2) the\noperating system used by the accessing system, (3) the website from which an\naccessing system reaches our website (so-called referrers), (4) the\nsub-websites, (5) the date and time of access to the Internet site, (6) an\nInternet protocol address (IP address), (7) the Internet service provider of\nthe accessing system, and (8) any other similar data and information that may\nbe used in the event of attacks on our information technology systems.\n")]), _vm._v(" "), _c('p', [_vm._v("\nWhen using these general data and information, the Fotografie Henning\nMaier-Jantzen does not draw any conclusions about the data subject. Rather,\nthis information is needed to (1) deliver the content of our website correctly,\n(2) optimize the content of our website as well as its advertisement, (3)\nensure the long-term viability of our information technology systems and\nwebsite technology, and (4) provide law enforcement authorities with the\ninformation necessary for criminal prosecution in case of a cyber-attack.\nTherefore, the Fotografie Henning Maier-Jantzen analyzes anonymously collected\ndata and information statistically, with the aim of increasing the data\nprotection and data security of our enterprise, and to ensure an optimal level\nof protection for the personal data we process. The anonymous data of the\nserver log files are stored separately from all personal data provided by a\ndata subject.\n")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n  4. Routine erasure and blocking of personal data\n")]), _vm._v(" "), _c('p', [_vm._v("\nThe data controller shall process and store the personal data of the data\nsubject only for the period necessary to achieve the purpose of storage, or as\nfar as this is granted by the European legislator or other legislators in laws\nor regulations to which the controller is subject to.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIf the storage purpose is not applicable, or if a storage period prescribed by\nthe European legislator or another competent legislator expires, the personal\ndata are routinely blocked or erased in accordance with legal requirements.\n")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n  5. Rights of the data subject\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  a) Right of confirmation\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator to\nobtain from the controller the confirmation as to whether or not personal data\nconcerning him or her are being processed. If a data subject wishes to avail\nhimself of this right of confirmation, he or she may, at any time, contact our\nData Protection Officer or another employee of the controller.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  b) Right of access\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator to\nobtain from the controller free information about his or her personal data\nstored at any time and a copy of this information. Furthermore, the European\ndirectives and regulations grant the data subject access to the following\ninformation:\n")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', [_vm._v("\nFurthermore, the data subject shall have a right to obtain information as to\nwhether personal data are transferred to a third country or to an international\norganisation. Where this is the case, the data subject shall have the right to\nbe informed of the appropriate safeguards relating to the transfer.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIf a data subject wishes to avail himself of this right of access, he or she\nmay at any time contact our Data Protection Officer or another employee of the\ncontroller.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  c) Right to rectification\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator to\nobtain from the controller without undue delay the rectification of inaccurate\npersonal data concerning him or her. Taking into account the purposes of the\nprocessing, the data subject shall have the right to have incomplete personal\ndata completed, including by means of providing a supplementary statement.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIf a data subject wishes to exercise this right to rectification, he or she\nmay, at any time, contact our Data Protection Officer or another employee of\nthe controller.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  d) Right to erasure (Right to be forgotten)\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator to\nobtain from the controller the erasure of personal data concerning him or her\nwithout undue delay, and the controller shall have the obligation to erase\npersonal data without undue delay where one of the following grounds applies,\nas long as the processing is not necessary:\n")]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', [_vm._v("\nIf one of the aforementioned reasons applies, and a data subject wishes to\nrequest the erasure of personal data stored by the Fotografie Henning\nMaier-Jantzen, he or she may at any time contact our Data Protection Officer or\nanother employee of the controller. The Data Protection Officer of the\nFotografie Henning Maier-Jantzen or another employee shall promptly ensure that\nthe erasure request is complied with immediately.\n")]), _vm._v(" "), _c('p', [_vm._v("\nWhere the controller has made personal data public and is obliged pursuant to\nArticle 17(1) to erase the personal data, the controller, taking account of\navailable technology and the cost of implementation, shall take reasonable\nsteps, including technical measures, to inform other controllers processing the\npersonal data that the data subject has requested erasure by such controllers\nof any links to, or copy or replication of, those personal data, as far as\nprocessing is not required. The Data Protection Officer of the Fotografie\nHenning Maier-Jantzen or another employee will arrange the necessary measures\nin individual cases.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  e) Right of restriction of processing\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator to\nobtain from the controller restriction of processing where one of the following\napplies:\n")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('p', [_vm._v("\nIf one of the aforementioned conditions is met, and a data subject wishes to\nrequest the restriction of the processing of personal data stored by the\nFotografie Henning Maier-Jantzen, he or she may at any time contact our Data\nProtection Officer or another employee of the controller. The Data Protection\nOfficer of the Fotografie Henning Maier-Jantzen or another employee will\narrange the restriction of the processing.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  f) Right to data portability\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator, to\nreceive the personal data concerning him or her, which was provided to a\ncontroller, in a structured, commonly used and machine-readable format. He or\nshe shall have the right to transmit those data to another controller without\nhindrance from the controller to which the personal data have been provided, as\nlong as the processing is based on consent pursuant to point (a) of Article\n6(1) of the GDPR or point (a) of Article 9(2) of the GDPR, or on a contract\npursuant to point (b) of Article 6(1) of the GDPR, and the processing is\ncarried out by automated means, as long as the processing is not necessary for\nthe performance of a task carried out in the public interest or in the exercise\nof official authority vested in the controller.\n")]), _vm._v(" "), _c('p', [_vm._v("\nFurthermore, in exercising his or her right to data portability pursuant to\nArticle 20(1) of the GDPR, the data subject shall have the right to have\npersonal data transmitted directly from one controller to another, where\ntechnically feasible and when doing so does not adversely affect the rights and\nfreedoms of others.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIn order to assert the right to data portability, the data subject may at any\ntime contact the Data Protection Officer designated by the Fotografie Henning\nMaier-Jantzen or another employee.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  g) Right to object\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator to\nobject, on grounds relating to his or her particular situation, at any time, to\nprocessing of personal data concerning him or her, which is based on point (e)\nor (f) of Article 6(1) of the GDPR. This also applies to profiling based on\nthese provisions.\n")]), _vm._v(" "), _c('p', [_vm._v("\nThe Fotografie Henning Maier-Jantzen shall no longer process the personal data\nin the event of the objection, unless we can demonstrate compelling legitimate\ngrounds for the processing which override the interests, rights and freedoms of\nthe data subject, or for the establishment, exercise or defence of legal\nclaims.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIf the Fotografie Henning Maier-Jantzen processes personal data for direct\nmarketing purposes, the data subject shall have the right to object at any time\nto processing of personal data concerning him or her for such marketing. This\napplies to profiling to the extent that it is related to such direct marketing.\nIf the data subject objects to the Fotografie Henning Maier-Jantzen to the\nprocessing for direct marketing purposes, the Fotografie Henning Maier-Jantzen\nwill no longer process the personal data for these purposes.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIn addition, the data subject has the right, on grounds relating to his or her\nparticular situation, to object to processing of personal data concerning him\nor her by the Fotografie Henning Maier-Jantzen for scientific or historical\nresearch purposes, or for statistical purposes pursuant to Article 89(1) of the\nGDPR, unless the processing is necessary for the performance of a task carried\nout for reasons of public interest.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIn order to exercise the right to object, the data subject may directly contact\nthe Data Protection Officer of the Fotografie Henning Maier-Jantzen or another\nemployee. In addition, the data subject is free in the context of the use of\ninformation society services, and notwithstanding Directive 2002/58/EC, to use\nhis or her right to object by automated means using technical specifications.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  h) Automated individual decision-making, including profiling\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator not\nto be subject to a decision based solely on automated processing, including\nprofiling, which produces legal effects concerning him or her, or similarly\nsignificantly affects him or her, as long as the decision (1) is not is\nnecessary for entering into, or the performance of, a contract between the data\nsubject and a data controller, or (2) is not authorised by Union or Member\nState law to which the controller is subject and which also lays down suitable\nmeasures to safeguard the data subject's rights and freedoms and legitimate\ninterests, or (3) is not based on the data subject's explicit consent.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIf the decision (1) is necessary for entering into, or the performance of, a\ncontract between the data subject and a data controller, or (2) it is based on\nthe data subject's explicit consent, the Fotografie Henning Maier-Jantzen shall\nimplement suitable measures to safeguard the data subject's rights and freedoms\nand legitimate interests, at least the right to obtain human intervention on\nthe part of the controller, to express his or her point of view and contest the\ndecision.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIf the data subject wishes to exercise the rights concerning automated\nindividual decision-making, he or she may at any time directly contact our Data\nProtection Officer of the Fotografie Henning Maier-Jantzen or another employee\nof the controller.\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  i) Right to withdraw data protection consent\n")]), _vm._v(" "), _c('p', [_vm._v("\nEach data subject shall have the right granted by the European legislator to\nwithdraw his or her consent to processing of his or her personal data at any\ntime.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIf the data subject wishes to exercise the right to withdraw the consent, he or\nshe may at any time directly contact our Data Protection Officer of the\nFotografie Henning Maier-Jantzen or another employee of the controller.\n")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n  6. Legal basis for the processing\n")]), _vm._v(" "), _c('p', [_vm._v("\nArt. 6(1) lit. a GDPR serves as the legal basis for processing operations for\nwhich we obtain consent for a specific processing purpose. If the processing of\npersonal data is necessary for the performance of a contract to which the data\nsubject is party, as is the case, for example, when processing operations are\nnecessary for the supply of goods or to provide any other service, the\nprocessing is based on Article 6(1) lit. b GDPR. The same applies to such\nprocessing operations which are necessary for carrying out pre-contractual\nmeasures, for example in the case of inquiries concerning our products or\nservices. Is our company subject to a legal obligation by which processing of\npersonal data is required, such as for the fulfillment of tax obligations, the\nprocessing is based on Art. 6(1) lit. c GDPR. In rare cases, the processing of\npersonal data may be necessary to protect the vital interests of the data\nsubject or of another natural person. This would be the case, for example, if a\nvisitor were injured in our company and his name, age, health insurance data or\nother vital information would have to be passed on to a doctor, hospital or\nother third party. Then the processing would be based on Art. 6(1) lit. d GDPR.\nFinally, processing operations could be based on Article 6(1) lit. f GDPR. This\nlegal basis is used for processing operations which are not covered by any of\nthe abovementioned legal grounds, if processing is necessary for the purposes\nof the legitimate interests pursued by our company or by a third party, except\nwhere such interests are overridden by the interests or fundamental rights and\nfreedoms of the data subject which require protection of personal data. Such\nprocessing operations are particularly permissible because they have been\nspecifically mentioned by the European legislator. He considered that a\nlegitimate interest could be assumed if the data subject is a client of the\ncontroller (Recital 47 Sentence 2 GDPR).\n")]), _vm._v(" "), _c('strong', [_vm._v("\n  7. The legitimate interests pursued by the controller or by a third party\n")]), _vm._v(" "), _c('p', [_vm._v("\nWhere the processing of personal data is based on Article 6(1) lit. f GDPR our\nlegitimate interest is to carry out our business in favor of the well-being of\nall our employees and the shareholders.\n")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n  8. Period for which the personal data will be stored\n")]), _vm._v(" "), _c('p', [_vm._v("\nThe criteria used to determine the period of storage of personal data is the\nrespective statutory retention period. After expiration of that period, the\ncorresponding data is routinely deleted, as long as it is no longer necessary\nfor the fulfillment of the contract or the initiation of a contract.\n")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n  9. Provision of personal data as statutory or contractual requirement; Requirement necessary to enter into a contract; Obligation of the data subject to provide the personal data; possible consequences of failure to provide such data\n")]), _vm._v(" "), _c('p', [_vm._v("\nWe clarify that the provision of personal data is partly required by law (e.g.\ntax regulations) or can also result from contractual provisions (e.g.\ninformation on the contractual partner). Sometimes it may be necessary to\nconclude a contract that the data subject provides us with personal data, which\nmust subsequently be processed by us. The data subject is, for example, obliged\nto provide us with personal data when our company signs a contract with him or\nher. The non-provision of the personal data would have the consequence that the\ncontract with the data subject could not be concluded. Before personal data is\nprovided by the data subject, the data subject must contact our Data Protection\nOfficer. Our Data Protection Officer clarifies to the data subject whether the\nprovision of the personal data is required by law or contract or is necessary\nfor the conclusion of the contract, whether there is an obligation to provide\nthe personal data and the consequences of non-provision of the personal data.\n")]), _vm._v(" "), _c('h3', {
	    staticClass: "margin-top-large"
	  }, [_vm._v("\n  10. Existence of automated decision-making\n")]), _vm._v(" "), _c('p', [_vm._v("\nAs a responsible company, we do not use automatic decision-making or profiling.\n")]), _vm._v(" "), _vm._m(29)]) : _vm._e()])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("GELTUNG\n                    "), _c('ol', [_c('li', [_vm._v("\n                        Die nachfolgenden allgemeinen Liefer- und\n                        Geschäftsbedingungen (im folgenden AGB genannt) gelten\n                        für alle vom Fotografen durchgeführten Aufträge,\n                        Angebote, Lieferungen und Leistungen.\n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Sie gelten als vereinbart mit Entgegennahme der\n                        Lieferung oder Leistung bzw. des Angebots des\n                        Fotografen durch den Kunden, spätestens jedoch mit der\n                        Annahme des Bildmaterials zur Veröffentlichung.\n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Wenn der Kunde den AGB widersprechen will, ist dieses\n                        schriftlich binnen drei Werktagen zu erklären.\n                        Abweichenden Geschäftsbedingungen des Kunden wird\n                        hiermit widersprochen. Abweichende Geschäftsbedingungen\n                        des Kunden erlangen keine Gültigkeit, es sei denn, dass\n                        der Fotograf diese schriftlich anerkennt.\n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Die AGB gelten im Rahmen einer laufenden\n                        Geschäftsbeziehung auch ohne ausdrückliche Einbeziehung\n                        auch für alle zukünftigen Aufträge, Angebote,\n                        Lieferungen und Leistungen des Fotografen, sofern nicht\n                        ausdrücklich abweichende Regelungen getroffen werden.\n                        ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                    AUFTRAGSPRODUKTIONEN\n                        "), _c('ol', [_c('li', [_vm._v("\n                            Soweit der Fotograf Kostenvoranschläge erstellt,\n                            sind diese unverbindlich. Treten während der\n                            Produktion Kostenerhöhungen ein, sind diese erst\n                            dann vom Fotografen anzuzeigen, wenn erkennbar\n                            wird, dass hierdurch eine Überschreitung der\n                            ursprünglich veranschlagten Gesamtkosten um mehr\n                            als 15 % zu erwarten ist. Wird die vorgesehene\n                            Produktionszeit aus Gründen überschritten, die der\n                            Fotograf nicht zu vertreten hat, so ist eine\n                            zusätzliche Vergütung auf der Grundlage des\n                            vereinbarten Zeithonorars bzw. in Form einer\n                            angemessenen Erhöhung des Pauschalhonorars zu\n                            leisten. \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Der Fotograf ist berechtigt, Leistungen von Dritten, die zur Durchführung der Produk-tion eingekauft werden müssen, im Namen und mit Vollmacht sowie für Rechnung des Kunden in Auftrag zu geben.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Vorbehaltlich einer anderweitigen Regelung werden die Aufnahmen, die dem Kunden nach Abschluss der Produktion zur Abnahme vorgelegt werden, durch den Fotografen ausgewählt.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Sind dem Fotografen innerhalb von zwei Wochen nach Ablieferung der Aufnahmen keine schriftlichen Mängelrügen zugegangen, gelten die Aufnahmen als vertragsgemäß und mängelfrei abgenommen.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n\n                    ÜBERLASSENES BILDMATERIAL (ANALOG UND DIGITAL)\n                    "), _c('ol', [_c('li', [_vm._v("\n                                Die AGB gelten für jegliches dem Kunden überlassenes Bildmaterial, gleich in welcher Schaffensstufe oder in welcher technischen Form sie vorliegen. Sie gelten insbesondere auch für elektronisches oder digital übermitteltes Bildmaterial.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Der Kunde erkennt an, dass es sich bei dem vom Fotografen gelieferten Bildmaterial um urheberrechtlich geschützte Lichtbildwerke i.S.v. § 2 Abs. 1 Ziff. 5 Urheberrechtsgesetz handelt.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Vom Kunden in Auftrag gegebene Gestaltungsvorschläge oder Konzeptionen sind eigenständige Leistungen, die zu vergüten sind.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Das überlassene Bildmaterial bleibt Eigentum des Fotografen, und zwar auch in dem Fall, dass Schadensersatz hierfür geleistet wird.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Der Kunde hat das Bildmaterial sorgfältig und pfleglich zu behandeln und darf es an Dritte nur zu geschäftsinternen Zwecken der Sichtung, Auswahl und technischen Verarbeitung weitergeben.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Reklamationen, die den Inhalt der gelieferten Sendung oder Inhalt, Qualität oder Zustand des Bildmaterials betreffen, sind innerhalb von zwei Wochen nach Empfang mit-zuteilen. Anderenfalls gilt das Bildmaterial als ordnungsgemäß, vertragsgemäß und wie verzeichnet zugegangen.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                    NUTZUNGSRECHTE\n                        "), _c('ol', [_c('li', [_vm._v("\n                            Der Kunde erwirbt grundsätzlich nur ein einfaches Nutzungsrecht zur einmaligen Verwendung. Veröffentlichungen im Internet oder die Einstellung in digitale Datenbanken sind vorbehaltlich anderweitiger Vereinbarungen zeitlich begrenzt auf die Dauer der Veröffentlichungszeiträume des entsprechenden bzw. eines vergleichbaren Printobjektes.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Ausschließliche Nutzungsrechte, medienbezogene oder räumliche Exklusivrechte oder Sperrfristen müssen gesondert vereinbart werden und bedingen einen Aufschlag von mindestens 100 % auf das jeweilige Grundhonorar.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Mit der Lieferung wird lediglich das Nutzungsrecht übertragen für die einmalige Nutzung des Bildmaterials zu dem vom Kunden angegebenen Zweck und in der Publikation und in dem Medium oder Datenträger, welche/-s/-n der Kunde angegeben hat oder welche/-s/-r sich aus den Umständen der Auftragserteilung ergibt. Im Zweifelsfall ist maßgeblich der Nutzungszweck, für den das Bildmaterial ausweislich des Lieferscheins oder der Versandadresse zur Verfügung gestellt worden ist.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Jede über Ziffer 3. hinausgehende Nutzung, Verwertung, Vervielfältigung, Verbreitung oder Veröffentlichung ist honorarpflichtig und bedarf der vorherigen ausdrücklichen Zustimmung des Fotografen. Das gilt insbesondere für: \n                                "), _c('ul', [_c('li', [_vm._v("\n                                        eine Zweitverwertung oder Zweitveröffentlichung, insbesondere in Sammelbänden, produktbegleitenden Prospekten, bei Werbemaßnahmen oder bei sonstigen Nachdrucken, jegliche Bearbeitung, Änderung oder Umgestaltung des Bildmaterials,\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                                    die Digitalisierung, Speicherung oder Duplizierung des Bildmaterials auf Datenträgern aller Art (z. B. magnetische, optische, magnetooptische oder elektronische Trägermedien wie CD-ROM, DVD, Festplatten, Arbeitsspeicher, Mikrofilm etc.), soweit dieses nicht nur der technischen Verarbeitung und Verwaltung des Bildmaterials gem. Ziff. III 5. AGB dient, \n                                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                                        jegliche Vervielfältigung oder Nutzung der Bilddaten auf digitalen Datenträgern, jegliche Aufnahme oder Wiedergabe der Bilddaten im Internet oder in Online-Datenbanken oder in anderen elektronischen Archiven (auch soweit es sich um interne elektronische Archive des Kunden handelt),\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                                    die Weitergabe des digitalisierten Bildmaterials im Wege der Datenfernübertragung oder auf Datenträgern, die zur öffentlichen Wiedergabe auf Bildschirmen oder zur Herstellung von Hardcopies geeignet sind.\n                                    ")])])]), _vm._v(" "), _c('li', [_vm._v("\n                            Veränderungen des Bildmaterials durch Foto-Composing, Montage oder durch elektronische Hilfsmittel zur Erstellung eines neuen urheberrechtlich geschützten Werkes sind nur nach vorheriger schriftlicher Zustimmung des Fotografen und nur bei Kennzeichnung mit [M] gestattet. Auch darf das Bildmaterial nicht abgezeichnet, nachgestellt fotografiert oder anderweitig als Motiv benutzt werden.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Der Kunde ist nicht berechtigt, die ihm eingeräumten Nutzungsrechte ganz oder teilweise auf Dritte, auch nicht auf andere Konzern- oder Tochterunternehmen, zu übertragen. Jegliche Nutzung, Wiedergabe oder Weitergabe des Bildmaterials ist nur gestattet unter der Voraussetzung der Anbringung des vom Fotografen vorgegebenen Urhebervermerks in zweifelsfreier Zuordnung zum jeweiligen Bild.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Die Einräumung der Nutzungsrechte steht unter der aufschiebenden Bedingung der vollständigen Bezahlung sämtlicher Zahlungsansprüche des Fotografen aus dem jeweiligen Vertragsverhältnis.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Der Fotograf bleibt auch bei Übertragung der ausschließlichen (exklusiven) Nutzungsrechte berechtigt, seine Fotos zu Zwecken der Eigenwerbung selbst zu verwenden.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                    HAFTUNG\n                        "), _c('ol', [_c('li', [_vm._v("\n                            Der Fotograf übernimmt keine Haftung für die Verletzung von Rechten abgebildeter Kennzeichen (Marken, Firmen Geschmacksmuster) Personen oder Objekte, es sei denn, es wird ein entsprechend unterzeichnetes Release-Formular beigefügt. Der Erwerb von Nutzungsrechten über das fotografische Urheberrecht hinaus, z. B. für abgebildete Werke der bildenden oder angewandten Kunst sowie die Einholung von Veröffentlichungsgenehmigungen bei Sammlungen, Museen etc. obliegt dem Kunden. Der Kunde trägt die Verantwortung für die Betextung sowie die sich aus der konkreten Veröffentlichung ergebenden Sinnzusammenhänge.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Ab dem Zeitpunkt der ordnungsgemäßen Lieferung des Bildmaterials ist der Kunde für dessen sachgemäße Verwendung verantwortlich. \n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        HONORARE\n\n                        "), _c('ol', [_c('li', [_vm._v("\n                                Es gilt das vereinbarte Honorar. Ist kein Honorar vereinbart worden, bestimmt es sich nach der jeweils aktuellen Bildhonorarübersicht der Mittelstandsgemeinschaft Foto-Marketing (MFM). Das Honorar versteht sich zuzüglich der jeweils gültigen Mehrwertsteuer.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Mit dem vereinbarten Honorar wird die einmalige Nutzung des Bildmaterials zu dem vereinbarten Zweck gemäß Ziff. IV. 3 abgegolten. \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                Durch den Auftrag anfallende Kosten und Auslagen (z.B. Material- und Laborkosten, Modellhonorare, Kosten für erforderliche Requisiten, Reisekosten, erforderliche Spesen etc.) sind nicht im Honorar enthalten und gehen zu Lasten des Kunden.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Der Honoraranspruch ist bei Ablieferung der Aufnahme fällig. Wird eine Produktion in Teilen abgeliefert, so ist das entsprechende Teilhonorar mit jeweiliger Lieferung fällig. Der Fotograf ist berechtigt, bei Produktionsaufträgen Abschlagszahlungen entsprechend dem jeweils erbrachten Leistungsumfang zu verlangen.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Das Honorar gemäß VI. 1. AGB ist auch dann in voller Höhe zu zahlen, wenn das in Auftrag gegebene und gelieferte Bildmaterial nicht veröffentlicht wird. Bei Verwendung der Aufnahmen als Arbeitsvorlage für Layout- und Präsentationszwecke fällt vorbehaltlich einer abweichenden Vereinbarung ein Honorar von mindestens Euro 75,00 pro Aufnahme an.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Eine Aufrechnung oder die Ausübung des Zurückbehaltungsrechts ist nur mit unbestrittenen oder rechtskräftig festgestellten Forderungen des Kunden zulässig. Zulässig ist außerdem die Aufrechnung mit bestrittenen aber entscheidungsreifen Gegenforderungen.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        RÜCKGABE DES BILDMATERIALS\n                        "), _c('ol', [_c('li', [_vm._v("\n                            Analoges Bildmaterial ist in der gelieferten Form unverzüglich nach der Veröffentlichung oder der vereinbarten Nutzung, spätestens jedoch drei Monate nach dem Lieferdatum, unaufgefordert zurückzusenden; beizufügen sind zwei Belegexemplare. Eine Verlängerung der 3-Monatsfrist bedarf der schriftlichen Genehmigung des Fotografen.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                Digitale Daten sind nach Abschluss der Nutzung grundsätzlich zu löschen bzw. sind die Datenträger zu vernichten. Der Fotograf haftet nicht für den Bestand und/oder die Möglichkeit einer erneuten Lieferung der Daten. \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Überlässt der Fotograf auf Anforderung des Kunden oder mit dessen Einverständnis Bildmaterial lediglich zum Zwecke der Prüfung, ob eine Nutzung oder Veröffentlichung in Betracht kommt, hat der Kunde analoges Bildmaterial spätestens innerhalb eines Monats nach Erhalt zurückzugeben, sofern auf dem Lieferschein keine andere Frist vermerkt ist. Digitale Daten sind zu löschen bzw. sind die Datenträger zu vernichten oder zurückzugeben. Eine Verlängerung dieser Frist ist nur wirksam, wenn sie vom Fotografen schriftlich bestätigt worden ist.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Die Rücksendung des Bildmaterials erfolgt durch den Kunden auf dessen Kosten in branchenüblicher Verpackung. Der Kunde trägt das Risiko des Verlusts oder der Beschädigung während des Transports bis zum Eingang beim Fotografen.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        VERTRAGSSTRAFE, SCHADENSERSATZ\n                        "), _c('ol', [_c('li', [_vm._v("\n                                Bei jeglicher unberechtigten (ohne Zustimmung des Fotografen erfolgten) Nutzung, Verwendung, Wiedergabe oder Weitergabe des Bildmaterials ist für jeden Einzelfall eine Vertragsstrafe in Höhe des fünffachen Nutzungshonorars zu zahlen, vorbehaltlich weitergehender Schadensersatzansprüche.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Bei unterlassenem, unvollständigem, falsch platziertem oder nicht zuordnungsfähigem Urhebervermerk ist ein Aufschlag in Höhe von 100 % auf das vereinbarte bzw. übliche Nutzungshonorar zu zahlen.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        ALLGEMEINES\n                        "), _c('ol', [_c('li', [_vm._v("\n                                Es gilt das Recht der Bundesrepublik Deutschland als vereinbart, und zwar auch bei Lieferungen ins Ausland. \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                Nebenabreden zum Vertrag oder zu diesen AGB bedürfen zu ihrer Wirksamkeit der Schriftform.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Die etwaige Nichtigkeit bzw. Unwirksamkeit einer oder mehrerer Bestimmungen dieser AGB berührt nicht die Wirksamkeit der übrigen Bestimmungen. Die Parteien verpflichten sich, die ungültige Bestimmung durch eine sinnentsprechende wirksame Bestimmung zu ersetzen, die der angestrebten Regelung wirtschaftlich und juristisch am nächsten kommt.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Erfüllungsort und Gerichtsstand ist, wenn der Kunde Vollkaufmann ist, der Wohnsitz des Fotografen.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("APPLICATION\n                    "), _c('ol', [_c('li', [_vm._v("\n                        The following Standard Terms and Conditions of Delivery\n                        and Business (hereinafter referred to as the Standard\n                        Terms and Conditions) shall apply to all of orders,\n                        offers, deliveries and services executed by the\n                        photographer.\n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                        They shall be deemed to be binding on both parties upon acceptance of the photographer’s delivery, service or offer by the customer, however no later than upon the photographic material being accepted for publication.\n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                            If the customer does not accept these Standard Terms and Conditions, it shall lodge written notification to this effect within three work days. Any alternative Standard Terms and Conditions on the part of the customer are hereby rejected. Alternative Standard Terms and Conditions on the part of the customer shall be deemed to be void unless the photographer agrees in writing to be bound by them.\n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                            In the absence of any express reference to the contrary, these Standard Terms and Conditions shall also apply to all of the photographer’s future orders, offers, deliveries and services under the ongoing business relationship notwithstanding the absence of any express reference to them.\n                        ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                    COMMISSION PRODUCTS\n                        "), _c('ol', [_c('li', [_vm._v("\n                            Any cost estimates provided by the photographer shall be given without engagement. If any increase in costs occurs during production, the photographer shall only report such increase when it becomes evident that the original estimate of the total costs is likely to be exceeded by more than 15 %. If the planned production period is exceeded for reasons beyond the photographer’s control, additional remuneration shall be paid on the basis of the agreed time-based fee or in the form of a reasonable increase in the flat-rate fee agreed upon.  \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The photographer may commission third party services which are required for the execution of the production on behalf and for the account of the customer and with the customer’s authorization.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Subject to any other provisions, the photographer shall be responsible for selecting the photographs to be presented to the customer for approval at the conclusion of production.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The photographs shall be deemed to have been duly accepted in accordance with the terms of the contract and be free of any faults unless notification to the contrary is served upon the photographer within two weeks of submission of the photographs.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n\n                    PROVISION OF PHOTOGRAPHIC MATERIAL (ANALOG AND DIGITAL)\n                    "), _c('ol', [_c('li', [_vm._v("\n                            These Standard Terms and Conditions shall apply to all photographic material submitted to the customer regardless of its degree of completion or technical form. They shall expressly also apply to photographic material transmitted electronically or digitally.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The customer acknowledges that the photographic material provided by the photographer constitutes copyright material as defined in Section 2 (1) No. 5 of the German Copyright Act.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Any suggestions submitted by the customer concerning modifications or adjustments shall be deemed to constitute individual services which shall be subject to separate remuneration.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The photographic material provided shall remain the photographer’s property notwithstanding the fact that consideration may have been received for it.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The customer shall treat the photographic material carefully and may only make it available to third parties for internal business purposes, i. e. for viewing, selection purposes and technical editing.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Any complaints concerning the content of the delivery or the content, quality or state of the photographic material shall be lodged within 48 hours of receipt. Failing this, the photographic material shall be deemed to have been received in proper condition, in conformance with the contract and as described.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                    UTILIZATION RIGHTS\n                        "), _c('ol', [_c('li', [_vm._v("\n                            The customer shall fundamentally only receive simple rights for one-time utilization. Subject to any other agreements, the right of publication on the Internet or inclusion in digital databases shall be limited to the duration of the publication period of the corresponding or a comparable printed item.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Exclusive utilization rights, exclusive rights for certain geographic territories or periods of time shall be subject to separate agreement as well as a surcharge of at least 100 % on top of the basic fee in question.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Upon the photographic material being delivered, only the utilization rights shall be granted for one-time use of the photographic material for the purpose specified by the customer and in the publication, medium or data vehicle which has been stated by the customer or can be reasonably assumed in the light of the circumstances surrounding the placing of the order. In the case of any doubt, the purpose for which the photographic material has been supplied as evidenced by the delivery note or the recipient address shall be decisive.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Any use, exploitation, dissemination, copying or publication going beyond the scope provided for in Section 3 above shall be subject to separate remuneration and require the photographer’s prior written approval. This shall particularly apply to:\n                                "), _c('ul', [_c('li', [_vm._v("\n                                    secondary exploitation or publication including but not limited to anthologies, product-related brochures, advertising or, in the case of any other types of reprinting, any editing of or modifications or changes to the photographic material,\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                                    digitalization, storage or duplication of the photographic material on data media of any type (e. g. magnetic, optic, magneto-optic or electronic media such as CD-ROM, DVD, hard disks, RAM, microfilms etc.) other than for the technical editing and management of the photographic material pursuant to III. 5. herein, \n                                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                                    any reproduction or utilization of the photographic data on digital data media, inclusion or display of the photographic data on the Internet or in on-line databases or other electronic archives (including the customer’s internal electronic archives),\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                                    the transmission of digitalized photographic material by data transmission lines or on data media for reproduction on screens or for the production of hardcopies.\n                                    ")])])]), _vm._v(" "), _c('li', [_vm._v("\n                            Any modifications to the photographic material using photo composing, mounting or electronic means to produce a new copyright work shall require the photographer’s prior written approval and shall be designated as such by [M]. In addition, the photographic material may not be copied in drawing form, recreated photographically or used in any other manner as a motive.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The customer may not transfer the rights of utilization or any part thereof granted to it to any third parties unless these are members of its group or subsidiaries. All use, reproduction and transfer of the photographic material shall be subject to the condition that the copyright information stipulated by the photographer be included in such a way that it can be clearly allocated to the picture in question.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The grant of the rights of utilization shall be subject to the condition precedent of full settlement of all of the photographer’s claims for payment under the applicable contractual relationship.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                The photographer still has the right to use his photographs for house advertising purposes even if he grants exclusive rights to the customer.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                    LIABILITY\n                        "), _c('ol', [_c('li', [_vm._v("\n                            The photographer shall not be held liable for the breach of any rights (trademarks, company names, design rights) shown in the photographs or held by persons or objects depicted in the photographic material unless a duly signed release is enclosed. The customer shall be responsible for acquiring the rights of utilization over and above the copyright to the photograph in question and for obtaining releases from collections, museums etc., e. g. for images showing works of applied or plastic arts. The customer shall be responsible for the legend as well as the context in which the photograph is used.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The customer shall assume responsibility for the due and proper utilization of the photographic material as of the date of delivery. \n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        FEES\n\n                        "), _c('ol', [_c('li', [_vm._v("\n                            The agreed fee shall apply. If no fee has been agreed upon, it shall be determined on the basis of the prevailing list of photographic fees issued by Mittelstandsgemeinschaft Foto-Marketing (MFM). The fee shall be subject to value added tax at the applicable rate.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The fee shall be deemed to constitute good consideration for the one-time utilization of the photographic material for the agreed purpose in accordance with Section IV. 3 herein. \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The fee shall not include any costs and expenses arising in connection with the order (e. g. cost of materials, laboratory, models, props, travel, other necessary expenses), which shall be borne by the customer.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The fee shall be payable upon delivery of the photographs. If the results of the production are supplied in parts, the corresponding part payment shall fall due upon receipt of the corresponding delivery. In the case of commission productions, the photographer may request advance payments matching the percentage of completion of the production.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                The fee provided for in Section VI. 1 herein shall be payable in full notwithstanding the fact that the photographic material ordered and supplied is not published. If the photographic material is to be used as a basis for layout and presentation purposes, a fee of at least Euro 75.00 shall be payable in the absence of any other agreement to the contrary.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Only counter-receivables which are not disputed or have been upheld in a court of law may be netted or shall be subject to a right of retention. Moreover, counter-receivables which are disputed but on which a decision is soon to be made may also be netted.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        RETURN OF PHOTOGRAPHIC MATERIAL\n                        "), _c('ol', [_c('li', [_vm._v("\n                            Analog photographic material shall be returned in the form in which it was supplied immediately after it has been published or utilized for the agreed purpose provided that this is no later than three months after the date of delivery; two sample copies of the publication in which the photographic material appears shall be enclosed. An extension to this three-month period shall require the photographer’s written approval.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Digital data shall be deleted and/or the data media destroyed upon completion of utilization. The photographer shall be under no duty to ensure the continued existence and/or possibility of renewed delivery of the data.  \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                If at the customer’s request or with its approval the photographer supplies photographic material solely for the purpose of determining whether it is suitable for use or publication, the customer shall return analog photographic material no later than one month of receipt in the absence of any other period stated on the consignment note. Digital data shall be deleted and/or the data media destroyed or returned. This period may only be extended with the photographer’s written consent.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The customer shall return the photographic material at its own cost in standard packaging. The customer shall bear the risk of loss or damage during transportation until the photographic material reaches the photographer.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        PENALTIES, DAMAGES\n                        "), _c('ol', [_c('li', [_vm._v("\n                            In the event of any unauthorized utilization, use, reproduction or disclosure of the photographic material (i.e. without the photographer’s consent), the customer shall be liable to pay a penalty equaling five times the applicable fee for each individual instance, it being understood that this shall not operate to restrict any other remedies available to the photographer.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                If the copyright notice is missing, incomplete, in the wrong position or not possible of being clearly allocated to the picture in question, a surcharge of 100 % of the agreed or customary fee shall be payable.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("\n                        GENERAL PROVISIONS \n                        "), _c('ol', [_c('li', [_vm._v("\n                                The contractual relationship anticipated by these Standard Terms and Conditions shall be subject to German law including in the case of deliveries to foreign destinations.  \n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            Any additions or modifications to these Standard Terms and Conditions shall be in writing only.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            If any of the provisions contained herein are void, this shall not prejudice the validity of the remaining provisions. In such a case, the Parties undertake to replace the void provision with a valid one coming as commercially and economically close as possible to what they intended with the void provision.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                            The place of fulfillment and the legal venue shall be the photographer’s domicile in cases in which the customer is a full merchant as defined by German commercial law.\n                            ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("\n          Fotografie Henning Maier-Jantzen"), _c('br'), _vm._v("\n          Elbingeroderweg 5"), _c('br'), _vm._v("\n          12059 Berlin"), _c('br'), _vm._v("\n          Germany"), _c('br'), _vm._v("\n          Tel.: +49 171 1963601"), _c('br'), _vm._v("\n          E-Mail: contact@maier-jantzen.de"), _c('br'), _vm._v("\n          Website: www.maier-jantzen.de"), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-left": "2em"
	    }
	  }, [_c('li', [_vm._v("\n              die Verarbeitungszwecke\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              die Kategorien personenbezogener Daten, die verarbeitet werden\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              die Empfänger oder Kategorien von Empfängern, gegenüber denen die\n              personenbezogenen Daten offengelegt worden sind oder noch\n              offengelegt werden, insbesondere bei Empfängern in Drittländern\n              oder bei internationalen Organisationen\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              falls möglich die geplante Dauer, für die die personenbezogenen\n              Daten gespeichert werden, oder, falls dies nicht möglich ist, die\n              Kriterien für die Festlegung dieser Dauer\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              das Bestehen eines Rechts auf Berichtigung oder Löschung der sie\n              betreffenden personenbezogenen Daten oder auf Einschränkung der\n              Verarbeitung durch den Verantwortlichen oder eines\n              Widerspruchsrechts gegen diese Verarbeitung\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              wenn die personenbezogenen Daten nicht bei der betroffenen Person\n              erhoben werden: Alle verfügbaren Informationen über die Herkunft\n              der Daten\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              das Bestehen einer automatisierten Entscheidungsfindung\n              einschließlich Profiling gemäß Artikel 22 Abs.1 und 4 DS-GVO und\n              — zumindest in diesen Fällen — aussagekräftige Informationen über\n              die involvierte Logik sowie die Tragweite und die angestrebten\n              Auswirkungen einer derartigen Verarbeitung für die betroffene\n              Person\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-left": "2em"
	    }
	  }, [_c('li', [_vm._v("\n              Die personenbezogenen Daten wurden für solche Zwecke erhoben oder auf sonstige Weise verarbeitet, für welche sie nicht mehr notwendig sind.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Die betroffene Person widerruft ihre Einwilligung, auf die sich die Verarbeitung gemäß Art. 6 Abs. 1 Buchstabe a DS-GVO oder Art. 9 Abs. 2 Buchstabe a DS-GVO stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Die betroffene Person legt gemäß Art. 21 Abs. 1 DS-GVO Widerspruch gegen die Verarbeitung ein, und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder die betroffene Person legt gemäß Art. 21 Abs. 2 DS-GVO Widerspruch gegen die Verarbeitung ein.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1 DS-GVO erhoben.\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-left": "2em"
	    }
	  }, [_c('li', [_vm._v("\n              Die Richtigkeit der personenbezogenen Daten wird von der betroffenen Person bestritten, und zwar für eine Dauer, die es dem Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Die Verarbeitung ist unrechtmäßig, die betroffene Person lehnt die Löschung der personenbezogenen Daten ab und verlangt stattdessen die Einschränkung der Nutzung der personenbezogenen Daten.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Der Verantwortliche benötigt die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger, die betroffene Person benötigt sie jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Die betroffene Person hat Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt und es steht noch nicht fest, ob die berechtigten Gründe des Verantwortlichen gegenüber denen der betroffenen Person überwiegen.\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n          Auf dieser Website nutzen wir MyFonts Counter, einen Webanalysedienst\n          der MyFonts Inc., 500 Unicorn Park Drive, Woburn, MA 01801, USA.\n          Aufgrund der Lizenzbestimmungen wird ein Page-View-Tracking\n          durchgeführt, indem die Anzahl der Besuche der Webseite zu\n          statistischen Zwecken gezählt und an MyFonts übermittelt werden.\n          MyFonts erhebt dabei lediglich anonymisierte Daten. Die Weitergabe\n          der Daten erfolgt gegebenenfalls durch die Aktivierung von\n          Java-Script-Code in Ihrem Browser. Weitere Informationen zu MyFonts\n          Counter finden Sie in den Datenschutzhinweisen von MyFonts unter "), _c('a', {
	    attrs: {
	      "href": "http://www.myfonts.com/info/terms-and-conditions/#Privacy"
	    }
	  }, [_vm._v("http://www.myfonts.com/info/terms-and-conditions/#Privacy")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n          Widerspruchsmöglichkeit"), _c('br'), _vm._v("\n          Um die Ausführung von Java-Script-Code von MyFonts insgesamt zu\n          verhindern, können Sie einen Java-Script-Blocker installieren (z.B. "), _c('a', {
	    attrs: {
	      "href": "http://www.noscript.net/"
	    }
	  }, [_vm._v("www.noscript.net")]), _vm._v(").\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "margin-top-large",
	    staticStyle: {
	      "font-style": "italic"
	    }
	  }, [_vm._v("\n          Diese Datenschutzerklärung wurde durch den Datenschutzerklärungs-Generator der\n          DGD Deutsche Gesellschaft für Datenschutz GmbH, die als "), _c('a', {
	    attrs: {
	      "href": "https://dg-datenschutz.de/datenschutz-dienstleistungen/externer-datenschutzbeauftragter/"
	    }
	  }, [_vm._v("Externer\n            Datenschutzbeauftragter Stuttgart")]), _vm._v(" tätig ist, in Kooperation mit dem \n          "), _c('a', {
	    attrs: {
	      "href": "https://www.wbs-law.de/"
	    }
	  }, [_vm._v("Kölner Datenschutz Anwalt Christian Solmecke erstellt")]), _vm._v(". \n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('strong', [_vm._v("\n            Fotografie Henning Maier-Jantzen"), _c('br'), _vm._v("\n            Elbingeroderweg 5"), _c('br'), _vm._v("\n            12059 Berlin"), _c('br'), _vm._v("\n            Germany"), _c('br'), _vm._v("\n            Phone: +49 171 1963601"), _c('br'), _vm._v("\n            Email: contact@maier-jantzen.de"), _c('br'), _vm._v("\n            Website: www.maier-jantzen.de"), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-right": "2em"
	    }
	  }, [_c('li', [_vm._v("\n    the purposes of the processing;\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    the categories of personal data concerned;\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    the recipients or categories of recipients to whom the personal data have been or will be disclosed, in particular recipients in third countries or international organisations;\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    where possible, the envisaged period for which the personal data will be stored, or, if not possible, the criteria used to determine that period;\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    the existence of the right to request from the controller rectification or erasure of personal data, or restriction of processing of personal data concerning the data subject, or to object to such processing;\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    the existence of the right to lodge a complaint with a supervisory authority;\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    where the personal data are not collected from the data subject, any available information as to their source;\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    the existence of automated decision-making, including profiling, referred to in Article 22(1) and (4) of the GDPR and, at least in those cases, meaningful information about the logic involved, as well as the significance and envisaged consequences of such processing for the data subject.\n  ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-left": "2em"
	    }
	  }, [_c('li', [_vm._v("\n    The personal data are no longer necessary in relation to the purposes for which they were collected or otherwise processed.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The data subject withdraws consent to which the processing is based according to point (a) of Article 6(1) of the GDPR, or point (a) of Article 9(2) of the GDPR, and where there is no other legal ground for the processing.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The data subject objects to the processing pursuant to Article 21(1) of the GDPR and there are no overriding legitimate grounds for the processing, or the data subject objects to the processing pursuant to Article 21(2) of the GDPR.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The personal data have been unlawfully processed.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The personal data must be erased for compliance with a legal obligation in Union or Member State law to which the controller is subject.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The personal data have been collected in relation to the offer of information society services referred to in Article 8(1) of the GDPR.\n  ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-left": "2em"
	    }
	  }, [_c('li', [_vm._v("\n    The Vccuracy of the personal data is contested by the data subject, for a period enabling the controller to verify the accuracy of the personal data.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The processing is unlawful and the data subject opposes the erasure of the personal data and requests instead the restriction of their use instead.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The controller no longer needs the personal data for the purposes of the processing, but they are required by the data subject for the establishment, exercise or defence of legal claims.\n  ")]), _vm._v(" "), _c('li', [_vm._v("\n    The data subject has objected to processing pursuant to Article 21(1) of the GDPR pending the verification whether the legitimate grounds of the controller override those of the data subject.\n  ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "margin-top-large"
	  }, [_c('i', [_vm._v("\n  This Privacy Policy has been generated by the Privacy Policy Generator of the\n  "), _c('a', {
	    attrs: {
	      "href": "https://dg-datenschutz.de/?lang=en",
	      "target": "_blank"
	    }
	  }, [_vm._v("German Association for Data Protection")]), _vm._v(" that was developed in cooperation with\n  "), _c('a', {
	    attrs: {
	      "href": "https://www.wbs-law.de/eng/practice-areas/internet-law/it-law/"
	    }
	  }, [_vm._v("Privacy Lawyers from WILDE BEUGER SOLMECKE")]), _vm._v(", Cologne. \n")])])
	}]}

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slide",
	    staticStyle: {
	      "position": "relative"
	    },
	    style: ({
	      width: _vm.image.view.width + _vm.slidePadding + 'px',
	      height: _vm.image.view.height + 'px',
	      marginRight: _vm.gutterRight + 'px',
	      marginTop: _vm.windowMargin + 'px'
	    }),
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('img', {
	    staticClass: "project-image",
	    staticStyle: {
	      "opacity": "0"
	    },
	    style: ({
	      width: _vm.image.view.width + 'px',
	      height: _vm.image.view.height + 'px',
	      marginTop: _vm.marginTop + 'px'
	    }),
	    attrs: {
	      "src": _vm.imagePath,
	      "data-src": _vm.src
	    }
	  }), _vm._v(" "), (_vm.layout.type == 'large') ? _c('a', {
	    staticClass: "download-trigger-container",
	    on: {
	      "click": _vm.download
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/icons/HMJ-Download.svg"
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "image-overlay",
	    style: ({
	      width: _vm.image.view.width + 'px',
	      height: _vm.image.view.height + 'px',
	      marginTop: _vm.marginTop + 'px'
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "image-overlay-content",
	    style: ({
	      width: _vm.image.view.width + 'px',
	      height: _vm.image.view.height + 'px',
	      marginTop: _vm.marginTop + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "overlay-content-cell"
	  }, [_c('h2', {
	    staticClass: "info-title",
	    class: {
	      centered: _vm.hideInfoText
	    }
	  }, [_vm._v(_vm._s(this.project.title[_vm.lang]))]), _vm._v(" "), _c('p', {
	    staticClass: "info-text",
	    class: {
	      hidden: _vm.hideInfoText
	    }
	  }, [_vm._v("\n        " + _vm._s(this.project.text[_vm.lang].description) + "\n        ")])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "projects-wrapper",
	    style: ({
	      height: _vm.windowHeight + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "project-frame",
	    style: ({
	      height: _vm.windowHeight + 'px',
	      width: _vm.windowWidth + 'px',
	      left: _vm.sidebarWidth + 'px',
	      top: _vm.windowMargin + 'px'
	    })
	  }, [(_vm.layout.type == 'small' || _vm.layout.type == 'medium') ? _c('div', {
	    directives: [{
	      name: "touch",
	      rawName: "v-touch:tap",
	      value: (_vm.handleDetectorClick),
	      expression: "handleDetectorClick",
	      arg: "tap"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swipeleft",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swipeleft"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swiperight",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swiperight"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swipeup",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swipeup"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swipedown",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swipedown"
	    }],
	    staticClass: "projects-swipe-area text-center",
	    style: ({
	      height: _vm.layout.galleryHeight + 'px',
	      width: _vm.windowWidth + 'px',
	      left: _vm.layout.offsetLeft + 'px',
	      top: _vm.layout.offsetTop + 'px'
	    }),
	    on: {
	      "click": _vm.handleDetectorClick,
	      "scroll": _vm.handleDetector,
	      "keyup": [function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        return _vm.preventArrowKeys($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        return _vm.preventArrowKeys($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
	        if ('button' in $event && $event.button !== 0) { return null; }
	        return _vm.preventArrowKeys($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
	        if ('button' in $event && $event.button !== 2) { return null; }
	        return _vm.preventArrowKeys($event)
	      }]
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.layout.type == 'large') ? _c('div', {
	    directives: [{
	      name: "touch",
	      rawName: "v-touch:swipeleft",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swipeleft"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swiperight",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swiperight"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swipeup",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swipeup"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swipedown",
	      value: (_vm.handleSwipe),
	      expression: "handleSwipe",
	      arg: "swipedown"
	    }],
	    staticClass: "projects-detector",
	    style: ({
	      height: _vm.layout.galleryHeight + 'px',
	      width: _vm.viewportWidth + 'px',
	      left: _vm.layout.offsetLeft + 'px'
	    }),
	    attrs: {
	      "id": "swipe-detector"
	    },
	    on: {
	      "mousemove": _vm.handleMouseMove,
	      "click": _vm.handleDetectorClick,
	      "scroll": _vm.handleDetector,
	      "keyup": [function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        return _vm.preventArrowKeys($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        return _vm.preventArrowKeys($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
	        if ('button' in $event && $event.button !== 0) { return null; }
	        return _vm.preventArrowKeys($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
	        if ('button' in $event && $event.button !== 2) { return null; }
	        return _vm.preventArrowKeys($event)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "detector-content",
	    style: ({
	      height: 4000 + 'px',
	      width: 4000 + 'px'
	    })
	  }, [_vm._v("\n                 \n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "component-projects",
	    style: ({
	      height: _vm.windowHeight + 'px'
	    })
	  }, [(_vm.projectsVisible) ? _c('div', {
	    staticClass: "projects-vertical-track"
	  }, _vm._l((_vm.filteredProjects), function(project, index) {
	    return _c('project-component', {
	      attrs: {
	        "project": project,
	        "index": index
	      },
	      on: {
	        "projectEnd": _vm.projectEnd
	      }
	    })
	  }), 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-index default-content-container",
	    class: {
	      landscape: _vm.isLandscape, 'portrait': _vm.isPortrait, mobile: _vm.isMobile
	    }
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Henning Maier-Jantzen "), _c('em', [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
	    staticClass: "index-container margin-top-container",
	    style: ({
	      marginRight: _vm.windowMargin + 'px'
	    })
	  }, _vm._l((_vm.filteredProjects), function(project, index) {
	    return (project.type != 'homepage') ? _c('div', {
	      key: project.id,
	      staticClass: "index-project",
	      attrs: {
	        "id": 'index-' + project.id
	      }
	    }, [_c('div', {
	      staticClass: "index-project-info"
	    }, [_c('span', {
	      staticClass: "index-project-title"
	    }, [_vm._v(_vm._s(project.title[_vm.lang]))]), _vm._v(" "), _c('span', {
	      staticClass: "index-project-category"
	    }, [_vm._v(_vm._s(_vm.getCategoryBySlug(project.category[0])))]), _vm._v(" "), _c('span', {
	      staticClass: "index-project-client"
	    }, [_vm._v(_vm._s(project.client))])]), _vm._v(" "), _c('div', {
	      staticClass: "index-project-track-wrapper"
	    }, [_c('div', {
	      staticClass: "track-nav track-nav-left",
	      on: {
	        "click": function($event) {
	          _vm.trackMoveLeft(project.id)
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": "/static/images/icons/HMJ-Cursor-Scroll-Left.svg",
	        "alt": "left arrow"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "track-nav track-nav-right",
	      on: {
	        "click": function($event) {
	          _vm.trackMoveRight(project.id)
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": "/static/images/icons/HMJ-Cursor-Scroll-Right.svg",
	        "alt": "left arrow"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "index-project-slide-track"
	    }, _vm._l((project.images), function(image, imageIndex) {
	      return _c('div', {
	        key: image.file,
	        staticClass: "index-project-slide"
	      }, [_c('router-link', {
	        attrs: {
	          "to": {
	            name: 'project-slide',
	            params: {
	              slug: project.id,
	              index: imageIndex
	            }
	          }
	        }
	      }, [_c('div', {
	        staticStyle: {
	          "background": "#E5E5E5"
	        },
	        style: ({
	          height: 133 + 'px',
	          width: 133 * (image.view.width / image.view.height) + 'px'
	        })
	      }, [_c('img', {
	        staticClass: "index-image",
	        style: ({
	          height: 133 + 'px',
	          width: 133 * (image.view.width / image.view.height) + 'px'
	        }),
	        attrs: {
	          "id": 'index-' + project.id + '--' + imageIndex,
	          "src": "/static/images/placeholder.gif",
	          "data-src": '/static/assets2/small/' + project.directory + '/' + image.file
	        }
	      })])]), _vm._v(" "), _c('div', {
	        staticClass: "download hide-for-small-only hide-for-medium-only",
	        on: {
	          "click": function($event) {
	            _vm.download(image)
	          }
	        }
	      }, [_vm._m(0, true)])], 1)
	    }), 0)])]) : _vm._e()
	  }), 0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', [_c('img', {
	    attrs: {
	      "src": "/static/images/icons/HMJ-Download.svg"
	    }
	  })])
	}]}

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "mainApp"
	    }
	  }, [(_vm.$route.params.slug == 'startseite') ? _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "position": "fixed",
	      "z-index": "1000001",
	      "cursor": "pointer",
	      "transform-origin": "center center"
	    },
	    style: ({
	      left: _vm.windowMargin * 1 + 'px',
	      bottom: '50px',
	      width: _vm.windowWidth - _vm.windowMargin * 2 + 'px'
	    }),
	    attrs: {
	      "id": "featureBlock"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.downloadTermsVisible) ? _c('div', {
	    style: ({
	      width: _vm.windowWidth + 'px',
	      height: _vm.windowHeight + 'px'
	    }),
	    attrs: {
	      "id": "downloadTermsWrapper"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.language == 'de') ? _c('div', {
	    staticClass: "columns large-8 small-12 large-offset-2 margin-top-large"
	  }, [_c('h2', [_vm._v("Hinweis zum Download")]), _vm._v(" "), _c('p', [_vm._v("\n            Gerne biete ich Ihnen die Bilder auf dieser Internetseite zum\n            Download an. Folgenden Bedingungen sind dabei zu beachten:\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Das zum Download bereit gestellt Bildmaterial ist urheberrechtlich\n            geschützt. Eine Nutzung ist nur mit ausdrücklicher Genehmigung\n            gestattet. Der Genehmigungsumfang ergibt sich in der Regel aus dem\n            Angebot.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Die Verwendung für Layout-Entwürfe ist bei Namensnennung\n            unmittelbar unter dem Bild unabhängig vom Vorliegen eines Angebotes\n            kostenfrei gestattet. Bei Unsicherheiten über den genehmigten\n            Nutzungsumfang zögern Sie nicht mit einer Nachfrage.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Bei jeder unberechtigten (ohne Zustimmung erfolgten) Nutzung,\n            Verwendung, Wiedergabe oder Weitergabe des Bild­materials ist für\n            jeden Einzelfall eine Vertragsstrafe in Höhe des fünffachen\n            Nutzungshonorars gemäß den Honoraren der Mittelstandsgemeinschaft\n            Foto-Marketing zu zahlen, vorbehaltlich weitergehender\n            Schadensersatzansprüche.  \n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-large text-center button-area"
	  }, [_c('a', {
	    on: {
	      "click": _vm.cancelDownloadTerms
	    }
	  }, [_c('h3', [_vm._v("Abbrechen")])]), _vm._v(" "), _c('a', {
	    on: {
	      "click": _vm.acceptDownloadTerms
	    }
	  }, [_c('h3', [_vm._v("Ich stimme zu")])])])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('div', {
	    staticClass: "columns large-8 small-12 large-offset-2 margin-top-large"
	  }, [_c('h2', [_vm._v("Legal note regarding downloads")]), _vm._v(" "), _c('p', [_vm._v("\n            I'm delighted that you are interested in making use of my images.\n            However, please note that a few conditions apply. \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            All images are subject to copyright, any download requires my\n            explicit approval.  The number of images that can be downloaded\n            depends on the offer made by each potential client.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Images may be used free of charge for draft layouts as long as my\n            name is clearly stated directly under each image. This may be done\n            regardless of any existing offer. Should you be unsure about the\n            number of images you are allowed to use, please don't hesitate to\n            get in touch.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Please note that any unauthorized use (i.e. without my explicit\n            consent), reproduction and sharing of my images will result in a\n            minimum fee amounting to five times the usage fee in accordance\n            with the fee recommendations of the Mittelstandsgemeinschaft\n            Foto-Marketing (MFM), subject to further claims for damages.  ")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-large text-center button-area"
	  }, [_c('a', {
	    on: {
	      "click": _vm.cancelDownloadTerms
	    }
	  }, [_c('h3', [_vm._v("Cancel")])]), _vm._v(" "), _c('a', {
	    on: {
	      "click": _vm.acceptDownloadTerms
	    }
	  }, [_c('h3', [_vm._v("I agree")])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "hide-for-small-only hide-for-medium-only",
	    style: ({
	      height: _vm.windowHeight + 'px'
	    }),
	    attrs: {
	      "id": "sidebar"
	    }
	  }, [_c('a', {
	    staticClass: "menu-toggle",
	    on: {
	      "click": function($event) {
	        _vm.toggleSidebar()
	      }
	    }
	  }, [_c('img', {
	    staticClass: "sidebar-icon",
	    attrs: {
	      "src": "/static/images/icons/HMJ-Menue.svg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "main-menu"
	  }, [_c('ul', [_c('li', [(_vm.language == 'en') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index'
	      }
	    }
	  }, [_vm._v("All Projects")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.language == 'de') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index'
	      }
	    }
	  }, [_vm._v("Alle Projekte")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
	    return _c('li', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'index-category',
	          params: {
	            category: cat.slug
	          }
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(cat.title[_vm.language]) + "\n                    ")])], 1)
	  }), _vm._v(" "), _c('li', {
	    staticClass: "margin-top-medium"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'about'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.about[_vm.language]))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.clients[_vm.language]))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'making-of'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.makingOf[_vm.language]))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'contact'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.contact[_vm.language]))])], 1), _vm._v(" "), (_vm.language == 'de') ? _c('li', {
	    staticClass: "margin-top-medium",
	    on: {
	      "click": function($event) {
	        _vm.setLanguage('en')
	      }
	    }
	  }, [_c('a', [_vm._v("En")])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('li', {
	    staticClass: "margin-top-medium",
	    on: {
	      "click": function($event) {
	        _vm.setLanguage('de')
	      }
	    }
	  }, [_c('a', [_vm._v("De")])]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleFullScreen
	    }
	  }, [(!_vm.fullscreen) ? _c('img', {
	    staticClass: "full-screen-trigger",
	    attrs: {
	      "src": "/static/images/icons/HMJ-Full-Screen-Open.svg"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.fullscreen) ? _c('img', {
	    staticClass: "full-screen-trigger",
	    attrs: {
	      "src": "/static/images/icons/HMJ-Full-Screen-Close.svg"
	    }
	  }) : _vm._e()])], 2)]), _vm._v(" "), (_vm.showNavArrows) ? _c('div', {
	    staticClass: "side-nav"
	  }, [_c('a', {
	    staticClass: "cursor-up sidebar-cursor",
	    on: {
	      "click": _vm.prevPage
	    }
	  }, [_c('img', {
	    staticClass: "sidebar-icon",
	    attrs: {
	      "src": "/static/images/icons/HMJ-Cursor-Up.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "cursor-down sidebar-cursor",
	    on: {
	      "click": _vm.nextPage
	    }
	  }, [_c('img', {
	    staticClass: "sidebar-icon",
	    attrs: {
	      "src": "/static/images/icons/HMJ-Cursor-Down.svg"
	    }
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.layout.orientation == 'landscape' && _vm.layout.type != 'large') ? _c('div', {
	    staticClass: "mobile-navigation",
	    style: ({
	      height: _vm.layout.viewportHeight + 'px'
	    }),
	    attrs: {
	      "id": "mobile-navigation-horizontal"
	    }
	  }, [_c('a', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('img', {
	    staticClass: "mobile-sandwich",
	    attrs: {
	      "src": "/static/images/icons/HMJ-Menue.svg"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'portrait' && _vm.layout.type != 'large') ? _c('div', {
	    staticClass: "mobile-navigation",
	    style: ({
	      width: _vm.layout.viewportWidth + 'px'
	    }),
	    attrs: {
	      "id": "mobile-navigation-vertical"
	    }
	  }, [_c('a', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('img', {
	    staticClass: "mobile-sandwich",
	    attrs: {
	      "src": "/static/images/icons/HMJ-Menue.svg"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.layout.mobileNavigation) ? _c('div', {
	    style: ({
	      width: _vm.layout.viewportWidth + 'px',
	      height: _vm.layout.viewportHeight + 'px',
	      top: _vm.mobileMenuTop + 'px',
	      left: _vm.layout.offsetLeft + 'px'
	    }),
	    attrs: {
	      "id": "mobile-navigation-menu"
	    }
	  }, [(_vm.layout.orientation == 'portrait') ? _c('div', {
	    staticClass: "mobile-navigation-content portrait",
	    class: {
	      verySmall: _vm.isVerySmall
	    }
	  }, [_c('ul', [_c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [(_vm.language == 'en') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index'
	      }
	    }
	  }, [_vm._v("All Projects")]) : _vm._e()], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [(_vm.language == 'de') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index'
	      }
	    }
	  }, [_vm._v("Alle Projekte")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
	    return _c('li', {
	      on: {
	        "click": _vm.toggleMobileNav
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'index-category',
	          params: {
	            category: cat.slug
	          }
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(cat.title[_vm.language]) + "\n                ")])], 1)
	  }), _vm._v(" "), _c('li', {
	    staticClass: "margin-top-medium",
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'about'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.about[_vm.language]))])], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.clients[_vm.language]))])], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'making-of'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.makingOf[_vm.language]))])], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'contact'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.contact[_vm.language]))])], 1), _vm._v(" "), (_vm.language == 'de') ? _c('li', {
	    staticClass: "margin-top-medium",
	    on: {
	      "click": function($event) {
	        _vm.setLanguage('en')
	      }
	    }
	  }, [_c('a', [_vm._v("En")])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('li', {
	    staticClass: "margin-top-medium",
	    on: {
	      "click": function($event) {
	        _vm.setLanguage('de')
	      }
	    }
	  }, [_c('a', [_vm._v("De")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.layout.orientation == 'landscape') ? _c('div', {
	    staticClass: "row mobile-navigation-content landscape"
	  }, [_c('div', {
	    staticClass: "columns small-4 small-offset-2 margin-top-large medium-4 medium-offset-2"
	  }, [_c('ul', [_c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [(_vm.language == 'en') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index'
	      }
	    }
	  }, [_vm._v("All Projects")]) : _vm._e()], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [(_vm.language == 'de') ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index'
	      }
	    }
	  }, [_vm._v("Alle Projekte")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
	    return _c('li', {
	      on: {
	        "click": _vm.toggleMobileNav
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'index-category',
	          params: {
	            category: cat.slug
	          }
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(cat.title[_vm.language]) + "\n                ")])], 1)
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "columns small-6 margin-top-large"
	  }, [_c('ul', [_c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.about[_vm.language]))])], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'clients'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.clients[_vm.language]))])], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'making-of'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.makingOf[_vm.language]))])], 1), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.toggleMobileNav
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'page',
	        params: {
	          pageslug: 'contact'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nav.contact[_vm.language]))])], 1), _vm._v(" "), (_vm.language == 'de') ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.setLanguage('en')
	      }
	    }
	  }, [_c('a', [_vm._v("En")])]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.setLanguage('de')
	      }
	    }
	  }, [_c('a', [_vm._v("De")])]) : _vm._e()])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.layout.mobileNavigation) ? _c('div', {
	    style: ({
	      marginLeft: _vm.layout.offsetLeft + 'px',
	      marginTop: _vm.layout.offsetTop + 'px'
	    }),
	    attrs: {
	      "id": "mainContent"
	    }
	  }, [_c('router-view')], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "touch",
	      rawName: "v-touch:swipeleft",
	      value: (_vm.test),
	      expression: "test",
	      arg: "swipeleft"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swiperight",
	      value: (_vm.test),
	      expression: "test",
	      arg: "swiperight"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swipeup",
	      value: (_vm.test),
	      expression: "test",
	      arg: "swipeup"
	    }, {
	      name: "touch",
	      rawName: "v-touch:swipedown",
	      value: (_vm.test),
	      expression: "test",
	      arg: "swipedown"
	    }, {
	      name: "touch",
	      rawName: "v-touch:tap",
	      value: (_vm.test),
	      expression: "test",
	      arg: "tap"
	    }, {
	      name: "touch",
	      rawName: "v-touch:press",
	      value: (_vm.test),
	      expression: "test",
	      arg: "press"
	    }, {
	      name: "touch",
	      rawName: "v-touch:pinchin",
	      value: (_vm.test),
	      expression: "test",
	      arg: "pinchin"
	    }, {
	      name: "touch",
	      rawName: "v-touch:pinchout",
	      value: (_vm.test),
	      expression: "test",
	      arg: "pinchout"
	    }],
	    staticClass: "text-center margin-top-large",
	    staticStyle: {
	      "min-height": "400px",
	      "background": "#E5E5E5"
	    }
	  }, [_c('h1', {
	    staticStyle: {
	      "padding-top": "3em"
	    }
	  }, [_vm._v(_vm._s(_vm.msg))])])
	},staticRenderFns: []}

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.34bf707c8a99b6d6deab.js